/**
 * Auto-generated field paths for logistics objects
 * 
 * Generated from TypeScript types using the TypeScript Compiler API.
 * 
 * To regenerate this file, run:
 *   npm run generate:field-paths
 * 
 * Maximum depth: 8
 * Generation date: 2026-03-11T16:21:29.464Z
 */

/**
 * Field paths for Activity
 * Total: 635 paths
 */
export const ACTIVITY_FIELD_PATHS = [
  'activity.activityName',
  'activity.processReference',
  'activity.sequenceNumber',
  'activity.isStartingService',
  'activity.isEndingService',
  'activity.activityType',
  'activity.activitySubtype',
  'activity.executionStatus',
  'activity.contacts',
  'activity.contacts.email',
  'activity.contacts.telephone',
  'activity.contacts.persons',
  'activity.contacts.persons.additionalName',
  'activity.contacts.persons.email',
  'activity.contacts.persons.familyName',
  'activity.contacts.persons.faxNumber',
  'activity.contacts.persons.givenName',
  'activity.contacts.persons.idCardNumber',
  'activity.contacts.persons.telephone',
  'activity.contacts.persons.party',
  'activity.contacts.persons.party.commercialName',
  'activity.contacts.persons.party.legalEntityName',
  'activity.contacts.persons.party.address',
  'activity.contacts.persons.party.address.addressLocality',
  'activity.contacts.persons.party.address.addressRegion',
  'activity.contacts.persons.party.address.postOfficeBoxNumber',
  'activity.contacts.persons.party.address.postalCode',
  'activity.contacts.persons.party.address.addressLines',
  'activity.contacts.persons.party.address.addressCountry',
  'activity.contacts.persons.party.address.addressCountry.countryCode',
  'activity.contacts.persons.party.address.addressCountry.countryName',
  'activity.contacts.persons.party.companyRegistrationIds',
  'activity.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'activity.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'activity.contacts.role',
  'activity.delegatedService',
  'activity.delegatedService.uri',
  'activity.documents',
  'activity.documents.cmsUri',
  'activity.documents.documentName',
  'activity.documents.format',
  'activity.documents.isRequired',
  'activity.documents.suppliedWithGoods',
  'activity.documents.documentType',
  'activity.documents.documentSubtype',
  'activity.estimatedCostOperations',
  'activity.estimatedCostOperations.isMandatory',
  'activity.estimatedCostOperations.isProposedByDefault',
  'activity.estimatedCostOperations.isSelected',
  'activity.estimatedCostOperations.operationDescription',
  'activity.estimatedCostOperations.operationName',
  'activity.estimatedCostOperations.operationCode',
  'activity.estimatedCostOperations.operationSubtype',
  'activity.estimatedCostOperations.operationType',
  'activity.estimatedCostOperations.amountExclTaxes',
  'activity.estimatedCostOperations.amountExclTaxes.unit',
  'activity.estimatedCostOperations.amountExclTaxes.value',
  'activity.estimatedCostOperations.amountInclTaxes',
  'activity.estimatedCostOperations.amountInclTaxes.unit',
  'activity.estimatedCostOperations.amountInclTaxes.value',
  'activity.estimatedCostOperations.requestedPrepaidAmount',
  'activity.estimatedCostOperations.requestedPrepaidAmount.unit',
  'activity.estimatedCostOperations.requestedPrepaidAmount.value',
  'activity.estimatedCostOperations.actualQuantity',
  'activity.estimatedCostOperations.actualQuantity.unit',
  'activity.estimatedCostOperations.actualQuantity.value',
  'activity.estimatedCostOperations.contacts',
  'activity.estimatedCostOperations.contacts.email',
  'activity.estimatedCostOperations.contacts.telephone',
  'activity.estimatedCostOperations.contacts.persons',
  'activity.estimatedCostOperations.contacts.persons.additionalName',
  'activity.estimatedCostOperations.contacts.persons.email',
  'activity.estimatedCostOperations.contacts.persons.familyName',
  'activity.estimatedCostOperations.contacts.persons.faxNumber',
  'activity.estimatedCostOperations.contacts.persons.givenName',
  'activity.estimatedCostOperations.contacts.persons.idCardNumber',
  'activity.estimatedCostOperations.contacts.persons.telephone',
  'activity.estimatedCostOperations.contacts.persons.party',
  'activity.estimatedCostOperations.contacts.persons.party.commercialName',
  'activity.estimatedCostOperations.contacts.persons.party.legalEntityName',
  'activity.estimatedCostOperations.contacts.persons.party.address',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressLocality',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressRegion',
  'activity.estimatedCostOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'activity.estimatedCostOperations.contacts.persons.party.address.postalCode',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressLines',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressCountry',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressCountry.countryCode',
  'activity.estimatedCostOperations.contacts.persons.party.address.addressCountry.countryName',
  'activity.estimatedCostOperations.contacts.persons.party.companyRegistrationIds',
  'activity.estimatedCostOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'activity.estimatedCostOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'activity.estimatedCostOperations.contacts.role',
  'activity.estimatedCostOperations.documents',
  'activity.estimatedCostOperations.documents.cmsUri',
  'activity.estimatedCostOperations.documents.documentName',
  'activity.estimatedCostOperations.documents.format',
  'activity.estimatedCostOperations.documents.isRequired',
  'activity.estimatedCostOperations.documents.suppliedWithGoods',
  'activity.estimatedCostOperations.documents.documentType',
  'activity.estimatedCostOperations.documents.documentSubtype',
  'activity.estimatedCostOperations.externalReferences',
  'activity.estimatedCostOperations.externalReferences.description',
  'activity.estimatedCostOperations.externalReferences.externalReferenceType',
  'activity.estimatedCostOperations.externalReferences.reference',
  'activity.estimatedCostOperations.operationInvoicingDetails',
  'activity.estimatedCostOperations.operationInvoicingDetails.invoiceLineId',
  'activity.estimatedCostOperations.operationInvoicingDetails.invoice',
  'activity.estimatedCostOperations.operationInvoicingDetails.invoice.uri',
  'activity.estimatedCostOperations.operationInvoicingDetails.quantity',
  'activity.estimatedCostOperations.operationInvoicingDetails.quantity.unit',
  'activity.estimatedCostOperations.operationInvoicingDetails.quantity.value',
  'activity.estimatedCostOperations.operationInvoicingDetails.totalPrice',
  'activity.estimatedCostOperations.operationInvoicingDetails.totalPrice.unit',
  'activity.estimatedCostOperations.operationInvoicingDetails.totalPrice.value',
  'activity.estimatedCostOperations.operationInvoicingDetails.unitPrice',
  'activity.estimatedCostOperations.operationInvoicingDetails.unitPrice.unit',
  'activity.estimatedCostOperations.operationInvoicingDetails.unitPrice.value',
  'activity.estimatedCostOperations.plannedQuantity',
  'activity.estimatedCostOperations.plannedQuantity.unit',
  'activity.estimatedCostOperations.plannedQuantity.value',
  'activity.estimatedCostOperations.requestedQuantity',
  'activity.estimatedCostOperations.requestedQuantity.unit',
  'activity.estimatedCostOperations.requestedQuantity.value',
  'activity.estimatedCostOperations.unitPrice',
  'activity.estimatedCostOperations.unitPrice.unit',
  'activity.estimatedCostOperations.unitPrice.value',
  'activity.estimatedCostOperations.specialCharacteristics',
  'activity.estimatedCostOperations.specialCharacteristics.stringValue',
  'activity.estimatedCostOperations.specialCharacteristics.characteristicReference',
  'activity.estimatedCostOperations.specialCharacteristics.specialCharacteristicType',
  'activity.estimatedCostOperations.specialCharacteristics.numericalValue',
  'activity.estimatedCostOperations.specialCharacteristics.numericalValue.unit',
  'activity.estimatedCostOperations.specialCharacteristics.numericalValue.value',
  'activity.estimatedCostOperations.specialInstructions',
  'activity.estimatedCostOperations.specialInstructions.description',
  'activity.estimatedCostOperations.specialInstructions.instructionCode',
  'activity.externalReferences',
  'activity.externalReferences.description',
  'activity.externalReferences.externalReferenceType',
  'activity.externalReferences.reference',
  'activity.relatedObject',
  'activity.quotations',
  'activity.quotations.uri',
  'activity.serviceRequests',
  'activity.serviceRequests.uri',
  'activity.specialCharacteristics',
  'activity.specialCharacteristics.stringValue',
  'activity.specialCharacteristics.characteristicReference',
  'activity.specialCharacteristics.specialCharacteristicType',
  'activity.specialCharacteristics.numericalValue',
  'activity.specialCharacteristics.numericalValue.unit',
  'activity.specialCharacteristics.numericalValue.value',
  'activity.specialInstructions',
  'activity.specialInstructions.description',
  'activity.specialInstructions.instructionCode',
  'activity.startLocation',
  'activity.startLocation.isAppointmentRequested',
  'activity.startLocation.actions',
  'activity.startLocation.actions.actionDateTime',
  'activity.startLocation.actions.actionName',
  'activity.startLocation.actions.sequenceNumber',
  'activity.startLocation.actions.actionState',
  'activity.startLocation.actions.actionType',
  'activity.startLocation.actions.actionSubtype',
  'activity.startLocation.actions.compositionMovements',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'activity.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'activity.startLocation.actions.compositionMovements.containedObjects',
  'activity.startLocation.actions.compositionMovements.container',
  'activity.startLocation.actions.compositionMovements.container.uri',
  'activity.startLocation.actions.sealNumber',
  'activity.startLocation.actions.sealedMaterialMean',
  'activity.startLocation.actions.sealedMaterialMean.uri',
  'activity.startLocation.actions.labelAssociations',
  'activity.startLocation.actions.labelAssociations.labelId',
  'activity.startLocation.actions.labelAssociations.labeledObject',
  'activity.startLocation.location',
  'activity.startLocation.location.locationName',
  'activity.startLocation.location.locationType',
  'activity.startLocation.location.code',
  'activity.startLocation.location.address',
  'activity.startLocation.location.address.addressLocality',
  'activity.startLocation.location.address.addressRegion',
  'activity.startLocation.location.address.postOfficeBoxNumber',
  'activity.startLocation.location.address.postalCode',
  'activity.startLocation.location.address.addressLines',
  'activity.startLocation.location.address.addressCountry',
  'activity.startLocation.location.address.addressCountry.countryCode',
  'activity.startLocation.location.address.addressCountry.countryName',
  'activity.startLocation.location.contacts',
  'activity.startLocation.location.contacts.email',
  'activity.startLocation.location.contacts.telephone',
  'activity.startLocation.location.contacts.persons',
  'activity.startLocation.location.contacts.persons.additionalName',
  'activity.startLocation.location.contacts.persons.email',
  'activity.startLocation.location.contacts.persons.familyName',
  'activity.startLocation.location.contacts.persons.faxNumber',
  'activity.startLocation.location.contacts.persons.givenName',
  'activity.startLocation.location.contacts.persons.idCardNumber',
  'activity.startLocation.location.contacts.persons.telephone',
  'activity.startLocation.location.contacts.persons.party',
  'activity.startLocation.location.contacts.persons.party.commercialName',
  'activity.startLocation.location.contacts.persons.party.legalEntityName',
  'activity.startLocation.location.contacts.persons.party.address',
  'activity.startLocation.location.contacts.persons.party.address.addressLocality',
  'activity.startLocation.location.contacts.persons.party.address.addressRegion',
  'activity.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'activity.startLocation.location.contacts.persons.party.address.postalCode',
  'activity.startLocation.location.contacts.persons.party.address.addressLines',
  'activity.startLocation.location.contacts.persons.party.address.addressCountry',
  'activity.startLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'activity.startLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'activity.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'activity.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'activity.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'activity.startLocation.location.contacts.role',
  'activity.startLocation.location.documents',
  'activity.startLocation.location.documents.cmsUri',
  'activity.startLocation.location.documents.documentName',
  'activity.startLocation.location.documents.format',
  'activity.startLocation.location.documents.isRequired',
  'activity.startLocation.location.documents.suppliedWithGoods',
  'activity.startLocation.location.documents.documentType',
  'activity.startLocation.location.documents.documentSubtype',
  'activity.startLocation.location.externalReferences',
  'activity.startLocation.location.externalReferences.description',
  'activity.startLocation.location.externalReferences.externalReferenceType',
  'activity.startLocation.location.externalReferences.reference',
  'activity.startLocation.location.geolocation',
  'activity.startLocation.location.geolocation.geolocationUnit',
  'activity.startLocation.location.geolocation.elevation',
  'activity.startLocation.location.geolocation.elevation.unit',
  'activity.startLocation.location.geolocation.elevation.value',
  'activity.startLocation.location.geolocation.latitude',
  'activity.startLocation.location.geolocation.latitude.unit',
  'activity.startLocation.location.geolocation.latitude.value',
  'activity.startLocation.location.geolocation.longitude',
  'activity.startLocation.location.geolocation.longitude.unit',
  'activity.startLocation.location.geolocation.longitude.value',
  'activity.startLocation.location.specialCharacteristics',
  'activity.startLocation.location.specialCharacteristics.stringValue',
  'activity.startLocation.location.specialCharacteristics.characteristicReference',
  'activity.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'activity.startLocation.location.specialCharacteristics.numericalValue',
  'activity.startLocation.location.specialCharacteristics.numericalValue.unit',
  'activity.startLocation.location.specialCharacteristics.numericalValue.value',
  'activity.startLocation.location.specialInstructions',
  'activity.startLocation.location.specialInstructions.description',
  'activity.startLocation.location.specialInstructions.instructionCode',
  'activity.startLocation.appointmentTimeRange',
  'activity.startLocation.appointmentTimeRange.earliestDateTime',
  'activity.startLocation.appointmentTimeRange.latestDateTime',
  'activity.startLocation.actualStartDateTime',
  'activity.startLocation.actualEndDateTime',
  'activity.startLocation.requestedStartTimeRange',
  'activity.startLocation.requestedStartTimeRange.earliestDateTime',
  'activity.startLocation.requestedStartTimeRange.latestDateTime',
  'activity.startLocation.requestedEndTimeRange',
  'activity.startLocation.requestedEndTimeRange.earliestDateTime',
  'activity.startLocation.requestedEndTimeRange.latestDateTime',
  'activity.startLocation.plannedStartTimeRange',
  'activity.startLocation.plannedStartTimeRange.earliestDateTime',
  'activity.startLocation.plannedStartTimeRange.latestDateTime',
  'activity.startLocation.plannedEndTimeRange',
  'activity.startLocation.plannedEndTimeRange.earliestDateTime',
  'activity.startLocation.plannedEndTimeRange.latestDateTime',
  'activity.endLocation',
  'activity.endLocation.isAppointmentRequested',
  'activity.endLocation.actions',
  'activity.endLocation.actions.actionDateTime',
  'activity.endLocation.actions.actionName',
  'activity.endLocation.actions.sequenceNumber',
  'activity.endLocation.actions.actionState',
  'activity.endLocation.actions.actionType',
  'activity.endLocation.actions.actionSubtype',
  'activity.endLocation.actions.compositionMovements',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'activity.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'activity.endLocation.actions.compositionMovements.containedObjects',
  'activity.endLocation.actions.compositionMovements.container',
  'activity.endLocation.actions.compositionMovements.container.uri',
  'activity.endLocation.actions.sealNumber',
  'activity.endLocation.actions.sealedMaterialMean',
  'activity.endLocation.actions.sealedMaterialMean.uri',
  'activity.endLocation.actions.labelAssociations',
  'activity.endLocation.actions.labelAssociations.labelId',
  'activity.endLocation.actions.labelAssociations.labeledObject',
  'activity.endLocation.location',
  'activity.endLocation.location.locationName',
  'activity.endLocation.location.locationType',
  'activity.endLocation.location.code',
  'activity.endLocation.location.address',
  'activity.endLocation.location.address.addressLocality',
  'activity.endLocation.location.address.addressRegion',
  'activity.endLocation.location.address.postOfficeBoxNumber',
  'activity.endLocation.location.address.postalCode',
  'activity.endLocation.location.address.addressLines',
  'activity.endLocation.location.address.addressCountry',
  'activity.endLocation.location.address.addressCountry.countryCode',
  'activity.endLocation.location.address.addressCountry.countryName',
  'activity.endLocation.location.contacts',
  'activity.endLocation.location.contacts.email',
  'activity.endLocation.location.contacts.telephone',
  'activity.endLocation.location.contacts.persons',
  'activity.endLocation.location.contacts.persons.additionalName',
  'activity.endLocation.location.contacts.persons.email',
  'activity.endLocation.location.contacts.persons.familyName',
  'activity.endLocation.location.contacts.persons.faxNumber',
  'activity.endLocation.location.contacts.persons.givenName',
  'activity.endLocation.location.contacts.persons.idCardNumber',
  'activity.endLocation.location.contacts.persons.telephone',
  'activity.endLocation.location.contacts.persons.party',
  'activity.endLocation.location.contacts.persons.party.commercialName',
  'activity.endLocation.location.contacts.persons.party.legalEntityName',
  'activity.endLocation.location.contacts.persons.party.address',
  'activity.endLocation.location.contacts.persons.party.address.addressLocality',
  'activity.endLocation.location.contacts.persons.party.address.addressRegion',
  'activity.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'activity.endLocation.location.contacts.persons.party.address.postalCode',
  'activity.endLocation.location.contacts.persons.party.address.addressLines',
  'activity.endLocation.location.contacts.persons.party.address.addressCountry',
  'activity.endLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'activity.endLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'activity.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'activity.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'activity.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'activity.endLocation.location.contacts.role',
  'activity.endLocation.location.documents',
  'activity.endLocation.location.documents.cmsUri',
  'activity.endLocation.location.documents.documentName',
  'activity.endLocation.location.documents.format',
  'activity.endLocation.location.documents.isRequired',
  'activity.endLocation.location.documents.suppliedWithGoods',
  'activity.endLocation.location.documents.documentType',
  'activity.endLocation.location.documents.documentSubtype',
  'activity.endLocation.location.externalReferences',
  'activity.endLocation.location.externalReferences.description',
  'activity.endLocation.location.externalReferences.externalReferenceType',
  'activity.endLocation.location.externalReferences.reference',
  'activity.endLocation.location.geolocation',
  'activity.endLocation.location.geolocation.geolocationUnit',
  'activity.endLocation.location.geolocation.elevation',
  'activity.endLocation.location.geolocation.elevation.unit',
  'activity.endLocation.location.geolocation.elevation.value',
  'activity.endLocation.location.geolocation.latitude',
  'activity.endLocation.location.geolocation.latitude.unit',
  'activity.endLocation.location.geolocation.latitude.value',
  'activity.endLocation.location.geolocation.longitude',
  'activity.endLocation.location.geolocation.longitude.unit',
  'activity.endLocation.location.geolocation.longitude.value',
  'activity.endLocation.location.specialCharacteristics',
  'activity.endLocation.location.specialCharacteristics.stringValue',
  'activity.endLocation.location.specialCharacteristics.characteristicReference',
  'activity.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'activity.endLocation.location.specialCharacteristics.numericalValue',
  'activity.endLocation.location.specialCharacteristics.numericalValue.unit',
  'activity.endLocation.location.specialCharacteristics.numericalValue.value',
  'activity.endLocation.location.specialInstructions',
  'activity.endLocation.location.specialInstructions.description',
  'activity.endLocation.location.specialInstructions.instructionCode',
  'activity.endLocation.appointmentTimeRange',
  'activity.endLocation.appointmentTimeRange.earliestDateTime',
  'activity.endLocation.appointmentTimeRange.latestDateTime',
  'activity.endLocation.actualStartDateTime',
  'activity.endLocation.actualEndDateTime',
  'activity.endLocation.requestedStartTimeRange',
  'activity.endLocation.requestedStartTimeRange.earliestDateTime',
  'activity.endLocation.requestedStartTimeRange.latestDateTime',
  'activity.endLocation.requestedEndTimeRange',
  'activity.endLocation.requestedEndTimeRange.earliestDateTime',
  'activity.endLocation.requestedEndTimeRange.latestDateTime',
  'activity.endLocation.plannedStartTimeRange',
  'activity.endLocation.plannedStartTimeRange.earliestDateTime',
  'activity.endLocation.plannedStartTimeRange.latestDateTime',
  'activity.endLocation.plannedEndTimeRange',
  'activity.endLocation.plannedEndTimeRange.earliestDateTime',
  'activity.endLocation.plannedEndTimeRange.latestDateTime',
  'activity.inTransitActions',
  'activity.inTransitActions.actionDateTime',
  'activity.inTransitActions.actionName',
  'activity.inTransitActions.sequenceNumber',
  'activity.inTransitActions.actionState',
  'activity.inTransitActions.actionType',
  'activity.inTransitActions.actionSubtype',
  'activity.inTransitActions.compositionMovements',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.containerType',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.product',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.product.uri',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.quantity',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.weight',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.weight.value',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'activity.inTransitActions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'activity.inTransitActions.compositionMovements.containedObjects',
  'activity.inTransitActions.compositionMovements.container',
  'activity.inTransitActions.compositionMovements.container.uri',
  'activity.inTransitActions.sealNumber',
  'activity.inTransitActions.sealedMaterialMean',
  'activity.inTransitActions.sealedMaterialMean.uri',
  'activity.inTransitActions.labelAssociations',
  'activity.inTransitActions.labelAssociations.labelId',
  'activity.inTransitActions.labelAssociations.labeledObject',
  'activity.humanMeans',
  'activity.humanMeans.uri',
  'activity.executionLocation',
  'activity.executionLocation.isAppointmentRequested',
  'activity.executionLocation.actions',
  'activity.executionLocation.actions.actionDateTime',
  'activity.executionLocation.actions.actionName',
  'activity.executionLocation.actions.sequenceNumber',
  'activity.executionLocation.actions.actionState',
  'activity.executionLocation.actions.actionType',
  'activity.executionLocation.actions.actionSubtype',
  'activity.executionLocation.actions.compositionMovements',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'activity.executionLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'activity.executionLocation.actions.compositionMovements.containedObjects',
  'activity.executionLocation.actions.compositionMovements.container',
  'activity.executionLocation.actions.compositionMovements.container.uri',
  'activity.executionLocation.actions.sealNumber',
  'activity.executionLocation.actions.sealedMaterialMean',
  'activity.executionLocation.actions.sealedMaterialMean.uri',
  'activity.executionLocation.actions.labelAssociations',
  'activity.executionLocation.actions.labelAssociations.labelId',
  'activity.executionLocation.actions.labelAssociations.labeledObject',
  'activity.executionLocation.location',
  'activity.executionLocation.location.locationName',
  'activity.executionLocation.location.locationType',
  'activity.executionLocation.location.code',
  'activity.executionLocation.location.address',
  'activity.executionLocation.location.address.addressLocality',
  'activity.executionLocation.location.address.addressRegion',
  'activity.executionLocation.location.address.postOfficeBoxNumber',
  'activity.executionLocation.location.address.postalCode',
  'activity.executionLocation.location.address.addressLines',
  'activity.executionLocation.location.address.addressCountry',
  'activity.executionLocation.location.address.addressCountry.countryCode',
  'activity.executionLocation.location.address.addressCountry.countryName',
  'activity.executionLocation.location.contacts',
  'activity.executionLocation.location.contacts.email',
  'activity.executionLocation.location.contacts.telephone',
  'activity.executionLocation.location.contacts.persons',
  'activity.executionLocation.location.contacts.persons.additionalName',
  'activity.executionLocation.location.contacts.persons.email',
  'activity.executionLocation.location.contacts.persons.familyName',
  'activity.executionLocation.location.contacts.persons.faxNumber',
  'activity.executionLocation.location.contacts.persons.givenName',
  'activity.executionLocation.location.contacts.persons.idCardNumber',
  'activity.executionLocation.location.contacts.persons.telephone',
  'activity.executionLocation.location.contacts.persons.party',
  'activity.executionLocation.location.contacts.persons.party.commercialName',
  'activity.executionLocation.location.contacts.persons.party.legalEntityName',
  'activity.executionLocation.location.contacts.persons.party.address',
  'activity.executionLocation.location.contacts.persons.party.address.addressLocality',
  'activity.executionLocation.location.contacts.persons.party.address.addressRegion',
  'activity.executionLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'activity.executionLocation.location.contacts.persons.party.address.postalCode',
  'activity.executionLocation.location.contacts.persons.party.address.addressLines',
  'activity.executionLocation.location.contacts.persons.party.address.addressCountry',
  'activity.executionLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'activity.executionLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'activity.executionLocation.location.contacts.persons.party.companyRegistrationIds',
  'activity.executionLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'activity.executionLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'activity.executionLocation.location.contacts.role',
  'activity.executionLocation.location.documents',
  'activity.executionLocation.location.documents.cmsUri',
  'activity.executionLocation.location.documents.documentName',
  'activity.executionLocation.location.documents.format',
  'activity.executionLocation.location.documents.isRequired',
  'activity.executionLocation.location.documents.suppliedWithGoods',
  'activity.executionLocation.location.documents.documentType',
  'activity.executionLocation.location.documents.documentSubtype',
  'activity.executionLocation.location.externalReferences',
  'activity.executionLocation.location.externalReferences.description',
  'activity.executionLocation.location.externalReferences.externalReferenceType',
  'activity.executionLocation.location.externalReferences.reference',
  'activity.executionLocation.location.geolocation',
  'activity.executionLocation.location.geolocation.geolocationUnit',
  'activity.executionLocation.location.geolocation.elevation',
  'activity.executionLocation.location.geolocation.elevation.unit',
  'activity.executionLocation.location.geolocation.elevation.value',
  'activity.executionLocation.location.geolocation.latitude',
  'activity.executionLocation.location.geolocation.latitude.unit',
  'activity.executionLocation.location.geolocation.latitude.value',
  'activity.executionLocation.location.geolocation.longitude',
  'activity.executionLocation.location.geolocation.longitude.unit',
  'activity.executionLocation.location.geolocation.longitude.value',
  'activity.executionLocation.location.specialCharacteristics',
  'activity.executionLocation.location.specialCharacteristics.stringValue',
  'activity.executionLocation.location.specialCharacteristics.characteristicReference',
  'activity.executionLocation.location.specialCharacteristics.specialCharacteristicType',
  'activity.executionLocation.location.specialCharacteristics.numericalValue',
  'activity.executionLocation.location.specialCharacteristics.numericalValue.unit',
  'activity.executionLocation.location.specialCharacteristics.numericalValue.value',
  'activity.executionLocation.location.specialInstructions',
  'activity.executionLocation.location.specialInstructions.description',
  'activity.executionLocation.location.specialInstructions.instructionCode',
  'activity.executionLocation.appointmentTimeRange',
  'activity.executionLocation.appointmentTimeRange.earliestDateTime',
  'activity.executionLocation.appointmentTimeRange.latestDateTime',
  'activity.executionLocation.actualStartDateTime',
  'activity.executionLocation.actualEndDateTime',
  'activity.executionLocation.requestedStartTimeRange',
  'activity.executionLocation.requestedStartTimeRange.earliestDateTime',
  'activity.executionLocation.requestedStartTimeRange.latestDateTime',
  'activity.executionLocation.requestedEndTimeRange',
  'activity.executionLocation.requestedEndTimeRange.earliestDateTime',
  'activity.executionLocation.requestedEndTimeRange.latestDateTime',
  'activity.executionLocation.plannedStartTimeRange',
  'activity.executionLocation.plannedStartTimeRange.earliestDateTime',
  'activity.executionLocation.plannedStartTimeRange.latestDateTime',
  'activity.executionLocation.plannedEndTimeRange',
  'activity.executionLocation.plannedEndTimeRange.earliestDateTime',
  'activity.executionLocation.plannedEndTimeRange.latestDateTime',
  'activity.id',
] as const;

/**
 * Field paths for Consignment
 * Total: 303 paths
 */
export const CONSIGNMENT_FIELD_PATHS = [
  'consignment.actualStartDateTime',
  'consignment.actualEndDateTime',
  'consignment.consignee',
  'consignment.consignee.commercialName',
  'consignment.consignee.legalEntityName',
  'consignment.consignee.address',
  'consignment.consignee.address.addressLocality',
  'consignment.consignee.address.addressRegion',
  'consignment.consignee.address.postOfficeBoxNumber',
  'consignment.consignee.address.postalCode',
  'consignment.consignee.address.addressLines',
  'consignment.consignee.address.addressCountry',
  'consignment.consignee.address.addressCountry.countryCode',
  'consignment.consignee.address.addressCountry.countryName',
  'consignment.consignee.companyRegistrationIds',
  'consignment.consignee.companyRegistrationIds.companyRegistrationIdType',
  'consignment.consignee.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.consignmentDetails',
  'consignment.consignmentDetails.customerOrderLineId',
  'consignment.consignmentDetails.customerOrder',
  'consignment.consignmentDetails.customerOrder.uri',
  'consignment.consignmentDetails.items',
  'consignment.consignmentDetails.items.uri',
  'consignment.consignmentDetails.pieces',
  'consignment.consignmentDetails.pieces.uri',
  'consignment.consignmentDetails.quantity',
  'consignment.consignmentDetails.quantity.unit',
  'consignment.consignmentDetails.quantity.value',
  'consignment.consignor',
  'consignment.consignor.commercialName',
  'consignment.consignor.legalEntityName',
  'consignment.consignor.address',
  'consignment.consignor.address.addressLocality',
  'consignment.consignor.address.addressRegion',
  'consignment.consignor.address.postOfficeBoxNumber',
  'consignment.consignor.address.postalCode',
  'consignment.consignor.address.addressLines',
  'consignment.consignor.address.addressCountry',
  'consignment.consignor.address.addressCountry.countryCode',
  'consignment.consignor.address.addressCountry.countryName',
  'consignment.consignor.companyRegistrationIds',
  'consignment.consignor.companyRegistrationIds.companyRegistrationIdType',
  'consignment.consignor.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.contacts',
  'consignment.contacts.email',
  'consignment.contacts.telephone',
  'consignment.contacts.persons',
  'consignment.contacts.persons.additionalName',
  'consignment.contacts.persons.email',
  'consignment.contacts.persons.familyName',
  'consignment.contacts.persons.faxNumber',
  'consignment.contacts.persons.givenName',
  'consignment.contacts.persons.idCardNumber',
  'consignment.contacts.persons.telephone',
  'consignment.contacts.persons.party',
  'consignment.contacts.persons.party.commercialName',
  'consignment.contacts.persons.party.legalEntityName',
  'consignment.contacts.persons.party.address',
  'consignment.contacts.persons.party.address.addressLocality',
  'consignment.contacts.persons.party.address.addressRegion',
  'consignment.contacts.persons.party.address.postOfficeBoxNumber',
  'consignment.contacts.persons.party.address.postalCode',
  'consignment.contacts.persons.party.address.addressLines',
  'consignment.contacts.persons.party.address.addressCountry',
  'consignment.contacts.persons.party.address.addressCountry.countryCode',
  'consignment.contacts.persons.party.address.addressCountry.countryName',
  'consignment.contacts.persons.party.companyRegistrationIds',
  'consignment.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'consignment.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.contacts.role',
  'consignment.dimensions',
  'consignment.dimensions.height',
  'consignment.dimensions.height.unit',
  'consignment.dimensions.height.value',
  'consignment.dimensions.length',
  'consignment.dimensions.length.unit',
  'consignment.dimensions.length.value',
  'consignment.dimensions.volume',
  'consignment.dimensions.volume.unit',
  'consignment.dimensions.volume.value',
  'consignment.dimensions.width',
  'consignment.dimensions.width.unit',
  'consignment.dimensions.width.value',
  'consignment.documents',
  'consignment.documents.cmsUri',
  'consignment.documents.documentName',
  'consignment.documents.format',
  'consignment.documents.isRequired',
  'consignment.documents.suppliedWithGoods',
  'consignment.documents.documentType',
  'consignment.documents.documentSubtype',
  'consignment.requestedStartTimeRange',
  'consignment.requestedStartTimeRange.earliestDateTime',
  'consignment.requestedStartTimeRange.latestDateTime',
  'consignment.requestedEndTimeRange',
  'consignment.requestedEndTimeRange.earliestDateTime',
  'consignment.requestedEndTimeRange.latestDateTime',
  'consignment.plannedStartTimeRange',
  'consignment.plannedStartTimeRange.earliestDateTime',
  'consignment.plannedStartTimeRange.latestDateTime',
  'consignment.plannedEndTimeRange',
  'consignment.plannedEndTimeRange.earliestDateTime',
  'consignment.plannedEndTimeRange.latestDateTime',
  'consignment.referencePlannedStartTimeRange',
  'consignment.referencePlannedStartTimeRange.earliestDateTime',
  'consignment.referencePlannedStartTimeRange.latestDateTime',
  'consignment.referencePlannedEndTimeRange',
  'consignment.referencePlannedEndTimeRange.earliestDateTime',
  'consignment.referencePlannedEndTimeRange.latestDateTime',
  'consignment.externalReferences',
  'consignment.externalReferences.description',
  'consignment.externalReferences.externalReferenceType',
  'consignment.externalReferences.reference',
  'consignment.finalLocation',
  'consignment.finalLocation.locationName',
  'consignment.finalLocation.locationType',
  'consignment.finalLocation.code',
  'consignment.finalLocation.address',
  'consignment.finalLocation.address.addressLocality',
  'consignment.finalLocation.address.addressRegion',
  'consignment.finalLocation.address.postOfficeBoxNumber',
  'consignment.finalLocation.address.postalCode',
  'consignment.finalLocation.address.addressLines',
  'consignment.finalLocation.address.addressCountry',
  'consignment.finalLocation.address.addressCountry.countryCode',
  'consignment.finalLocation.address.addressCountry.countryName',
  'consignment.finalLocation.contacts',
  'consignment.finalLocation.contacts.email',
  'consignment.finalLocation.contacts.telephone',
  'consignment.finalLocation.contacts.persons',
  'consignment.finalLocation.contacts.persons.additionalName',
  'consignment.finalLocation.contacts.persons.email',
  'consignment.finalLocation.contacts.persons.familyName',
  'consignment.finalLocation.contacts.persons.faxNumber',
  'consignment.finalLocation.contacts.persons.givenName',
  'consignment.finalLocation.contacts.persons.idCardNumber',
  'consignment.finalLocation.contacts.persons.telephone',
  'consignment.finalLocation.contacts.persons.party',
  'consignment.finalLocation.contacts.persons.party.commercialName',
  'consignment.finalLocation.contacts.persons.party.legalEntityName',
  'consignment.finalLocation.contacts.persons.party.address',
  'consignment.finalLocation.contacts.persons.party.address.addressLocality',
  'consignment.finalLocation.contacts.persons.party.address.addressRegion',
  'consignment.finalLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'consignment.finalLocation.contacts.persons.party.address.postalCode',
  'consignment.finalLocation.contacts.persons.party.address.addressLines',
  'consignment.finalLocation.contacts.persons.party.address.addressCountry',
  'consignment.finalLocation.contacts.persons.party.address.addressCountry.countryCode',
  'consignment.finalLocation.contacts.persons.party.address.addressCountry.countryName',
  'consignment.finalLocation.contacts.persons.party.companyRegistrationIds',
  'consignment.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'consignment.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.finalLocation.contacts.role',
  'consignment.finalLocation.documents',
  'consignment.finalLocation.documents.cmsUri',
  'consignment.finalLocation.documents.documentName',
  'consignment.finalLocation.documents.format',
  'consignment.finalLocation.documents.isRequired',
  'consignment.finalLocation.documents.suppliedWithGoods',
  'consignment.finalLocation.documents.documentType',
  'consignment.finalLocation.documents.documentSubtype',
  'consignment.finalLocation.externalReferences',
  'consignment.finalLocation.externalReferences.description',
  'consignment.finalLocation.externalReferences.externalReferenceType',
  'consignment.finalLocation.externalReferences.reference',
  'consignment.finalLocation.geolocation',
  'consignment.finalLocation.geolocation.geolocationUnit',
  'consignment.finalLocation.geolocation.elevation',
  'consignment.finalLocation.geolocation.elevation.unit',
  'consignment.finalLocation.geolocation.elevation.value',
  'consignment.finalLocation.geolocation.latitude',
  'consignment.finalLocation.geolocation.latitude.unit',
  'consignment.finalLocation.geolocation.latitude.value',
  'consignment.finalLocation.geolocation.longitude',
  'consignment.finalLocation.geolocation.longitude.unit',
  'consignment.finalLocation.geolocation.longitude.value',
  'consignment.finalLocation.specialCharacteristics',
  'consignment.finalLocation.specialCharacteristics.stringValue',
  'consignment.finalLocation.specialCharacteristics.characteristicReference',
  'consignment.finalLocation.specialCharacteristics.specialCharacteristicType',
  'consignment.finalLocation.specialCharacteristics.numericalValue',
  'consignment.finalLocation.specialCharacteristics.numericalValue.unit',
  'consignment.finalLocation.specialCharacteristics.numericalValue.value',
  'consignment.finalLocation.specialInstructions',
  'consignment.finalLocation.specialInstructions.description',
  'consignment.finalLocation.specialInstructions.instructionCode',
  'consignment.originLocation',
  'consignment.originLocation.locationName',
  'consignment.originLocation.locationType',
  'consignment.originLocation.code',
  'consignment.originLocation.address',
  'consignment.originLocation.address.addressLocality',
  'consignment.originLocation.address.addressRegion',
  'consignment.originLocation.address.postOfficeBoxNumber',
  'consignment.originLocation.address.postalCode',
  'consignment.originLocation.address.addressLines',
  'consignment.originLocation.address.addressCountry',
  'consignment.originLocation.address.addressCountry.countryCode',
  'consignment.originLocation.address.addressCountry.countryName',
  'consignment.originLocation.contacts',
  'consignment.originLocation.contacts.email',
  'consignment.originLocation.contacts.telephone',
  'consignment.originLocation.contacts.persons',
  'consignment.originLocation.contacts.persons.additionalName',
  'consignment.originLocation.contacts.persons.email',
  'consignment.originLocation.contacts.persons.familyName',
  'consignment.originLocation.contacts.persons.faxNumber',
  'consignment.originLocation.contacts.persons.givenName',
  'consignment.originLocation.contacts.persons.idCardNumber',
  'consignment.originLocation.contacts.persons.telephone',
  'consignment.originLocation.contacts.persons.party',
  'consignment.originLocation.contacts.persons.party.commercialName',
  'consignment.originLocation.contacts.persons.party.legalEntityName',
  'consignment.originLocation.contacts.persons.party.address',
  'consignment.originLocation.contacts.persons.party.address.addressLocality',
  'consignment.originLocation.contacts.persons.party.address.addressRegion',
  'consignment.originLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'consignment.originLocation.contacts.persons.party.address.postalCode',
  'consignment.originLocation.contacts.persons.party.address.addressLines',
  'consignment.originLocation.contacts.persons.party.address.addressCountry',
  'consignment.originLocation.contacts.persons.party.address.addressCountry.countryCode',
  'consignment.originLocation.contacts.persons.party.address.addressCountry.countryName',
  'consignment.originLocation.contacts.persons.party.companyRegistrationIds',
  'consignment.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'consignment.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.originLocation.contacts.role',
  'consignment.originLocation.documents',
  'consignment.originLocation.documents.cmsUri',
  'consignment.originLocation.documents.documentName',
  'consignment.originLocation.documents.format',
  'consignment.originLocation.documents.isRequired',
  'consignment.originLocation.documents.suppliedWithGoods',
  'consignment.originLocation.documents.documentType',
  'consignment.originLocation.documents.documentSubtype',
  'consignment.originLocation.externalReferences',
  'consignment.originLocation.externalReferences.description',
  'consignment.originLocation.externalReferences.externalReferenceType',
  'consignment.originLocation.externalReferences.reference',
  'consignment.originLocation.geolocation',
  'consignment.originLocation.geolocation.geolocationUnit',
  'consignment.originLocation.geolocation.elevation',
  'consignment.originLocation.geolocation.elevation.unit',
  'consignment.originLocation.geolocation.elevation.value',
  'consignment.originLocation.geolocation.latitude',
  'consignment.originLocation.geolocation.latitude.unit',
  'consignment.originLocation.geolocation.latitude.value',
  'consignment.originLocation.geolocation.longitude',
  'consignment.originLocation.geolocation.longitude.unit',
  'consignment.originLocation.geolocation.longitude.value',
  'consignment.originLocation.specialCharacteristics',
  'consignment.originLocation.specialCharacteristics.stringValue',
  'consignment.originLocation.specialCharacteristics.characteristicReference',
  'consignment.originLocation.specialCharacteristics.specialCharacteristicType',
  'consignment.originLocation.specialCharacteristics.numericalValue',
  'consignment.originLocation.specialCharacteristics.numericalValue.unit',
  'consignment.originLocation.specialCharacteristics.numericalValue.value',
  'consignment.originLocation.specialInstructions',
  'consignment.originLocation.specialInstructions.description',
  'consignment.originLocation.specialInstructions.instructionCode',
  'consignment.recipient',
  'consignment.recipient.additionalName',
  'consignment.recipient.email',
  'consignment.recipient.familyName',
  'consignment.recipient.faxNumber',
  'consignment.recipient.givenName',
  'consignment.recipient.idCardNumber',
  'consignment.recipient.telephone',
  'consignment.recipient.party',
  'consignment.recipient.party.commercialName',
  'consignment.recipient.party.legalEntityName',
  'consignment.recipient.party.address',
  'consignment.recipient.party.address.addressLocality',
  'consignment.recipient.party.address.addressRegion',
  'consignment.recipient.party.address.postOfficeBoxNumber',
  'consignment.recipient.party.address.postalCode',
  'consignment.recipient.party.address.addressLines',
  'consignment.recipient.party.address.addressCountry',
  'consignment.recipient.party.address.addressCountry.countryCode',
  'consignment.recipient.party.address.addressCountry.countryName',
  'consignment.recipient.party.companyRegistrationIds',
  'consignment.recipient.party.companyRegistrationIds.companyRegistrationIdType',
  'consignment.recipient.party.companyRegistrationIds.companyRegistrationIdValue',
  'consignment.serviceRequests',
  'consignment.serviceRequests.uri',
  'consignment.services',
  'consignment.services.uri',
  'consignment.specialCharacteristics',
  'consignment.specialCharacteristics.stringValue',
  'consignment.specialCharacteristics.characteristicReference',
  'consignment.specialCharacteristics.specialCharacteristicType',
  'consignment.specialCharacteristics.numericalValue',
  'consignment.specialCharacteristics.numericalValue.unit',
  'consignment.specialCharacteristics.numericalValue.value',
  'consignment.specialInstructions',
  'consignment.specialInstructions.description',
  'consignment.specialInstructions.instructionCode',
  'consignment.volume',
  'consignment.volume.unit',
  'consignment.volume.value',
  'consignment.weight',
  'consignment.weight.unit',
  'consignment.weight.value',
  'consignment.id',
] as const;

/**
 * Field paths for CustomerOrder
 * Total: 261 paths
 */
export const CUSTOMER_ORDER_FIELD_PATHS = [
  'customerOrder.creationDate',
  'customerOrder.buyer',
  'customerOrder.buyer.commercialName',
  'customerOrder.buyer.legalEntityName',
  'customerOrder.buyer.address',
  'customerOrder.buyer.address.addressLocality',
  'customerOrder.buyer.address.addressRegion',
  'customerOrder.buyer.address.postOfficeBoxNumber',
  'customerOrder.buyer.address.postalCode',
  'customerOrder.buyer.address.addressLines',
  'customerOrder.buyer.address.addressCountry',
  'customerOrder.buyer.address.addressCountry.countryCode',
  'customerOrder.buyer.address.addressCountry.countryName',
  'customerOrder.buyer.companyRegistrationIds',
  'customerOrder.buyer.companyRegistrationIds.companyRegistrationIdType',
  'customerOrder.buyer.companyRegistrationIds.companyRegistrationIdValue',
  'customerOrder.consignments',
  'customerOrder.consignments.uri',
  'customerOrder.contacts',
  'customerOrder.contacts.email',
  'customerOrder.contacts.telephone',
  'customerOrder.contacts.persons',
  'customerOrder.contacts.persons.additionalName',
  'customerOrder.contacts.persons.email',
  'customerOrder.contacts.persons.familyName',
  'customerOrder.contacts.persons.faxNumber',
  'customerOrder.contacts.persons.givenName',
  'customerOrder.contacts.persons.idCardNumber',
  'customerOrder.contacts.persons.telephone',
  'customerOrder.contacts.persons.party',
  'customerOrder.contacts.persons.party.commercialName',
  'customerOrder.contacts.persons.party.legalEntityName',
  'customerOrder.contacts.persons.party.address',
  'customerOrder.contacts.persons.party.address.addressLocality',
  'customerOrder.contacts.persons.party.address.addressRegion',
  'customerOrder.contacts.persons.party.address.postOfficeBoxNumber',
  'customerOrder.contacts.persons.party.address.postalCode',
  'customerOrder.contacts.persons.party.address.addressLines',
  'customerOrder.contacts.persons.party.address.addressCountry',
  'customerOrder.contacts.persons.party.address.addressCountry.countryCode',
  'customerOrder.contacts.persons.party.address.addressCountry.countryName',
  'customerOrder.contacts.persons.party.companyRegistrationIds',
  'customerOrder.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'customerOrder.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'customerOrder.contacts.role',
  'customerOrder.customerOrderLines',
  'customerOrder.customerOrderLines.actualStartDateTime',
  'customerOrder.customerOrderLines.actualEndDateTime',
  'customerOrder.customerOrderLines.codePackaging',
  'customerOrder.customerOrderLines.customerOrderLineId',
  'customerOrder.customerOrderLines.externalReferences',
  'customerOrder.customerOrderLines.externalReferences.description',
  'customerOrder.customerOrderLines.externalReferences.externalReferenceType',
  'customerOrder.customerOrderLines.externalReferences.reference',
  'customerOrder.customerOrderLines.finalLocation',
  'customerOrder.customerOrderLines.finalLocation.locationName',
  'customerOrder.customerOrderLines.finalLocation.locationType',
  'customerOrder.customerOrderLines.finalLocation.code',
  'customerOrder.customerOrderLines.finalLocation.address',
  'customerOrder.customerOrderLines.finalLocation.address.addressLocality',
  'customerOrder.customerOrderLines.finalLocation.address.addressRegion',
  'customerOrder.customerOrderLines.finalLocation.address.postOfficeBoxNumber',
  'customerOrder.customerOrderLines.finalLocation.address.postalCode',
  'customerOrder.customerOrderLines.finalLocation.address.addressLines',
  'customerOrder.customerOrderLines.finalLocation.address.addressCountry',
  'customerOrder.customerOrderLines.finalLocation.address.addressCountry.countryCode',
  'customerOrder.customerOrderLines.finalLocation.address.addressCountry.countryName',
  'customerOrder.customerOrderLines.finalLocation.contacts',
  'customerOrder.customerOrderLines.finalLocation.contacts.email',
  'customerOrder.customerOrderLines.finalLocation.contacts.telephone',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.additionalName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.email',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.familyName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.faxNumber',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.givenName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.idCardNumber',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.telephone',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.commercialName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.legalEntityName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressLocality',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressRegion',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.postalCode',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressLines',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressCountry',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressCountry.countryCode',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.address.addressCountry.countryName',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.companyRegistrationIds',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'customerOrder.customerOrderLines.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'customerOrder.customerOrderLines.finalLocation.contacts.role',
  'customerOrder.customerOrderLines.finalLocation.documents',
  'customerOrder.customerOrderLines.finalLocation.documents.cmsUri',
  'customerOrder.customerOrderLines.finalLocation.documents.documentName',
  'customerOrder.customerOrderLines.finalLocation.documents.format',
  'customerOrder.customerOrderLines.finalLocation.documents.isRequired',
  'customerOrder.customerOrderLines.finalLocation.documents.suppliedWithGoods',
  'customerOrder.customerOrderLines.finalLocation.documents.documentType',
  'customerOrder.customerOrderLines.finalLocation.documents.documentSubtype',
  'customerOrder.customerOrderLines.finalLocation.externalReferences',
  'customerOrder.customerOrderLines.finalLocation.externalReferences.description',
  'customerOrder.customerOrderLines.finalLocation.externalReferences.externalReferenceType',
  'customerOrder.customerOrderLines.finalLocation.externalReferences.reference',
  'customerOrder.customerOrderLines.finalLocation.geolocation',
  'customerOrder.customerOrderLines.finalLocation.geolocation.geolocationUnit',
  'customerOrder.customerOrderLines.finalLocation.geolocation.elevation',
  'customerOrder.customerOrderLines.finalLocation.geolocation.elevation.unit',
  'customerOrder.customerOrderLines.finalLocation.geolocation.elevation.value',
  'customerOrder.customerOrderLines.finalLocation.geolocation.latitude',
  'customerOrder.customerOrderLines.finalLocation.geolocation.latitude.unit',
  'customerOrder.customerOrderLines.finalLocation.geolocation.latitude.value',
  'customerOrder.customerOrderLines.finalLocation.geolocation.longitude',
  'customerOrder.customerOrderLines.finalLocation.geolocation.longitude.unit',
  'customerOrder.customerOrderLines.finalLocation.geolocation.longitude.value',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.stringValue',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.characteristicReference',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.specialCharacteristicType',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.numericalValue',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.numericalValue.unit',
  'customerOrder.customerOrderLines.finalLocation.specialCharacteristics.numericalValue.value',
  'customerOrder.customerOrderLines.finalLocation.specialInstructions',
  'customerOrder.customerOrderLines.finalLocation.specialInstructions.description',
  'customerOrder.customerOrderLines.finalLocation.specialInstructions.instructionCode',
  'customerOrder.customerOrderLines.originLocation',
  'customerOrder.customerOrderLines.originLocation.locationName',
  'customerOrder.customerOrderLines.originLocation.locationType',
  'customerOrder.customerOrderLines.originLocation.code',
  'customerOrder.customerOrderLines.originLocation.address',
  'customerOrder.customerOrderLines.originLocation.address.addressLocality',
  'customerOrder.customerOrderLines.originLocation.address.addressRegion',
  'customerOrder.customerOrderLines.originLocation.address.postOfficeBoxNumber',
  'customerOrder.customerOrderLines.originLocation.address.postalCode',
  'customerOrder.customerOrderLines.originLocation.address.addressLines',
  'customerOrder.customerOrderLines.originLocation.address.addressCountry',
  'customerOrder.customerOrderLines.originLocation.address.addressCountry.countryCode',
  'customerOrder.customerOrderLines.originLocation.address.addressCountry.countryName',
  'customerOrder.customerOrderLines.originLocation.contacts',
  'customerOrder.customerOrderLines.originLocation.contacts.email',
  'customerOrder.customerOrderLines.originLocation.contacts.telephone',
  'customerOrder.customerOrderLines.originLocation.contacts.persons',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.additionalName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.email',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.familyName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.faxNumber',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.givenName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.idCardNumber',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.telephone',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.commercialName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.legalEntityName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressLocality',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressRegion',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.postalCode',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressLines',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressCountry',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressCountry.countryCode',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.address.addressCountry.countryName',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.companyRegistrationIds',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'customerOrder.customerOrderLines.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'customerOrder.customerOrderLines.originLocation.contacts.role',
  'customerOrder.customerOrderLines.originLocation.documents',
  'customerOrder.customerOrderLines.originLocation.documents.cmsUri',
  'customerOrder.customerOrderLines.originLocation.documents.documentName',
  'customerOrder.customerOrderLines.originLocation.documents.format',
  'customerOrder.customerOrderLines.originLocation.documents.isRequired',
  'customerOrder.customerOrderLines.originLocation.documents.suppliedWithGoods',
  'customerOrder.customerOrderLines.originLocation.documents.documentType',
  'customerOrder.customerOrderLines.originLocation.documents.documentSubtype',
  'customerOrder.customerOrderLines.originLocation.externalReferences',
  'customerOrder.customerOrderLines.originLocation.externalReferences.description',
  'customerOrder.customerOrderLines.originLocation.externalReferences.externalReferenceType',
  'customerOrder.customerOrderLines.originLocation.externalReferences.reference',
  'customerOrder.customerOrderLines.originLocation.geolocation',
  'customerOrder.customerOrderLines.originLocation.geolocation.geolocationUnit',
  'customerOrder.customerOrderLines.originLocation.geolocation.elevation',
  'customerOrder.customerOrderLines.originLocation.geolocation.elevation.unit',
  'customerOrder.customerOrderLines.originLocation.geolocation.elevation.value',
  'customerOrder.customerOrderLines.originLocation.geolocation.latitude',
  'customerOrder.customerOrderLines.originLocation.geolocation.latitude.unit',
  'customerOrder.customerOrderLines.originLocation.geolocation.latitude.value',
  'customerOrder.customerOrderLines.originLocation.geolocation.longitude',
  'customerOrder.customerOrderLines.originLocation.geolocation.longitude.unit',
  'customerOrder.customerOrderLines.originLocation.geolocation.longitude.value',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.stringValue',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.characteristicReference',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.specialCharacteristicType',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.numericalValue',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.numericalValue.unit',
  'customerOrder.customerOrderLines.originLocation.specialCharacteristics.numericalValue.value',
  'customerOrder.customerOrderLines.originLocation.specialInstructions',
  'customerOrder.customerOrderLines.originLocation.specialInstructions.description',
  'customerOrder.customerOrderLines.originLocation.specialInstructions.instructionCode',
  'customerOrder.customerOrderLines.product',
  'customerOrder.customerOrderLines.product.uri',
  'customerOrder.customerOrderLines.quantity',
  'customerOrder.customerOrderLines.quantity.unit',
  'customerOrder.customerOrderLines.quantity.value',
  'customerOrder.customerOrderLines.requestedStartTimeRange',
  'customerOrder.customerOrderLines.requestedStartTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.requestedStartTimeRange.latestDateTime',
  'customerOrder.customerOrderLines.requestedEndTimeRange',
  'customerOrder.customerOrderLines.requestedEndTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.requestedEndTimeRange.latestDateTime',
  'customerOrder.customerOrderLines.plannedStartTimeRange',
  'customerOrder.customerOrderLines.plannedStartTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.plannedStartTimeRange.latestDateTime',
  'customerOrder.customerOrderLines.plannedEndTimeRange',
  'customerOrder.customerOrderLines.plannedEndTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.plannedEndTimeRange.latestDateTime',
  'customerOrder.customerOrderLines.referencePlannedStartTimeRange',
  'customerOrder.customerOrderLines.referencePlannedStartTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.referencePlannedStartTimeRange.latestDateTime',
  'customerOrder.customerOrderLines.referencePlannedEndTimeRange',
  'customerOrder.customerOrderLines.referencePlannedEndTimeRange.earliestDateTime',
  'customerOrder.customerOrderLines.referencePlannedEndTimeRange.latestDateTime',
  'customerOrder.documents',
  'customerOrder.documents.cmsUri',
  'customerOrder.documents.documentName',
  'customerOrder.documents.format',
  'customerOrder.documents.isRequired',
  'customerOrder.documents.suppliedWithGoods',
  'customerOrder.documents.documentType',
  'customerOrder.documents.documentSubtype',
  'customerOrder.externalReferences',
  'customerOrder.externalReferences.description',
  'customerOrder.externalReferences.externalReferenceType',
  'customerOrder.externalReferences.reference',
  'customerOrder.seller',
  'customerOrder.seller.commercialName',
  'customerOrder.seller.legalEntityName',
  'customerOrder.seller.address',
  'customerOrder.seller.address.addressLocality',
  'customerOrder.seller.address.addressRegion',
  'customerOrder.seller.address.postOfficeBoxNumber',
  'customerOrder.seller.address.postalCode',
  'customerOrder.seller.address.addressLines',
  'customerOrder.seller.address.addressCountry',
  'customerOrder.seller.address.addressCountry.countryCode',
  'customerOrder.seller.address.addressCountry.countryName',
  'customerOrder.seller.companyRegistrationIds',
  'customerOrder.seller.companyRegistrationIds.companyRegistrationIdType',
  'customerOrder.seller.companyRegistrationIds.companyRegistrationIdValue',
  'customerOrder.specialCharacteristics',
  'customerOrder.specialCharacteristics.stringValue',
  'customerOrder.specialCharacteristics.characteristicReference',
  'customerOrder.specialCharacteristics.specialCharacteristicType',
  'customerOrder.specialCharacteristics.numericalValue',
  'customerOrder.specialCharacteristics.numericalValue.unit',
  'customerOrder.specialCharacteristics.numericalValue.value',
  'customerOrder.specialInstructions',
  'customerOrder.specialInstructions.description',
  'customerOrder.specialInstructions.instructionCode',
  'customerOrder.id',
] as const;

/**
 * Field paths for HumanMean
 * Total: 48 paths
 */
export const HUMAN_MEAN_FIELD_PATHS = [
  'humanMean.allocationDate',
  'humanMean.contacts',
  'humanMean.contacts.email',
  'humanMean.contacts.telephone',
  'humanMean.contacts.persons',
  'humanMean.contacts.persons.additionalName',
  'humanMean.contacts.persons.email',
  'humanMean.contacts.persons.familyName',
  'humanMean.contacts.persons.faxNumber',
  'humanMean.contacts.persons.givenName',
  'humanMean.contacts.persons.idCardNumber',
  'humanMean.contacts.persons.telephone',
  'humanMean.contacts.persons.party',
  'humanMean.contacts.persons.party.commercialName',
  'humanMean.contacts.persons.party.legalEntityName',
  'humanMean.contacts.persons.party.address',
  'humanMean.contacts.persons.party.address.addressLocality',
  'humanMean.contacts.persons.party.address.addressRegion',
  'humanMean.contacts.persons.party.address.postOfficeBoxNumber',
  'humanMean.contacts.persons.party.address.postalCode',
  'humanMean.contacts.persons.party.address.addressLines',
  'humanMean.contacts.persons.party.address.addressCountry',
  'humanMean.contacts.persons.party.address.addressCountry.countryCode',
  'humanMean.contacts.persons.party.address.addressCountry.countryName',
  'humanMean.contacts.persons.party.companyRegistrationIds',
  'humanMean.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'humanMean.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'humanMean.contacts.role',
  'humanMean.externalReferences',
  'humanMean.externalReferences.description',
  'humanMean.externalReferences.externalReferenceType',
  'humanMean.externalReferences.reference',
  'humanMean.isLinkedToResources',
  'humanMean.pieces',
  'humanMean.pieces.uri',
  'humanMean.specialCharacteristics',
  'humanMean.specialCharacteristics.stringValue',
  'humanMean.specialCharacteristics.characteristicReference',
  'humanMean.specialCharacteristics.specialCharacteristicType',
  'humanMean.specialCharacteristics.numericalValue',
  'humanMean.specialCharacteristics.numericalValue.unit',
  'humanMean.specialCharacteristics.numericalValue.value',
  'humanMean.specialInstructions',
  'humanMean.specialInstructions.description',
  'humanMean.specialInstructions.instructionCode',
  'humanMean.description',
  'humanMean.role',
  'humanMean.id',
] as const;

/**
 * Field paths for InvoicingDocument
 * Total: 218 paths
 */
export const INVOICING_DOCUMENT_FIELD_PATHS = [
  'invoicingDocument.documentType',
  'invoicingDocument.dueDate',
  'invoicingDocument.footerTexts',
  'invoicingDocument.invoiceDate',
  'invoicingDocument.address',
  'invoicingDocument.address.addressLocality',
  'invoicingDocument.address.addressRegion',
  'invoicingDocument.address.postOfficeBoxNumber',
  'invoicingDocument.address.postalCode',
  'invoicingDocument.address.addressLines',
  'invoicingDocument.address.addressCountry',
  'invoicingDocument.address.addressCountry.countryCode',
  'invoicingDocument.address.addressCountry.countryName',
  'invoicingDocument.contacts',
  'invoicingDocument.contacts.email',
  'invoicingDocument.contacts.telephone',
  'invoicingDocument.contacts.persons',
  'invoicingDocument.contacts.persons.additionalName',
  'invoicingDocument.contacts.persons.email',
  'invoicingDocument.contacts.persons.familyName',
  'invoicingDocument.contacts.persons.faxNumber',
  'invoicingDocument.contacts.persons.givenName',
  'invoicingDocument.contacts.persons.idCardNumber',
  'invoicingDocument.contacts.persons.telephone',
  'invoicingDocument.contacts.persons.party',
  'invoicingDocument.contacts.persons.party.commercialName',
  'invoicingDocument.contacts.persons.party.legalEntityName',
  'invoicingDocument.contacts.persons.party.address',
  'invoicingDocument.contacts.persons.party.address.addressLocality',
  'invoicingDocument.contacts.persons.party.address.addressRegion',
  'invoicingDocument.contacts.persons.party.address.postOfficeBoxNumber',
  'invoicingDocument.contacts.persons.party.address.postalCode',
  'invoicingDocument.contacts.persons.party.address.addressLines',
  'invoicingDocument.contacts.persons.party.address.addressCountry',
  'invoicingDocument.contacts.persons.party.address.addressCountry.countryCode',
  'invoicingDocument.contacts.persons.party.address.addressCountry.countryName',
  'invoicingDocument.contacts.persons.party.companyRegistrationIds',
  'invoicingDocument.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'invoicingDocument.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'invoicingDocument.contacts.role',
  'invoicingDocument.documents',
  'invoicingDocument.documents.cmsUri',
  'invoicingDocument.documents.documentName',
  'invoicingDocument.documents.format',
  'invoicingDocument.documents.isRequired',
  'invoicingDocument.documents.suppliedWithGoods',
  'invoicingDocument.documents.documentType',
  'invoicingDocument.documents.documentSubtype',
  'invoicingDocument.externalReferences',
  'invoicingDocument.externalReferences.description',
  'invoicingDocument.externalReferences.externalReferenceType',
  'invoicingDocument.externalReferences.reference',
  'invoicingDocument.invoiceLines',
  'invoicingDocument.invoiceLines.invoiceLineId',
  'invoicingDocument.invoiceLines.taxType',
  'invoicingDocument.invoiceLines.amount',
  'invoicingDocument.invoiceLines.amount.unit',
  'invoicingDocument.invoiceLines.amount.value',
  'invoicingDocument.invoiceLines.operations',
  'invoicingDocument.invoiceLines.operations.isMandatory',
  'invoicingDocument.invoiceLines.operations.isProposedByDefault',
  'invoicingDocument.invoiceLines.operations.isSelected',
  'invoicingDocument.invoiceLines.operations.operationDescription',
  'invoicingDocument.invoiceLines.operations.operationName',
  'invoicingDocument.invoiceLines.operations.operationCode',
  'invoicingDocument.invoiceLines.operations.operationSubtype',
  'invoicingDocument.invoiceLines.operations.operationType',
  'invoicingDocument.invoiceLines.operations.amountExclTaxes',
  'invoicingDocument.invoiceLines.operations.amountExclTaxes.unit',
  'invoicingDocument.invoiceLines.operations.amountExclTaxes.value',
  'invoicingDocument.invoiceLines.operations.amountInclTaxes',
  'invoicingDocument.invoiceLines.operations.amountInclTaxes.unit',
  'invoicingDocument.invoiceLines.operations.amountInclTaxes.value',
  'invoicingDocument.invoiceLines.operations.requestedPrepaidAmount',
  'invoicingDocument.invoiceLines.operations.requestedPrepaidAmount.unit',
  'invoicingDocument.invoiceLines.operations.requestedPrepaidAmount.value',
  'invoicingDocument.invoiceLines.operations.actualQuantity',
  'invoicingDocument.invoiceLines.operations.actualQuantity.unit',
  'invoicingDocument.invoiceLines.operations.actualQuantity.value',
  'invoicingDocument.invoiceLines.operations.contacts',
  'invoicingDocument.invoiceLines.operations.contacts.email',
  'invoicingDocument.invoiceLines.operations.contacts.telephone',
  'invoicingDocument.invoiceLines.operations.contacts.persons',
  'invoicingDocument.invoiceLines.operations.contacts.persons.additionalName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.email',
  'invoicingDocument.invoiceLines.operations.contacts.persons.familyName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.faxNumber',
  'invoicingDocument.invoiceLines.operations.contacts.persons.givenName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.idCardNumber',
  'invoicingDocument.invoiceLines.operations.contacts.persons.telephone',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.commercialName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.legalEntityName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressLocality',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressRegion',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.postOfficeBoxNumber',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.postalCode',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressLines',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressCountry',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressCountry.countryCode',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.address.addressCountry.countryName',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.companyRegistrationIds',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'invoicingDocument.invoiceLines.operations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'invoicingDocument.invoiceLines.operations.contacts.role',
  'invoicingDocument.invoiceLines.operations.documents',
  'invoicingDocument.invoiceLines.operations.documents.cmsUri',
  'invoicingDocument.invoiceLines.operations.documents.documentName',
  'invoicingDocument.invoiceLines.operations.documents.format',
  'invoicingDocument.invoiceLines.operations.documents.isRequired',
  'invoicingDocument.invoiceLines.operations.documents.suppliedWithGoods',
  'invoicingDocument.invoiceLines.operations.documents.documentType',
  'invoicingDocument.invoiceLines.operations.documents.documentSubtype',
  'invoicingDocument.invoiceLines.operations.externalReferences',
  'invoicingDocument.invoiceLines.operations.externalReferences.description',
  'invoicingDocument.invoiceLines.operations.externalReferences.externalReferenceType',
  'invoicingDocument.invoiceLines.operations.externalReferences.reference',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.invoiceLineId',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.invoice',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.invoice.uri',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.quantity',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.quantity.unit',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.quantity.value',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.totalPrice',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.totalPrice.unit',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.totalPrice.value',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.unitPrice',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.unitPrice.unit',
  'invoicingDocument.invoiceLines.operations.operationInvoicingDetails.unitPrice.value',
  'invoicingDocument.invoiceLines.operations.plannedQuantity',
  'invoicingDocument.invoiceLines.operations.plannedQuantity.unit',
  'invoicingDocument.invoiceLines.operations.plannedQuantity.value',
  'invoicingDocument.invoiceLines.operations.requestedQuantity',
  'invoicingDocument.invoiceLines.operations.requestedQuantity.unit',
  'invoicingDocument.invoiceLines.operations.requestedQuantity.value',
  'invoicingDocument.invoiceLines.operations.unitPrice',
  'invoicingDocument.invoiceLines.operations.unitPrice.unit',
  'invoicingDocument.invoiceLines.operations.unitPrice.value',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.stringValue',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.characteristicReference',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.specialCharacteristicType',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.numericalValue',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.numericalValue.unit',
  'invoicingDocument.invoiceLines.operations.specialCharacteristics.numericalValue.value',
  'invoicingDocument.invoiceLines.operations.specialInstructions',
  'invoicingDocument.invoiceLines.operations.specialInstructions.description',
  'invoicingDocument.invoiceLines.operations.specialInstructions.instructionCode',
  'invoicingDocument.invoiceLines.unitPrice',
  'invoicingDocument.invoiceLines.unitPrice.unit',
  'invoicingDocument.invoiceLines.unitPrice.value',
  'invoicingDocument.invoiceTaxes',
  'invoicingDocument.invoiceTaxes.taxType',
  'invoicingDocument.invoiceTaxes.amount',
  'invoicingDocument.invoiceTaxes.amount.unit',
  'invoicingDocument.invoiceTaxes.amount.value',
  'invoicingDocument.invoicedParty',
  'invoicingDocument.invoicedParty.commercialName',
  'invoicingDocument.invoicedParty.legalEntityName',
  'invoicingDocument.invoicedParty.address',
  'invoicingDocument.invoicedParty.address.addressLocality',
  'invoicingDocument.invoicedParty.address.addressRegion',
  'invoicingDocument.invoicedParty.address.postOfficeBoxNumber',
  'invoicingDocument.invoicedParty.address.postalCode',
  'invoicingDocument.invoicedParty.address.addressLines',
  'invoicingDocument.invoicedParty.address.addressCountry',
  'invoicingDocument.invoicedParty.address.addressCountry.countryCode',
  'invoicingDocument.invoicedParty.address.addressCountry.countryName',
  'invoicingDocument.invoicedParty.companyRegistrationIds',
  'invoicingDocument.invoicedParty.companyRegistrationIds.companyRegistrationIdType',
  'invoicingDocument.invoicedParty.companyRegistrationIds.companyRegistrationIdValue',
  'invoicingDocument.invoicingParty',
  'invoicingDocument.invoicingParty.commercialName',
  'invoicingDocument.invoicingParty.legalEntityName',
  'invoicingDocument.invoicingParty.address',
  'invoicingDocument.invoicingParty.address.addressLocality',
  'invoicingDocument.invoicingParty.address.addressRegion',
  'invoicingDocument.invoicingParty.address.postOfficeBoxNumber',
  'invoicingDocument.invoicingParty.address.postalCode',
  'invoicingDocument.invoicingParty.address.addressLines',
  'invoicingDocument.invoicingParty.address.addressCountry',
  'invoicingDocument.invoicingParty.address.addressCountry.countryCode',
  'invoicingDocument.invoicingParty.address.addressCountry.countryName',
  'invoicingDocument.invoicingParty.companyRegistrationIds',
  'invoicingDocument.invoicingParty.companyRegistrationIds.companyRegistrationIdType',
  'invoicingDocument.invoicingParty.companyRegistrationIds.companyRegistrationIdValue',
  'invoicingDocument.specialCharacteristics',
  'invoicingDocument.specialCharacteristics.stringValue',
  'invoicingDocument.specialCharacteristics.characteristicReference',
  'invoicingDocument.specialCharacteristics.specialCharacteristicType',
  'invoicingDocument.specialCharacteristics.numericalValue',
  'invoicingDocument.specialCharacteristics.numericalValue.unit',
  'invoicingDocument.specialCharacteristics.numericalValue.value',
  'invoicingDocument.specialInstructions',
  'invoicingDocument.specialInstructions.description',
  'invoicingDocument.specialInstructions.instructionCode',
  'invoicingDocument.terms',
  'invoicingDocument.terms.bankDetails',
  'invoicingDocument.terms.paymentMethod',
  'invoicingDocument.terms.paymentTerms',
  'invoicingDocument.terms.paymentAddress',
  'invoicingDocument.terms.paymentAddress.addressLocality',
  'invoicingDocument.terms.paymentAddress.addressRegion',
  'invoicingDocument.terms.paymentAddress.postOfficeBoxNumber',
  'invoicingDocument.terms.paymentAddress.postalCode',
  'invoicingDocument.terms.paymentAddress.addressLines',
  'invoicingDocument.terms.paymentAddress.addressCountry',
  'invoicingDocument.terms.paymentAddress.addressCountry.countryCode',
  'invoicingDocument.terms.paymentAddress.addressCountry.countryName',
  'invoicingDocument.totalAmount',
  'invoicingDocument.totalAmount.unit',
  'invoicingDocument.totalAmount.value',
  'invoicingDocument.totalAmountIncludingTaxes',
  'invoicingDocument.totalAmountIncludingTaxes.unit',
  'invoicingDocument.totalAmountIncludingTaxes.value',
  'invoicingDocument.id',
] as const;

/**
 * Field paths for Item
 * Total: 82 paths
 */
export const ITEM_FIELD_PATHS = [
  'item.batchNumber',
  'item.productExpiryDate',
  'item.productionDate',
  'item.serialNumber',
  'item.contacts',
  'item.contacts.email',
  'item.contacts.telephone',
  'item.contacts.persons',
  'item.contacts.persons.additionalName',
  'item.contacts.persons.email',
  'item.contacts.persons.familyName',
  'item.contacts.persons.faxNumber',
  'item.contacts.persons.givenName',
  'item.contacts.persons.idCardNumber',
  'item.contacts.persons.telephone',
  'item.contacts.persons.party',
  'item.contacts.persons.party.commercialName',
  'item.contacts.persons.party.legalEntityName',
  'item.contacts.persons.party.address',
  'item.contacts.persons.party.address.addressLocality',
  'item.contacts.persons.party.address.addressRegion',
  'item.contacts.persons.party.address.postOfficeBoxNumber',
  'item.contacts.persons.party.address.postalCode',
  'item.contacts.persons.party.address.addressLines',
  'item.contacts.persons.party.address.addressCountry',
  'item.contacts.persons.party.address.addressCountry.countryCode',
  'item.contacts.persons.party.address.addressCountry.countryName',
  'item.contacts.persons.party.companyRegistrationIds',
  'item.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'item.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'item.contacts.role',
  'item.containedItems',
  'item.containedItems.uri',
  'item.dimensions',
  'item.dimensions.height',
  'item.dimensions.height.unit',
  'item.dimensions.height.value',
  'item.dimensions.length',
  'item.dimensions.length.unit',
  'item.dimensions.length.value',
  'item.dimensions.volume',
  'item.dimensions.volume.unit',
  'item.dimensions.volume.value',
  'item.dimensions.width',
  'item.dimensions.width.unit',
  'item.dimensions.width.value',
  'item.documents',
  'item.documents.cmsUri',
  'item.documents.documentName',
  'item.documents.format',
  'item.documents.isRequired',
  'item.documents.suppliedWithGoods',
  'item.documents.documentType',
  'item.documents.documentSubtype',
  'item.externalReferences',
  'item.externalReferences.description',
  'item.externalReferences.externalReferenceType',
  'item.externalReferences.reference',
  'item.isInItem',
  'item.isInItem.uri',
  'item.productionCountry',
  'item.productionCountry.countryCode',
  'item.productionCountry.countryName',
  'item.products',
  'item.products.uri',
  'item.quantity',
  'item.quantity.unit',
  'item.quantity.value',
  'item.specialCharacteristics',
  'item.specialCharacteristics.stringValue',
  'item.specialCharacteristics.characteristicReference',
  'item.specialCharacteristics.specialCharacteristicType',
  'item.specialCharacteristics.numericalValue',
  'item.specialCharacteristics.numericalValue.unit',
  'item.specialCharacteristics.numericalValue.value',
  'item.specialInstructions',
  'item.specialInstructions.description',
  'item.specialInstructions.instructionCode',
  'item.weight',
  'item.weight.unit',
  'item.weight.value',
  'item.id',
] as const;

/**
 * Field paths for MaterialMean
 * Total: 63 paths
 */
export const MATERIAL_MEAN_FIELD_PATHS = [
  'materialMean.allocationDate',
  'materialMean.contacts',
  'materialMean.contacts.email',
  'materialMean.contacts.telephone',
  'materialMean.contacts.persons',
  'materialMean.contacts.persons.additionalName',
  'materialMean.contacts.persons.email',
  'materialMean.contacts.persons.familyName',
  'materialMean.contacts.persons.faxNumber',
  'materialMean.contacts.persons.givenName',
  'materialMean.contacts.persons.idCardNumber',
  'materialMean.contacts.persons.telephone',
  'materialMean.contacts.persons.party',
  'materialMean.contacts.persons.party.commercialName',
  'materialMean.contacts.persons.party.legalEntityName',
  'materialMean.contacts.persons.party.address',
  'materialMean.contacts.persons.party.address.addressLocality',
  'materialMean.contacts.persons.party.address.addressRegion',
  'materialMean.contacts.persons.party.address.postOfficeBoxNumber',
  'materialMean.contacts.persons.party.address.postalCode',
  'materialMean.contacts.persons.party.address.addressLines',
  'materialMean.contacts.persons.party.address.addressCountry',
  'materialMean.contacts.persons.party.address.addressCountry.countryCode',
  'materialMean.contacts.persons.party.address.addressCountry.countryName',
  'materialMean.contacts.persons.party.companyRegistrationIds',
  'materialMean.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'materialMean.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'materialMean.contacts.role',
  'materialMean.externalReferences',
  'materialMean.externalReferences.description',
  'materialMean.externalReferences.externalReferenceType',
  'materialMean.externalReferences.reference',
  'materialMean.isLinkedToResources',
  'materialMean.pieces',
  'materialMean.pieces.uri',
  'materialMean.specialCharacteristics',
  'materialMean.specialCharacteristics.stringValue',
  'materialMean.specialCharacteristics.characteristicReference',
  'materialMean.specialCharacteristics.specialCharacteristicType',
  'materialMean.specialCharacteristics.numericalValue',
  'materialMean.specialCharacteristics.numericalValue.unit',
  'materialMean.specialCharacteristics.numericalValue.value',
  'materialMean.specialInstructions',
  'materialMean.specialInstructions.description',
  'materialMean.specialInstructions.instructionCode',
  'materialMean.referenceId',
  'materialMean.registrationNumber',
  'materialMean.meanSubtype',
  'materialMean.meanType',
  'materialMean.dimensions',
  'materialMean.dimensions.height',
  'materialMean.dimensions.height.unit',
  'materialMean.dimensions.height.value',
  'materialMean.dimensions.length',
  'materialMean.dimensions.length.unit',
  'materialMean.dimensions.length.value',
  'materialMean.dimensions.volume',
  'materialMean.dimensions.volume.unit',
  'materialMean.dimensions.volume.value',
  'materialMean.dimensions.width',
  'materialMean.dimensions.width.unit',
  'materialMean.dimensions.width.value',
  'materialMean.id',
] as const;

/**
 * Field paths for Piece
 * Total: 85 paths
 */
export const PIECE_FIELD_PATHS = [
  'piece.goodsDescription',
  'piece.stackingMaxNumber',
  'piece.turnable',
  'piece.containerType',
  'piece.containerSubtype',
  'piece.contacts',
  'piece.contacts.email',
  'piece.contacts.telephone',
  'piece.contacts.persons',
  'piece.contacts.persons.additionalName',
  'piece.contacts.persons.email',
  'piece.contacts.persons.familyName',
  'piece.contacts.persons.faxNumber',
  'piece.contacts.persons.givenName',
  'piece.contacts.persons.idCardNumber',
  'piece.contacts.persons.telephone',
  'piece.contacts.persons.party',
  'piece.contacts.persons.party.commercialName',
  'piece.contacts.persons.party.legalEntityName',
  'piece.contacts.persons.party.address',
  'piece.contacts.persons.party.address.addressLocality',
  'piece.contacts.persons.party.address.addressRegion',
  'piece.contacts.persons.party.address.postOfficeBoxNumber',
  'piece.contacts.persons.party.address.postalCode',
  'piece.contacts.persons.party.address.addressLines',
  'piece.contacts.persons.party.address.addressCountry',
  'piece.contacts.persons.party.address.addressCountry.countryCode',
  'piece.contacts.persons.party.address.addressCountry.countryName',
  'piece.contacts.persons.party.companyRegistrationIds',
  'piece.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'piece.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'piece.contacts.role',
  'piece.containedItems',
  'piece.containedItems.uri',
  'piece.containedPieces',
  'piece.containedPieces.uri',
  'piece.dimensions',
  'piece.dimensions.height',
  'piece.dimensions.height.unit',
  'piece.dimensions.height.value',
  'piece.dimensions.length',
  'piece.dimensions.length.unit',
  'piece.dimensions.length.value',
  'piece.dimensions.volume',
  'piece.dimensions.volume.unit',
  'piece.dimensions.volume.value',
  'piece.dimensions.width',
  'piece.dimensions.width.unit',
  'piece.dimensions.width.value',
  'piece.documents',
  'piece.documents.cmsUri',
  'piece.documents.documentName',
  'piece.documents.format',
  'piece.documents.isRequired',
  'piece.documents.suppliedWithGoods',
  'piece.documents.documentType',
  'piece.documents.documentSubtype',
  'piece.externalReferences',
  'piece.externalReferences.description',
  'piece.externalReferences.externalReferenceType',
  'piece.externalReferences.reference',
  'piece.grossWeight',
  'piece.grossWeight.unit',
  'piece.grossWeight.value',
  'piece.isInPiece',
  'piece.isInPiece.uri',
  'piece.netWeight',
  'piece.netWeight.unit',
  'piece.netWeight.value',
  'piece.specialCharacteristics',
  'piece.specialCharacteristics.stringValue',
  'piece.specialCharacteristics.characteristicReference',
  'piece.specialCharacteristics.specialCharacteristicType',
  'piece.specialCharacteristics.numericalValue',
  'piece.specialCharacteristics.numericalValue.unit',
  'piece.specialCharacteristics.numericalValue.value',
  'piece.specialInstructions',
  'piece.specialInstructions.description',
  'piece.specialInstructions.instructionCode',
  'piece.specialRegulations',
  'piece.specialRegulations.specialRegulationType',
  'piece.specialRegulations.productClass',
  'piece.specialRegulations.productUNCode',
  'piece.specialRegulations.productPackingGroup',
  'piece.id',
] as const;

/**
 * Field paths for Product
 * Total: 57 paths
 */
export const PRODUCT_FIELD_PATHS = [
  'product.commodityName',
  'product.hsCode',
  'product.hsCommodityDescription',
  'product.hsCommodityName',
  'product.hsType',
  'product.productDescription',
  'product.productIdentifier',
  'product.contacts',
  'product.contacts.email',
  'product.contacts.telephone',
  'product.contacts.persons',
  'product.contacts.persons.additionalName',
  'product.contacts.persons.email',
  'product.contacts.persons.familyName',
  'product.contacts.persons.faxNumber',
  'product.contacts.persons.givenName',
  'product.contacts.persons.idCardNumber',
  'product.contacts.persons.telephone',
  'product.contacts.persons.party',
  'product.contacts.persons.party.commercialName',
  'product.contacts.persons.party.legalEntityName',
  'product.contacts.persons.party.address',
  'product.contacts.persons.party.address.addressLocality',
  'product.contacts.persons.party.address.addressRegion',
  'product.contacts.persons.party.address.postOfficeBoxNumber',
  'product.contacts.persons.party.address.postalCode',
  'product.contacts.persons.party.address.addressLines',
  'product.contacts.persons.party.address.addressCountry',
  'product.contacts.persons.party.address.addressCountry.countryCode',
  'product.contacts.persons.party.address.addressCountry.countryName',
  'product.contacts.persons.party.companyRegistrationIds',
  'product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'product.contacts.role',
  'product.documents',
  'product.documents.cmsUri',
  'product.documents.documentName',
  'product.documents.format',
  'product.documents.isRequired',
  'product.documents.suppliedWithGoods',
  'product.documents.documentType',
  'product.documents.documentSubtype',
  'product.externalReferences',
  'product.externalReferences.description',
  'product.externalReferences.externalReferenceType',
  'product.externalReferences.reference',
  'product.specialCharacteristics',
  'product.specialCharacteristics.stringValue',
  'product.specialCharacteristics.characteristicReference',
  'product.specialCharacteristics.specialCharacteristicType',
  'product.specialCharacteristics.numericalValue',
  'product.specialCharacteristics.numericalValue.unit',
  'product.specialCharacteristics.numericalValue.value',
  'product.specialInstructions',
  'product.specialInstructions.description',
  'product.specialInstructions.instructionCode',
  'product.id',
] as const;

/**
 * Field paths for QuotationRequest
 * Total: 869 paths
 */
export const QUOTATION_REQUEST_FIELD_PATHS = [
  'quotationRequest.submissionDateTime',
  'quotationRequest.startLocation',
  'quotationRequest.startLocation.isAppointmentRequested',
  'quotationRequest.startLocation.actions',
  'quotationRequest.startLocation.actions.actionDateTime',
  'quotationRequest.startLocation.actions.actionName',
  'quotationRequest.startLocation.actions.sequenceNumber',
  'quotationRequest.startLocation.actions.actionState',
  'quotationRequest.startLocation.actions.actionType',
  'quotationRequest.startLocation.actions.actionSubtype',
  'quotationRequest.startLocation.actions.compositionMovements',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotationRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotationRequest.startLocation.actions.compositionMovements.containedObjects',
  'quotationRequest.startLocation.actions.compositionMovements.container',
  'quotationRequest.startLocation.actions.compositionMovements.container.uri',
  'quotationRequest.startLocation.actions.sealNumber',
  'quotationRequest.startLocation.actions.sealedMaterialMean',
  'quotationRequest.startLocation.actions.sealedMaterialMean.uri',
  'quotationRequest.startLocation.actions.labelAssociations',
  'quotationRequest.startLocation.actions.labelAssociations.labelId',
  'quotationRequest.startLocation.actions.labelAssociations.labeledObject',
  'quotationRequest.startLocation.location',
  'quotationRequest.startLocation.location.locationName',
  'quotationRequest.startLocation.location.locationType',
  'quotationRequest.startLocation.location.code',
  'quotationRequest.startLocation.location.address',
  'quotationRequest.startLocation.location.address.addressLocality',
  'quotationRequest.startLocation.location.address.addressRegion',
  'quotationRequest.startLocation.location.address.postOfficeBoxNumber',
  'quotationRequest.startLocation.location.address.postalCode',
  'quotationRequest.startLocation.location.address.addressLines',
  'quotationRequest.startLocation.location.address.addressCountry',
  'quotationRequest.startLocation.location.address.addressCountry.countryCode',
  'quotationRequest.startLocation.location.address.addressCountry.countryName',
  'quotationRequest.startLocation.location.contacts',
  'quotationRequest.startLocation.location.contacts.email',
  'quotationRequest.startLocation.location.contacts.telephone',
  'quotationRequest.startLocation.location.contacts.persons',
  'quotationRequest.startLocation.location.contacts.persons.additionalName',
  'quotationRequest.startLocation.location.contacts.persons.email',
  'quotationRequest.startLocation.location.contacts.persons.familyName',
  'quotationRequest.startLocation.location.contacts.persons.faxNumber',
  'quotationRequest.startLocation.location.contacts.persons.givenName',
  'quotationRequest.startLocation.location.contacts.persons.idCardNumber',
  'quotationRequest.startLocation.location.contacts.persons.telephone',
  'quotationRequest.startLocation.location.contacts.persons.party',
  'quotationRequest.startLocation.location.contacts.persons.party.commercialName',
  'quotationRequest.startLocation.location.contacts.persons.party.legalEntityName',
  'quotationRequest.startLocation.location.contacts.persons.party.address',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressLocality',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressRegion',
  'quotationRequest.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.startLocation.location.contacts.persons.party.address.postalCode',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressLines',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressCountry',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.startLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.startLocation.location.contacts.role',
  'quotationRequest.startLocation.location.documents',
  'quotationRequest.startLocation.location.documents.cmsUri',
  'quotationRequest.startLocation.location.documents.documentName',
  'quotationRequest.startLocation.location.documents.format',
  'quotationRequest.startLocation.location.documents.isRequired',
  'quotationRequest.startLocation.location.documents.suppliedWithGoods',
  'quotationRequest.startLocation.location.documents.documentType',
  'quotationRequest.startLocation.location.documents.documentSubtype',
  'quotationRequest.startLocation.location.externalReferences',
  'quotationRequest.startLocation.location.externalReferences.description',
  'quotationRequest.startLocation.location.externalReferences.externalReferenceType',
  'quotationRequest.startLocation.location.externalReferences.reference',
  'quotationRequest.startLocation.location.geolocation',
  'quotationRequest.startLocation.location.geolocation.geolocationUnit',
  'quotationRequest.startLocation.location.geolocation.elevation',
  'quotationRequest.startLocation.location.geolocation.elevation.unit',
  'quotationRequest.startLocation.location.geolocation.elevation.value',
  'quotationRequest.startLocation.location.geolocation.latitude',
  'quotationRequest.startLocation.location.geolocation.latitude.unit',
  'quotationRequest.startLocation.location.geolocation.latitude.value',
  'quotationRequest.startLocation.location.geolocation.longitude',
  'quotationRequest.startLocation.location.geolocation.longitude.unit',
  'quotationRequest.startLocation.location.geolocation.longitude.value',
  'quotationRequest.startLocation.location.specialCharacteristics',
  'quotationRequest.startLocation.location.specialCharacteristics.stringValue',
  'quotationRequest.startLocation.location.specialCharacteristics.characteristicReference',
  'quotationRequest.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.startLocation.location.specialCharacteristics.numericalValue',
  'quotationRequest.startLocation.location.specialCharacteristics.numericalValue.unit',
  'quotationRequest.startLocation.location.specialCharacteristics.numericalValue.value',
  'quotationRequest.startLocation.location.specialInstructions',
  'quotationRequest.startLocation.location.specialInstructions.description',
  'quotationRequest.startLocation.location.specialInstructions.instructionCode',
  'quotationRequest.startLocation.appointmentTimeRange',
  'quotationRequest.startLocation.appointmentTimeRange.earliestDateTime',
  'quotationRequest.startLocation.appointmentTimeRange.latestDateTime',
  'quotationRequest.startLocation.requestedStartTimeRange',
  'quotationRequest.startLocation.requestedStartTimeRange.earliestDateTime',
  'quotationRequest.startLocation.requestedStartTimeRange.latestDateTime',
  'quotationRequest.startLocation.requestedEndTimeRange',
  'quotationRequest.startLocation.requestedEndTimeRange.earliestDateTime',
  'quotationRequest.startLocation.requestedEndTimeRange.latestDateTime',
  'quotationRequest.endLocation',
  'quotationRequest.endLocation.isAppointmentRequested',
  'quotationRequest.endLocation.actions',
  'quotationRequest.endLocation.actions.actionDateTime',
  'quotationRequest.endLocation.actions.actionName',
  'quotationRequest.endLocation.actions.sequenceNumber',
  'quotationRequest.endLocation.actions.actionState',
  'quotationRequest.endLocation.actions.actionType',
  'quotationRequest.endLocation.actions.actionSubtype',
  'quotationRequest.endLocation.actions.compositionMovements',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotationRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotationRequest.endLocation.actions.compositionMovements.containedObjects',
  'quotationRequest.endLocation.actions.compositionMovements.container',
  'quotationRequest.endLocation.actions.compositionMovements.container.uri',
  'quotationRequest.endLocation.actions.sealNumber',
  'quotationRequest.endLocation.actions.sealedMaterialMean',
  'quotationRequest.endLocation.actions.sealedMaterialMean.uri',
  'quotationRequest.endLocation.actions.labelAssociations',
  'quotationRequest.endLocation.actions.labelAssociations.labelId',
  'quotationRequest.endLocation.actions.labelAssociations.labeledObject',
  'quotationRequest.endLocation.location',
  'quotationRequest.endLocation.location.locationName',
  'quotationRequest.endLocation.location.locationType',
  'quotationRequest.endLocation.location.code',
  'quotationRequest.endLocation.location.address',
  'quotationRequest.endLocation.location.address.addressLocality',
  'quotationRequest.endLocation.location.address.addressRegion',
  'quotationRequest.endLocation.location.address.postOfficeBoxNumber',
  'quotationRequest.endLocation.location.address.postalCode',
  'quotationRequest.endLocation.location.address.addressLines',
  'quotationRequest.endLocation.location.address.addressCountry',
  'quotationRequest.endLocation.location.address.addressCountry.countryCode',
  'quotationRequest.endLocation.location.address.addressCountry.countryName',
  'quotationRequest.endLocation.location.contacts',
  'quotationRequest.endLocation.location.contacts.email',
  'quotationRequest.endLocation.location.contacts.telephone',
  'quotationRequest.endLocation.location.contacts.persons',
  'quotationRequest.endLocation.location.contacts.persons.additionalName',
  'quotationRequest.endLocation.location.contacts.persons.email',
  'quotationRequest.endLocation.location.contacts.persons.familyName',
  'quotationRequest.endLocation.location.contacts.persons.faxNumber',
  'quotationRequest.endLocation.location.contacts.persons.givenName',
  'quotationRequest.endLocation.location.contacts.persons.idCardNumber',
  'quotationRequest.endLocation.location.contacts.persons.telephone',
  'quotationRequest.endLocation.location.contacts.persons.party',
  'quotationRequest.endLocation.location.contacts.persons.party.commercialName',
  'quotationRequest.endLocation.location.contacts.persons.party.legalEntityName',
  'quotationRequest.endLocation.location.contacts.persons.party.address',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressLocality',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressRegion',
  'quotationRequest.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.endLocation.location.contacts.persons.party.address.postalCode',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressLines',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressCountry',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.endLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.endLocation.location.contacts.role',
  'quotationRequest.endLocation.location.documents',
  'quotationRequest.endLocation.location.documents.cmsUri',
  'quotationRequest.endLocation.location.documents.documentName',
  'quotationRequest.endLocation.location.documents.format',
  'quotationRequest.endLocation.location.documents.isRequired',
  'quotationRequest.endLocation.location.documents.suppliedWithGoods',
  'quotationRequest.endLocation.location.documents.documentType',
  'quotationRequest.endLocation.location.documents.documentSubtype',
  'quotationRequest.endLocation.location.externalReferences',
  'quotationRequest.endLocation.location.externalReferences.description',
  'quotationRequest.endLocation.location.externalReferences.externalReferenceType',
  'quotationRequest.endLocation.location.externalReferences.reference',
  'quotationRequest.endLocation.location.geolocation',
  'quotationRequest.endLocation.location.geolocation.geolocationUnit',
  'quotationRequest.endLocation.location.geolocation.elevation',
  'quotationRequest.endLocation.location.geolocation.elevation.unit',
  'quotationRequest.endLocation.location.geolocation.elevation.value',
  'quotationRequest.endLocation.location.geolocation.latitude',
  'quotationRequest.endLocation.location.geolocation.latitude.unit',
  'quotationRequest.endLocation.location.geolocation.latitude.value',
  'quotationRequest.endLocation.location.geolocation.longitude',
  'quotationRequest.endLocation.location.geolocation.longitude.unit',
  'quotationRequest.endLocation.location.geolocation.longitude.value',
  'quotationRequest.endLocation.location.specialCharacteristics',
  'quotationRequest.endLocation.location.specialCharacteristics.stringValue',
  'quotationRequest.endLocation.location.specialCharacteristics.characteristicReference',
  'quotationRequest.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.endLocation.location.specialCharacteristics.numericalValue',
  'quotationRequest.endLocation.location.specialCharacteristics.numericalValue.unit',
  'quotationRequest.endLocation.location.specialCharacteristics.numericalValue.value',
  'quotationRequest.endLocation.location.specialInstructions',
  'quotationRequest.endLocation.location.specialInstructions.description',
  'quotationRequest.endLocation.location.specialInstructions.instructionCode',
  'quotationRequest.endLocation.appointmentTimeRange',
  'quotationRequest.endLocation.appointmentTimeRange.earliestDateTime',
  'quotationRequest.endLocation.appointmentTimeRange.latestDateTime',
  'quotationRequest.endLocation.requestedStartTimeRange',
  'quotationRequest.endLocation.requestedStartTimeRange.earliestDateTime',
  'quotationRequest.endLocation.requestedStartTimeRange.latestDateTime',
  'quotationRequest.endLocation.requestedEndTimeRange',
  'quotationRequest.endLocation.requestedEndTimeRange.earliestDateTime',
  'quotationRequest.endLocation.requestedEndTimeRange.latestDateTime',
  'quotationRequest.externalReferences',
  'quotationRequest.externalReferences.description',
  'quotationRequest.externalReferences.externalReferenceType',
  'quotationRequest.externalReferences.reference',
  'quotationRequest.requestor',
  'quotationRequest.requestor.commercialName',
  'quotationRequest.requestor.legalEntityName',
  'quotationRequest.requestor.address',
  'quotationRequest.requestor.address.addressLocality',
  'quotationRequest.requestor.address.addressRegion',
  'quotationRequest.requestor.address.postOfficeBoxNumber',
  'quotationRequest.requestor.address.postalCode',
  'quotationRequest.requestor.address.addressLines',
  'quotationRequest.requestor.address.addressCountry',
  'quotationRequest.requestor.address.addressCountry.countryCode',
  'quotationRequest.requestor.address.addressCountry.countryName',
  'quotationRequest.requestor.companyRegistrationIds',
  'quotationRequest.requestor.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.requestor.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.batchesOfGoods',
  'quotationRequest.batchesOfGoods.codePackaging',
  'quotationRequest.batchesOfGoods.containerSubtype',
  'quotationRequest.batchesOfGoods.containerType',
  'quotationRequest.batchesOfGoods.dimensions',
  'quotationRequest.batchesOfGoods.dimensions.height',
  'quotationRequest.batchesOfGoods.dimensions.height.unit',
  'quotationRequest.batchesOfGoods.dimensions.height.value',
  'quotationRequest.batchesOfGoods.dimensions.length',
  'quotationRequest.batchesOfGoods.dimensions.length.unit',
  'quotationRequest.batchesOfGoods.dimensions.length.value',
  'quotationRequest.batchesOfGoods.dimensions.volume',
  'quotationRequest.batchesOfGoods.dimensions.volume.unit',
  'quotationRequest.batchesOfGoods.dimensions.volume.value',
  'quotationRequest.batchesOfGoods.dimensions.width',
  'quotationRequest.batchesOfGoods.dimensions.width.unit',
  'quotationRequest.batchesOfGoods.dimensions.width.value',
  'quotationRequest.batchesOfGoods.product',
  'quotationRequest.batchesOfGoods.product.commodityName',
  'quotationRequest.batchesOfGoods.product.hsCode',
  'quotationRequest.batchesOfGoods.product.hsCommodityDescription',
  'quotationRequest.batchesOfGoods.product.hsCommodityName',
  'quotationRequest.batchesOfGoods.product.hsType',
  'quotationRequest.batchesOfGoods.product.productDescription',
  'quotationRequest.batchesOfGoods.product.productIdentifier',
  'quotationRequest.batchesOfGoods.product.contacts',
  'quotationRequest.batchesOfGoods.product.contacts.email',
  'quotationRequest.batchesOfGoods.product.contacts.telephone',
  'quotationRequest.batchesOfGoods.product.contacts.persons',
  'quotationRequest.batchesOfGoods.product.contacts.persons.additionalName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.email',
  'quotationRequest.batchesOfGoods.product.contacts.persons.familyName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.faxNumber',
  'quotationRequest.batchesOfGoods.product.contacts.persons.givenName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.idCardNumber',
  'quotationRequest.batchesOfGoods.product.contacts.persons.telephone',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.commercialName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.legalEntityName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressLocality',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressRegion',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.postalCode',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressLines',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressCountry',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.batchesOfGoods.product.contacts.role',
  'quotationRequest.batchesOfGoods.product.documents',
  'quotationRequest.batchesOfGoods.product.documents.cmsUri',
  'quotationRequest.batchesOfGoods.product.documents.documentName',
  'quotationRequest.batchesOfGoods.product.documents.format',
  'quotationRequest.batchesOfGoods.product.documents.isRequired',
  'quotationRequest.batchesOfGoods.product.documents.suppliedWithGoods',
  'quotationRequest.batchesOfGoods.product.documents.documentType',
  'quotationRequest.batchesOfGoods.product.documents.documentSubtype',
  'quotationRequest.batchesOfGoods.product.externalReferences',
  'quotationRequest.batchesOfGoods.product.externalReferences.description',
  'quotationRequest.batchesOfGoods.product.externalReferences.externalReferenceType',
  'quotationRequest.batchesOfGoods.product.externalReferences.reference',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.stringValue',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.characteristicReference',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.numericalValue',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.numericalValue.unit',
  'quotationRequest.batchesOfGoods.product.specialCharacteristics.numericalValue.value',
  'quotationRequest.batchesOfGoods.product.specialInstructions',
  'quotationRequest.batchesOfGoods.product.specialInstructions.description',
  'quotationRequest.batchesOfGoods.product.specialInstructions.instructionCode',
  'quotationRequest.batchesOfGoods.specialRegulations',
  'quotationRequest.batchesOfGoods.specialRegulations.specialRegulationType',
  'quotationRequest.batchesOfGoods.specialRegulations.productClass',
  'quotationRequest.batchesOfGoods.specialRegulations.productUNCode',
  'quotationRequest.batchesOfGoods.specialRegulations.productPackingGroup',
  'quotationRequest.batchesOfGoods.quantity',
  'quotationRequest.batchesOfGoods.quantity.unit',
  'quotationRequest.batchesOfGoods.quantity.value',
  'quotationRequest.batchesOfGoods.weight',
  'quotationRequest.batchesOfGoods.weight.unit',
  'quotationRequest.batchesOfGoods.weight.value',
  'quotationRequest.batchesOfGoods.declaredValue',
  'quotationRequest.batchesOfGoods.declaredValue.unit',
  'quotationRequest.batchesOfGoods.declaredValue.value',
  'quotationRequest.incoterms',
  'quotationRequest.quotationRequestStatus',
  'quotationRequest.serviceOffers',
  'quotationRequest.serviceOffers.commercialProductName',
  'quotationRequest.serviceOffers.commercialProductCode',
  'quotationRequest.serviceOffers.validityStartDateTime',
  'quotationRequest.serviceOffers.validityEndDateTime',
  'quotationRequest.serviceOffers.remarks',
  'quotationRequest.serviceOffers.startLocation',
  'quotationRequest.serviceOffers.startLocation.isAppointmentRequested',
  'quotationRequest.serviceOffers.startLocation.actions',
  'quotationRequest.serviceOffers.startLocation.actions.actionDateTime',
  'quotationRequest.serviceOffers.startLocation.actions.actionName',
  'quotationRequest.serviceOffers.startLocation.actions.sequenceNumber',
  'quotationRequest.serviceOffers.startLocation.actions.actionState',
  'quotationRequest.serviceOffers.startLocation.actions.actionType',
  'quotationRequest.serviceOffers.startLocation.actions.actionSubtype',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.containedObjects',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.container',
  'quotationRequest.serviceOffers.startLocation.actions.compositionMovements.container.uri',
  'quotationRequest.serviceOffers.startLocation.actions.sealNumber',
  'quotationRequest.serviceOffers.startLocation.actions.sealedMaterialMean',
  'quotationRequest.serviceOffers.startLocation.actions.sealedMaterialMean.uri',
  'quotationRequest.serviceOffers.startLocation.actions.labelAssociations',
  'quotationRequest.serviceOffers.startLocation.actions.labelAssociations.labelId',
  'quotationRequest.serviceOffers.startLocation.actions.labelAssociations.labeledObject',
  'quotationRequest.serviceOffers.startLocation.location',
  'quotationRequest.serviceOffers.startLocation.location.locationName',
  'quotationRequest.serviceOffers.startLocation.location.locationType',
  'quotationRequest.serviceOffers.startLocation.location.code',
  'quotationRequest.serviceOffers.startLocation.location.address',
  'quotationRequest.serviceOffers.startLocation.location.address.addressLocality',
  'quotationRequest.serviceOffers.startLocation.location.address.addressRegion',
  'quotationRequest.serviceOffers.startLocation.location.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.startLocation.location.address.postalCode',
  'quotationRequest.serviceOffers.startLocation.location.address.addressLines',
  'quotationRequest.serviceOffers.startLocation.location.address.addressCountry',
  'quotationRequest.serviceOffers.startLocation.location.address.addressCountry.countryCode',
  'quotationRequest.serviceOffers.startLocation.location.address.addressCountry.countryName',
  'quotationRequest.serviceOffers.startLocation.location.contacts',
  'quotationRequest.serviceOffers.startLocation.location.contacts.email',
  'quotationRequest.serviceOffers.startLocation.location.contacts.telephone',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.additionalName',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.email',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.familyName',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.faxNumber',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.givenName',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.idCardNumber',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.telephone',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.commercialName',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.legalEntityName',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.addressLocality',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.addressRegion',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.postalCode',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.addressLines',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.address.addressCountry',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.serviceOffers.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.serviceOffers.startLocation.location.contacts.role',
  'quotationRequest.serviceOffers.startLocation.location.documents',
  'quotationRequest.serviceOffers.startLocation.location.documents.cmsUri',
  'quotationRequest.serviceOffers.startLocation.location.documents.documentName',
  'quotationRequest.serviceOffers.startLocation.location.documents.format',
  'quotationRequest.serviceOffers.startLocation.location.documents.isRequired',
  'quotationRequest.serviceOffers.startLocation.location.documents.suppliedWithGoods',
  'quotationRequest.serviceOffers.startLocation.location.documents.documentType',
  'quotationRequest.serviceOffers.startLocation.location.documents.documentSubtype',
  'quotationRequest.serviceOffers.startLocation.location.externalReferences',
  'quotationRequest.serviceOffers.startLocation.location.externalReferences.description',
  'quotationRequest.serviceOffers.startLocation.location.externalReferences.externalReferenceType',
  'quotationRequest.serviceOffers.startLocation.location.externalReferences.reference',
  'quotationRequest.serviceOffers.startLocation.location.geolocation',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.geolocationUnit',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.elevation',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.elevation.unit',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.elevation.value',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.latitude',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.latitude.unit',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.latitude.value',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.longitude',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.longitude.unit',
  'quotationRequest.serviceOffers.startLocation.location.geolocation.longitude.value',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.stringValue',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.characteristicReference',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.numericalValue',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.numericalValue.unit',
  'quotationRequest.serviceOffers.startLocation.location.specialCharacteristics.numericalValue.value',
  'quotationRequest.serviceOffers.startLocation.location.specialInstructions',
  'quotationRequest.serviceOffers.startLocation.location.specialInstructions.description',
  'quotationRequest.serviceOffers.startLocation.location.specialInstructions.instructionCode',
  'quotationRequest.serviceOffers.startLocation.appointmentTimeRange',
  'quotationRequest.serviceOffers.startLocation.appointmentTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.startLocation.appointmentTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.startLocation.requestedStartTimeRange',
  'quotationRequest.serviceOffers.startLocation.requestedStartTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.startLocation.requestedStartTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.startLocation.requestedEndTimeRange',
  'quotationRequest.serviceOffers.startLocation.requestedEndTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.startLocation.requestedEndTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.startLocation.plannedStartTimeRange',
  'quotationRequest.serviceOffers.startLocation.plannedStartTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.startLocation.plannedStartTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.startLocation.plannedEndTimeRange',
  'quotationRequest.serviceOffers.startLocation.plannedEndTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.startLocation.plannedEndTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.endLocation',
  'quotationRequest.serviceOffers.endLocation.isAppointmentRequested',
  'quotationRequest.serviceOffers.endLocation.actions',
  'quotationRequest.serviceOffers.endLocation.actions.actionDateTime',
  'quotationRequest.serviceOffers.endLocation.actions.actionName',
  'quotationRequest.serviceOffers.endLocation.actions.sequenceNumber',
  'quotationRequest.serviceOffers.endLocation.actions.actionState',
  'quotationRequest.serviceOffers.endLocation.actions.actionType',
  'quotationRequest.serviceOffers.endLocation.actions.actionSubtype',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.containedObjects',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.container',
  'quotationRequest.serviceOffers.endLocation.actions.compositionMovements.container.uri',
  'quotationRequest.serviceOffers.endLocation.actions.sealNumber',
  'quotationRequest.serviceOffers.endLocation.actions.sealedMaterialMean',
  'quotationRequest.serviceOffers.endLocation.actions.sealedMaterialMean.uri',
  'quotationRequest.serviceOffers.endLocation.actions.labelAssociations',
  'quotationRequest.serviceOffers.endLocation.actions.labelAssociations.labelId',
  'quotationRequest.serviceOffers.endLocation.actions.labelAssociations.labeledObject',
  'quotationRequest.serviceOffers.endLocation.location',
  'quotationRequest.serviceOffers.endLocation.location.locationName',
  'quotationRequest.serviceOffers.endLocation.location.locationType',
  'quotationRequest.serviceOffers.endLocation.location.code',
  'quotationRequest.serviceOffers.endLocation.location.address',
  'quotationRequest.serviceOffers.endLocation.location.address.addressLocality',
  'quotationRequest.serviceOffers.endLocation.location.address.addressRegion',
  'quotationRequest.serviceOffers.endLocation.location.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.endLocation.location.address.postalCode',
  'quotationRequest.serviceOffers.endLocation.location.address.addressLines',
  'quotationRequest.serviceOffers.endLocation.location.address.addressCountry',
  'quotationRequest.serviceOffers.endLocation.location.address.addressCountry.countryCode',
  'quotationRequest.serviceOffers.endLocation.location.address.addressCountry.countryName',
  'quotationRequest.serviceOffers.endLocation.location.contacts',
  'quotationRequest.serviceOffers.endLocation.location.contacts.email',
  'quotationRequest.serviceOffers.endLocation.location.contacts.telephone',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.additionalName',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.email',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.familyName',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.faxNumber',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.givenName',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.idCardNumber',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.telephone',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.commercialName',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.legalEntityName',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.addressLocality',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.addressRegion',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.postalCode',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.addressLines',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.address.addressCountry',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.serviceOffers.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.serviceOffers.endLocation.location.contacts.role',
  'quotationRequest.serviceOffers.endLocation.location.documents',
  'quotationRequest.serviceOffers.endLocation.location.documents.cmsUri',
  'quotationRequest.serviceOffers.endLocation.location.documents.documentName',
  'quotationRequest.serviceOffers.endLocation.location.documents.format',
  'quotationRequest.serviceOffers.endLocation.location.documents.isRequired',
  'quotationRequest.serviceOffers.endLocation.location.documents.suppliedWithGoods',
  'quotationRequest.serviceOffers.endLocation.location.documents.documentType',
  'quotationRequest.serviceOffers.endLocation.location.documents.documentSubtype',
  'quotationRequest.serviceOffers.endLocation.location.externalReferences',
  'quotationRequest.serviceOffers.endLocation.location.externalReferences.description',
  'quotationRequest.serviceOffers.endLocation.location.externalReferences.externalReferenceType',
  'quotationRequest.serviceOffers.endLocation.location.externalReferences.reference',
  'quotationRequest.serviceOffers.endLocation.location.geolocation',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.geolocationUnit',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.elevation',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.elevation.unit',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.elevation.value',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.latitude',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.latitude.unit',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.latitude.value',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.longitude',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.longitude.unit',
  'quotationRequest.serviceOffers.endLocation.location.geolocation.longitude.value',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.stringValue',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.characteristicReference',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.numericalValue',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.numericalValue.unit',
  'quotationRequest.serviceOffers.endLocation.location.specialCharacteristics.numericalValue.value',
  'quotationRequest.serviceOffers.endLocation.location.specialInstructions',
  'quotationRequest.serviceOffers.endLocation.location.specialInstructions.description',
  'quotationRequest.serviceOffers.endLocation.location.specialInstructions.instructionCode',
  'quotationRequest.serviceOffers.endLocation.appointmentTimeRange',
  'quotationRequest.serviceOffers.endLocation.appointmentTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.endLocation.appointmentTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.endLocation.requestedStartTimeRange',
  'quotationRequest.serviceOffers.endLocation.requestedStartTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.endLocation.requestedStartTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.endLocation.requestedEndTimeRange',
  'quotationRequest.serviceOffers.endLocation.requestedEndTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.endLocation.requestedEndTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.endLocation.plannedStartTimeRange',
  'quotationRequest.serviceOffers.endLocation.plannedStartTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.endLocation.plannedStartTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.endLocation.plannedEndTimeRange',
  'quotationRequest.serviceOffers.endLocation.plannedEndTimeRange.earliestDateTime',
  'quotationRequest.serviceOffers.endLocation.plannedEndTimeRange.latestDateTime',
  'quotationRequest.serviceOffers.incoterm',
  'quotationRequest.serviceOffers.saleOperations',
  'quotationRequest.serviceOffers.saleOperations.isMandatory',
  'quotationRequest.serviceOffers.saleOperations.isProposedByDefault',
  'quotationRequest.serviceOffers.saleOperations.isSelected',
  'quotationRequest.serviceOffers.saleOperations.operationDescription',
  'quotationRequest.serviceOffers.saleOperations.operationName',
  'quotationRequest.serviceOffers.saleOperations.operationCode',
  'quotationRequest.serviceOffers.saleOperations.operationSubtype',
  'quotationRequest.serviceOffers.saleOperations.operationType',
  'quotationRequest.serviceOffers.saleOperations.amountExclTaxes',
  'quotationRequest.serviceOffers.saleOperations.amountExclTaxes.unit',
  'quotationRequest.serviceOffers.saleOperations.amountExclTaxes.value',
  'quotationRequest.serviceOffers.saleOperations.amountInclTaxes',
  'quotationRequest.serviceOffers.saleOperations.amountInclTaxes.unit',
  'quotationRequest.serviceOffers.saleOperations.amountInclTaxes.value',
  'quotationRequest.serviceOffers.saleOperations.requestedPrepaidAmount',
  'quotationRequest.serviceOffers.saleOperations.requestedPrepaidAmount.unit',
  'quotationRequest.serviceOffers.saleOperations.requestedPrepaidAmount.value',
  'quotationRequest.serviceOffers.saleOperations.actualQuantity',
  'quotationRequest.serviceOffers.saleOperations.actualQuantity.unit',
  'quotationRequest.serviceOffers.saleOperations.actualQuantity.value',
  'quotationRequest.serviceOffers.saleOperations.contacts',
  'quotationRequest.serviceOffers.saleOperations.contacts.email',
  'quotationRequest.serviceOffers.saleOperations.contacts.telephone',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.additionalName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.email',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.familyName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.faxNumber',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.givenName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.idCardNumber',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.telephone',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.commercialName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.legalEntityName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressLocality',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressRegion',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.postalCode',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressLines',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressCountry',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.serviceOffers.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.serviceOffers.saleOperations.contacts.role',
  'quotationRequest.serviceOffers.saleOperations.documents',
  'quotationRequest.serviceOffers.saleOperations.documents.cmsUri',
  'quotationRequest.serviceOffers.saleOperations.documents.documentName',
  'quotationRequest.serviceOffers.saleOperations.documents.format',
  'quotationRequest.serviceOffers.saleOperations.documents.isRequired',
  'quotationRequest.serviceOffers.saleOperations.documents.suppliedWithGoods',
  'quotationRequest.serviceOffers.saleOperations.documents.documentType',
  'quotationRequest.serviceOffers.saleOperations.documents.documentSubtype',
  'quotationRequest.serviceOffers.saleOperations.externalReferences',
  'quotationRequest.serviceOffers.saleOperations.externalReferences.description',
  'quotationRequest.serviceOffers.saleOperations.externalReferences.externalReferenceType',
  'quotationRequest.serviceOffers.saleOperations.externalReferences.reference',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.invoiceLineId',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.invoice',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.invoice.uri',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.quantity',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.quantity.unit',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.quantity.value',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.totalPrice',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.totalPrice.unit',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.totalPrice.value',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.unitPrice',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.unitPrice.unit',
  'quotationRequest.serviceOffers.saleOperations.operationInvoicingDetails.unitPrice.value',
  'quotationRequest.serviceOffers.saleOperations.plannedQuantity',
  'quotationRequest.serviceOffers.saleOperations.plannedQuantity.unit',
  'quotationRequest.serviceOffers.saleOperations.plannedQuantity.value',
  'quotationRequest.serviceOffers.saleOperations.requestedQuantity',
  'quotationRequest.serviceOffers.saleOperations.requestedQuantity.unit',
  'quotationRequest.serviceOffers.saleOperations.requestedQuantity.value',
  'quotationRequest.serviceOffers.saleOperations.unitPrice',
  'quotationRequest.serviceOffers.saleOperations.unitPrice.unit',
  'quotationRequest.serviceOffers.saleOperations.unitPrice.value',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.stringValue',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.characteristicReference',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.numericalValue',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.numericalValue.unit',
  'quotationRequest.serviceOffers.saleOperations.specialCharacteristics.numericalValue.value',
  'quotationRequest.serviceOffers.saleOperations.specialInstructions',
  'quotationRequest.serviceOffers.saleOperations.specialInstructions.description',
  'quotationRequest.serviceOffers.saleOperations.specialInstructions.instructionCode',
  'quotationRequest.serviceOffers.provider',
  'quotationRequest.serviceOffers.provider.commercialName',
  'quotationRequest.serviceOffers.provider.legalEntityName',
  'quotationRequest.serviceOffers.provider.address',
  'quotationRequest.serviceOffers.provider.address.addressLocality',
  'quotationRequest.serviceOffers.provider.address.addressRegion',
  'quotationRequest.serviceOffers.provider.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.provider.address.postalCode',
  'quotationRequest.serviceOffers.provider.address.addressLines',
  'quotationRequest.serviceOffers.provider.address.addressCountry',
  'quotationRequest.serviceOffers.provider.address.addressCountry.countryCode',
  'quotationRequest.serviceOffers.provider.address.addressCountry.countryName',
  'quotationRequest.serviceOffers.provider.companyRegistrationIds',
  'quotationRequest.serviceOffers.provider.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.serviceOffers.provider.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.serviceOffers.quotationRequest',
  'quotationRequest.serviceOffers.quotationRequest.uri',
  'quotationRequest.serviceOffers.carbonFootprint',
  'quotationRequest.serviceOffers.carbonFootprint.unit',
  'quotationRequest.serviceOffers.carbonFootprint.value',
  'quotationRequest.serviceOffers.specialInstructions',
  'quotationRequest.serviceOffers.specialInstructions.description',
  'quotationRequest.serviceOffers.specialInstructions.instructionCode',
  'quotationRequest.serviceOffers.specialCharacteristics',
  'quotationRequest.serviceOffers.specialCharacteristics.stringValue',
  'quotationRequest.serviceOffers.specialCharacteristics.characteristicReference',
  'quotationRequest.serviceOffers.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.serviceOffers.specialCharacteristics.numericalValue',
  'quotationRequest.serviceOffers.specialCharacteristics.numericalValue.unit',
  'quotationRequest.serviceOffers.specialCharacteristics.numericalValue.value',
  'quotationRequest.serviceOffers.externalReferences',
  'quotationRequest.serviceOffers.externalReferences.description',
  'quotationRequest.serviceOffers.externalReferences.externalReferenceType',
  'quotationRequest.serviceOffers.externalReferences.reference',
  'quotationRequest.serviceOffers.documents',
  'quotationRequest.serviceOffers.documents.cmsUri',
  'quotationRequest.serviceOffers.documents.documentName',
  'quotationRequest.serviceOffers.documents.format',
  'quotationRequest.serviceOffers.documents.isRequired',
  'quotationRequest.serviceOffers.documents.suppliedWithGoods',
  'quotationRequest.serviceOffers.documents.documentType',
  'quotationRequest.serviceOffers.documents.documentSubtype',
  'quotationRequest.serviceOffers.contacts',
  'quotationRequest.serviceOffers.contacts.email',
  'quotationRequest.serviceOffers.contacts.telephone',
  'quotationRequest.serviceOffers.contacts.persons',
  'quotationRequest.serviceOffers.contacts.persons.additionalName',
  'quotationRequest.serviceOffers.contacts.persons.email',
  'quotationRequest.serviceOffers.contacts.persons.familyName',
  'quotationRequest.serviceOffers.contacts.persons.faxNumber',
  'quotationRequest.serviceOffers.contacts.persons.givenName',
  'quotationRequest.serviceOffers.contacts.persons.idCardNumber',
  'quotationRequest.serviceOffers.contacts.persons.telephone',
  'quotationRequest.serviceOffers.contacts.persons.party',
  'quotationRequest.serviceOffers.contacts.persons.party.commercialName',
  'quotationRequest.serviceOffers.contacts.persons.party.legalEntityName',
  'quotationRequest.serviceOffers.contacts.persons.party.address',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressLocality',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressRegion',
  'quotationRequest.serviceOffers.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.serviceOffers.contacts.persons.party.address.postalCode',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressLines',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressCountry',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.serviceOffers.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.serviceOffers.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.serviceOffers.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.serviceOffers.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.serviceOffers.contacts.role',
  'quotationRequest.serviceOffers.id',
  'quotationRequest.quotation',
  'quotationRequest.quotation.uri',
  'quotationRequest.preferredCurrency',
  'quotationRequest.contacts',
  'quotationRequest.contacts.email',
  'quotationRequest.contacts.telephone',
  'quotationRequest.contacts.persons',
  'quotationRequest.contacts.persons.additionalName',
  'quotationRequest.contacts.persons.email',
  'quotationRequest.contacts.persons.familyName',
  'quotationRequest.contacts.persons.faxNumber',
  'quotationRequest.contacts.persons.givenName',
  'quotationRequest.contacts.persons.idCardNumber',
  'quotationRequest.contacts.persons.telephone',
  'quotationRequest.contacts.persons.party',
  'quotationRequest.contacts.persons.party.commercialName',
  'quotationRequest.contacts.persons.party.legalEntityName',
  'quotationRequest.contacts.persons.party.address',
  'quotationRequest.contacts.persons.party.address.addressLocality',
  'quotationRequest.contacts.persons.party.address.addressRegion',
  'quotationRequest.contacts.persons.party.address.postOfficeBoxNumber',
  'quotationRequest.contacts.persons.party.address.postalCode',
  'quotationRequest.contacts.persons.party.address.addressLines',
  'quotationRequest.contacts.persons.party.address.addressCountry',
  'quotationRequest.contacts.persons.party.address.addressCountry.countryCode',
  'quotationRequest.contacts.persons.party.address.addressCountry.countryName',
  'quotationRequest.contacts.persons.party.companyRegistrationIds',
  'quotationRequest.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotationRequest.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotationRequest.contacts.role',
  'quotationRequest.specialInstructions',
  'quotationRequest.specialInstructions.description',
  'quotationRequest.specialInstructions.instructionCode',
  'quotationRequest.specialCharacteristics',
  'quotationRequest.specialCharacteristics.stringValue',
  'quotationRequest.specialCharacteristics.characteristicReference',
  'quotationRequest.specialCharacteristics.specialCharacteristicType',
  'quotationRequest.specialCharacteristics.numericalValue',
  'quotationRequest.specialCharacteristics.numericalValue.unit',
  'quotationRequest.specialCharacteristics.numericalValue.value',
  'quotationRequest.rejections',
  'quotationRequest.rejections.code',
  'quotationRequest.rejections.detail',
  'quotationRequest.rejections.title',
  'quotationRequest.quotationProcess',
  'quotationRequest.id',
] as const;

/**
 * Field paths for Quotation
 * Total: 1057 paths
 */
export const QUOTATION_FIELD_PATHS = [
  'quotation.quotationName',
  'quotation.submissionDateTime',
  'quotation.validityStartDateTime',
  'quotation.validityEndDateTime',
  'quotation.contacts',
  'quotation.contacts.email',
  'quotation.contacts.telephone',
  'quotation.contacts.persons',
  'quotation.contacts.persons.additionalName',
  'quotation.contacts.persons.email',
  'quotation.contacts.persons.familyName',
  'quotation.contacts.persons.faxNumber',
  'quotation.contacts.persons.givenName',
  'quotation.contacts.persons.idCardNumber',
  'quotation.contacts.persons.telephone',
  'quotation.contacts.persons.party',
  'quotation.contacts.persons.party.commercialName',
  'quotation.contacts.persons.party.legalEntityName',
  'quotation.contacts.persons.party.address',
  'quotation.contacts.persons.party.address.addressLocality',
  'quotation.contacts.persons.party.address.addressRegion',
  'quotation.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.contacts.persons.party.address.postalCode',
  'quotation.contacts.persons.party.address.addressLines',
  'quotation.contacts.persons.party.address.addressCountry',
  'quotation.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.contacts.persons.party.address.addressCountry.countryName',
  'quotation.contacts.persons.party.companyRegistrationIds',
  'quotation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.contacts.role',
  'quotation.requestor',
  'quotation.requestor.commercialName',
  'quotation.requestor.legalEntityName',
  'quotation.requestor.address',
  'quotation.requestor.address.addressLocality',
  'quotation.requestor.address.addressRegion',
  'quotation.requestor.address.postOfficeBoxNumber',
  'quotation.requestor.address.postalCode',
  'quotation.requestor.address.addressLines',
  'quotation.requestor.address.addressCountry',
  'quotation.requestor.address.addressCountry.countryCode',
  'quotation.requestor.address.addressCountry.countryName',
  'quotation.requestor.companyRegistrationIds',
  'quotation.requestor.companyRegistrationIds.companyRegistrationIdType',
  'quotation.requestor.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.provider',
  'quotation.provider.commercialName',
  'quotation.provider.legalEntityName',
  'quotation.provider.address',
  'quotation.provider.address.addressLocality',
  'quotation.provider.address.addressRegion',
  'quotation.provider.address.postOfficeBoxNumber',
  'quotation.provider.address.postalCode',
  'quotation.provider.address.addressLines',
  'quotation.provider.address.addressCountry',
  'quotation.provider.address.addressCountry.countryCode',
  'quotation.provider.address.addressCountry.countryName',
  'quotation.provider.companyRegistrationIds',
  'quotation.provider.companyRegistrationIds.companyRegistrationIdType',
  'quotation.provider.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.invoicedParty',
  'quotation.invoicedParty.commercialName',
  'quotation.invoicedParty.legalEntityName',
  'quotation.invoicedParty.address',
  'quotation.invoicedParty.address.addressLocality',
  'quotation.invoicedParty.address.addressRegion',
  'quotation.invoicedParty.address.postOfficeBoxNumber',
  'quotation.invoicedParty.address.postalCode',
  'quotation.invoicedParty.address.addressLines',
  'quotation.invoicedParty.address.addressCountry',
  'quotation.invoicedParty.address.addressCountry.countryCode',
  'quotation.invoicedParty.address.addressCountry.countryName',
  'quotation.invoicedParty.companyRegistrationIds',
  'quotation.invoicedParty.companyRegistrationIds.companyRegistrationIdType',
  'quotation.invoicedParty.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.startLocation',
  'quotation.startLocation.isAppointmentRequested',
  'quotation.startLocation.actions',
  'quotation.startLocation.actions.actionDateTime',
  'quotation.startLocation.actions.actionName',
  'quotation.startLocation.actions.sequenceNumber',
  'quotation.startLocation.actions.actionState',
  'quotation.startLocation.actions.actionType',
  'quotation.startLocation.actions.actionSubtype',
  'quotation.startLocation.actions.compositionMovements',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotation.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotation.startLocation.actions.compositionMovements.containedObjects',
  'quotation.startLocation.actions.compositionMovements.container',
  'quotation.startLocation.actions.compositionMovements.container.uri',
  'quotation.startLocation.actions.sealNumber',
  'quotation.startLocation.actions.sealedMaterialMean',
  'quotation.startLocation.actions.sealedMaterialMean.uri',
  'quotation.startLocation.actions.labelAssociations',
  'quotation.startLocation.actions.labelAssociations.labelId',
  'quotation.startLocation.actions.labelAssociations.labeledObject',
  'quotation.startLocation.location',
  'quotation.startLocation.location.locationName',
  'quotation.startLocation.location.locationType',
  'quotation.startLocation.location.code',
  'quotation.startLocation.location.address',
  'quotation.startLocation.location.address.addressLocality',
  'quotation.startLocation.location.address.addressRegion',
  'quotation.startLocation.location.address.postOfficeBoxNumber',
  'quotation.startLocation.location.address.postalCode',
  'quotation.startLocation.location.address.addressLines',
  'quotation.startLocation.location.address.addressCountry',
  'quotation.startLocation.location.address.addressCountry.countryCode',
  'quotation.startLocation.location.address.addressCountry.countryName',
  'quotation.startLocation.location.contacts',
  'quotation.startLocation.location.contacts.email',
  'quotation.startLocation.location.contacts.telephone',
  'quotation.startLocation.location.contacts.persons',
  'quotation.startLocation.location.contacts.persons.additionalName',
  'quotation.startLocation.location.contacts.persons.email',
  'quotation.startLocation.location.contacts.persons.familyName',
  'quotation.startLocation.location.contacts.persons.faxNumber',
  'quotation.startLocation.location.contacts.persons.givenName',
  'quotation.startLocation.location.contacts.persons.idCardNumber',
  'quotation.startLocation.location.contacts.persons.telephone',
  'quotation.startLocation.location.contacts.persons.party',
  'quotation.startLocation.location.contacts.persons.party.commercialName',
  'quotation.startLocation.location.contacts.persons.party.legalEntityName',
  'quotation.startLocation.location.contacts.persons.party.address',
  'quotation.startLocation.location.contacts.persons.party.address.addressLocality',
  'quotation.startLocation.location.contacts.persons.party.address.addressRegion',
  'quotation.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.startLocation.location.contacts.persons.party.address.postalCode',
  'quotation.startLocation.location.contacts.persons.party.address.addressLines',
  'quotation.startLocation.location.contacts.persons.party.address.addressCountry',
  'quotation.startLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.startLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'quotation.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotation.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.startLocation.location.contacts.role',
  'quotation.startLocation.location.documents',
  'quotation.startLocation.location.documents.cmsUri',
  'quotation.startLocation.location.documents.documentName',
  'quotation.startLocation.location.documents.format',
  'quotation.startLocation.location.documents.isRequired',
  'quotation.startLocation.location.documents.suppliedWithGoods',
  'quotation.startLocation.location.documents.documentType',
  'quotation.startLocation.location.documents.documentSubtype',
  'quotation.startLocation.location.externalReferences',
  'quotation.startLocation.location.externalReferences.description',
  'quotation.startLocation.location.externalReferences.externalReferenceType',
  'quotation.startLocation.location.externalReferences.reference',
  'quotation.startLocation.location.geolocation',
  'quotation.startLocation.location.geolocation.geolocationUnit',
  'quotation.startLocation.location.geolocation.elevation',
  'quotation.startLocation.location.geolocation.elevation.unit',
  'quotation.startLocation.location.geolocation.elevation.value',
  'quotation.startLocation.location.geolocation.latitude',
  'quotation.startLocation.location.geolocation.latitude.unit',
  'quotation.startLocation.location.geolocation.latitude.value',
  'quotation.startLocation.location.geolocation.longitude',
  'quotation.startLocation.location.geolocation.longitude.unit',
  'quotation.startLocation.location.geolocation.longitude.value',
  'quotation.startLocation.location.specialCharacteristics',
  'quotation.startLocation.location.specialCharacteristics.stringValue',
  'quotation.startLocation.location.specialCharacteristics.characteristicReference',
  'quotation.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotation.startLocation.location.specialCharacteristics.numericalValue',
  'quotation.startLocation.location.specialCharacteristics.numericalValue.unit',
  'quotation.startLocation.location.specialCharacteristics.numericalValue.value',
  'quotation.startLocation.location.specialInstructions',
  'quotation.startLocation.location.specialInstructions.description',
  'quotation.startLocation.location.specialInstructions.instructionCode',
  'quotation.startLocation.appointmentTimeRange',
  'quotation.startLocation.appointmentTimeRange.earliestDateTime',
  'quotation.startLocation.appointmentTimeRange.latestDateTime',
  'quotation.startLocation.requestedStartTimeRange',
  'quotation.startLocation.requestedStartTimeRange.earliestDateTime',
  'quotation.startLocation.requestedStartTimeRange.latestDateTime',
  'quotation.startLocation.requestedEndTimeRange',
  'quotation.startLocation.requestedEndTimeRange.earliestDateTime',
  'quotation.startLocation.requestedEndTimeRange.latestDateTime',
  'quotation.startLocation.plannedStartTimeRange',
  'quotation.startLocation.plannedStartTimeRange.earliestDateTime',
  'quotation.startLocation.plannedStartTimeRange.latestDateTime',
  'quotation.startLocation.plannedEndTimeRange',
  'quotation.startLocation.plannedEndTimeRange.earliestDateTime',
  'quotation.startLocation.plannedEndTimeRange.latestDateTime',
  'quotation.endLocation',
  'quotation.endLocation.isAppointmentRequested',
  'quotation.endLocation.actions',
  'quotation.endLocation.actions.actionDateTime',
  'quotation.endLocation.actions.actionName',
  'quotation.endLocation.actions.sequenceNumber',
  'quotation.endLocation.actions.actionState',
  'quotation.endLocation.actions.actionType',
  'quotation.endLocation.actions.actionSubtype',
  'quotation.endLocation.actions.compositionMovements',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotation.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotation.endLocation.actions.compositionMovements.containedObjects',
  'quotation.endLocation.actions.compositionMovements.container',
  'quotation.endLocation.actions.compositionMovements.container.uri',
  'quotation.endLocation.actions.sealNumber',
  'quotation.endLocation.actions.sealedMaterialMean',
  'quotation.endLocation.actions.sealedMaterialMean.uri',
  'quotation.endLocation.actions.labelAssociations',
  'quotation.endLocation.actions.labelAssociations.labelId',
  'quotation.endLocation.actions.labelAssociations.labeledObject',
  'quotation.endLocation.location',
  'quotation.endLocation.location.locationName',
  'quotation.endLocation.location.locationType',
  'quotation.endLocation.location.code',
  'quotation.endLocation.location.address',
  'quotation.endLocation.location.address.addressLocality',
  'quotation.endLocation.location.address.addressRegion',
  'quotation.endLocation.location.address.postOfficeBoxNumber',
  'quotation.endLocation.location.address.postalCode',
  'quotation.endLocation.location.address.addressLines',
  'quotation.endLocation.location.address.addressCountry',
  'quotation.endLocation.location.address.addressCountry.countryCode',
  'quotation.endLocation.location.address.addressCountry.countryName',
  'quotation.endLocation.location.contacts',
  'quotation.endLocation.location.contacts.email',
  'quotation.endLocation.location.contacts.telephone',
  'quotation.endLocation.location.contacts.persons',
  'quotation.endLocation.location.contacts.persons.additionalName',
  'quotation.endLocation.location.contacts.persons.email',
  'quotation.endLocation.location.contacts.persons.familyName',
  'quotation.endLocation.location.contacts.persons.faxNumber',
  'quotation.endLocation.location.contacts.persons.givenName',
  'quotation.endLocation.location.contacts.persons.idCardNumber',
  'quotation.endLocation.location.contacts.persons.telephone',
  'quotation.endLocation.location.contacts.persons.party',
  'quotation.endLocation.location.contacts.persons.party.commercialName',
  'quotation.endLocation.location.contacts.persons.party.legalEntityName',
  'quotation.endLocation.location.contacts.persons.party.address',
  'quotation.endLocation.location.contacts.persons.party.address.addressLocality',
  'quotation.endLocation.location.contacts.persons.party.address.addressRegion',
  'quotation.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.endLocation.location.contacts.persons.party.address.postalCode',
  'quotation.endLocation.location.contacts.persons.party.address.addressLines',
  'quotation.endLocation.location.contacts.persons.party.address.addressCountry',
  'quotation.endLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.endLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'quotation.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotation.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.endLocation.location.contacts.role',
  'quotation.endLocation.location.documents',
  'quotation.endLocation.location.documents.cmsUri',
  'quotation.endLocation.location.documents.documentName',
  'quotation.endLocation.location.documents.format',
  'quotation.endLocation.location.documents.isRequired',
  'quotation.endLocation.location.documents.suppliedWithGoods',
  'quotation.endLocation.location.documents.documentType',
  'quotation.endLocation.location.documents.documentSubtype',
  'quotation.endLocation.location.externalReferences',
  'quotation.endLocation.location.externalReferences.description',
  'quotation.endLocation.location.externalReferences.externalReferenceType',
  'quotation.endLocation.location.externalReferences.reference',
  'quotation.endLocation.location.geolocation',
  'quotation.endLocation.location.geolocation.geolocationUnit',
  'quotation.endLocation.location.geolocation.elevation',
  'quotation.endLocation.location.geolocation.elevation.unit',
  'quotation.endLocation.location.geolocation.elevation.value',
  'quotation.endLocation.location.geolocation.latitude',
  'quotation.endLocation.location.geolocation.latitude.unit',
  'quotation.endLocation.location.geolocation.latitude.value',
  'quotation.endLocation.location.geolocation.longitude',
  'quotation.endLocation.location.geolocation.longitude.unit',
  'quotation.endLocation.location.geolocation.longitude.value',
  'quotation.endLocation.location.specialCharacteristics',
  'quotation.endLocation.location.specialCharacteristics.stringValue',
  'quotation.endLocation.location.specialCharacteristics.characteristicReference',
  'quotation.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotation.endLocation.location.specialCharacteristics.numericalValue',
  'quotation.endLocation.location.specialCharacteristics.numericalValue.unit',
  'quotation.endLocation.location.specialCharacteristics.numericalValue.value',
  'quotation.endLocation.location.specialInstructions',
  'quotation.endLocation.location.specialInstructions.description',
  'quotation.endLocation.location.specialInstructions.instructionCode',
  'quotation.endLocation.appointmentTimeRange',
  'quotation.endLocation.appointmentTimeRange.earliestDateTime',
  'quotation.endLocation.appointmentTimeRange.latestDateTime',
  'quotation.endLocation.requestedStartTimeRange',
  'quotation.endLocation.requestedStartTimeRange.earliestDateTime',
  'quotation.endLocation.requestedStartTimeRange.latestDateTime',
  'quotation.endLocation.requestedEndTimeRange',
  'quotation.endLocation.requestedEndTimeRange.earliestDateTime',
  'quotation.endLocation.requestedEndTimeRange.latestDateTime',
  'quotation.endLocation.plannedStartTimeRange',
  'quotation.endLocation.plannedStartTimeRange.earliestDateTime',
  'quotation.endLocation.plannedStartTimeRange.latestDateTime',
  'quotation.endLocation.plannedEndTimeRange',
  'quotation.endLocation.plannedEndTimeRange.earliestDateTime',
  'quotation.endLocation.plannedEndTimeRange.latestDateTime',
  'quotation.serviceOffer',
  'quotation.serviceOffer.commercialProductName',
  'quotation.serviceOffer.commercialProductCode',
  'quotation.serviceOffer.validityStartDateTime',
  'quotation.serviceOffer.validityEndDateTime',
  'quotation.serviceOffer.remarks',
  'quotation.serviceOffer.startLocation',
  'quotation.serviceOffer.startLocation.isAppointmentRequested',
  'quotation.serviceOffer.startLocation.actions',
  'quotation.serviceOffer.startLocation.actions.actionDateTime',
  'quotation.serviceOffer.startLocation.actions.actionName',
  'quotation.serviceOffer.startLocation.actions.sequenceNumber',
  'quotation.serviceOffer.startLocation.actions.actionState',
  'quotation.serviceOffer.startLocation.actions.actionType',
  'quotation.serviceOffer.startLocation.actions.actionSubtype',
  'quotation.serviceOffer.startLocation.actions.compositionMovements',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.containedObjects',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.container',
  'quotation.serviceOffer.startLocation.actions.compositionMovements.container.uri',
  'quotation.serviceOffer.startLocation.actions.sealNumber',
  'quotation.serviceOffer.startLocation.actions.sealedMaterialMean',
  'quotation.serviceOffer.startLocation.actions.sealedMaterialMean.uri',
  'quotation.serviceOffer.startLocation.actions.labelAssociations',
  'quotation.serviceOffer.startLocation.actions.labelAssociations.labelId',
  'quotation.serviceOffer.startLocation.actions.labelAssociations.labeledObject',
  'quotation.serviceOffer.startLocation.location',
  'quotation.serviceOffer.startLocation.location.locationName',
  'quotation.serviceOffer.startLocation.location.locationType',
  'quotation.serviceOffer.startLocation.location.code',
  'quotation.serviceOffer.startLocation.location.address',
  'quotation.serviceOffer.startLocation.location.address.addressLocality',
  'quotation.serviceOffer.startLocation.location.address.addressRegion',
  'quotation.serviceOffer.startLocation.location.address.postOfficeBoxNumber',
  'quotation.serviceOffer.startLocation.location.address.postalCode',
  'quotation.serviceOffer.startLocation.location.address.addressLines',
  'quotation.serviceOffer.startLocation.location.address.addressCountry',
  'quotation.serviceOffer.startLocation.location.address.addressCountry.countryCode',
  'quotation.serviceOffer.startLocation.location.address.addressCountry.countryName',
  'quotation.serviceOffer.startLocation.location.contacts',
  'quotation.serviceOffer.startLocation.location.contacts.email',
  'quotation.serviceOffer.startLocation.location.contacts.telephone',
  'quotation.serviceOffer.startLocation.location.contacts.persons',
  'quotation.serviceOffer.startLocation.location.contacts.persons.additionalName',
  'quotation.serviceOffer.startLocation.location.contacts.persons.email',
  'quotation.serviceOffer.startLocation.location.contacts.persons.familyName',
  'quotation.serviceOffer.startLocation.location.contacts.persons.faxNumber',
  'quotation.serviceOffer.startLocation.location.contacts.persons.givenName',
  'quotation.serviceOffer.startLocation.location.contacts.persons.idCardNumber',
  'quotation.serviceOffer.startLocation.location.contacts.persons.telephone',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.commercialName',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.legalEntityName',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.addressLocality',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.addressRegion',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.postalCode',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.addressLines',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.address.addressCountry',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.serviceOffer.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.serviceOffer.startLocation.location.contacts.role',
  'quotation.serviceOffer.startLocation.location.documents',
  'quotation.serviceOffer.startLocation.location.documents.cmsUri',
  'quotation.serviceOffer.startLocation.location.documents.documentName',
  'quotation.serviceOffer.startLocation.location.documents.format',
  'quotation.serviceOffer.startLocation.location.documents.isRequired',
  'quotation.serviceOffer.startLocation.location.documents.suppliedWithGoods',
  'quotation.serviceOffer.startLocation.location.documents.documentType',
  'quotation.serviceOffer.startLocation.location.documents.documentSubtype',
  'quotation.serviceOffer.startLocation.location.externalReferences',
  'quotation.serviceOffer.startLocation.location.externalReferences.description',
  'quotation.serviceOffer.startLocation.location.externalReferences.externalReferenceType',
  'quotation.serviceOffer.startLocation.location.externalReferences.reference',
  'quotation.serviceOffer.startLocation.location.geolocation',
  'quotation.serviceOffer.startLocation.location.geolocation.geolocationUnit',
  'quotation.serviceOffer.startLocation.location.geolocation.elevation',
  'quotation.serviceOffer.startLocation.location.geolocation.elevation.unit',
  'quotation.serviceOffer.startLocation.location.geolocation.elevation.value',
  'quotation.serviceOffer.startLocation.location.geolocation.latitude',
  'quotation.serviceOffer.startLocation.location.geolocation.latitude.unit',
  'quotation.serviceOffer.startLocation.location.geolocation.latitude.value',
  'quotation.serviceOffer.startLocation.location.geolocation.longitude',
  'quotation.serviceOffer.startLocation.location.geolocation.longitude.unit',
  'quotation.serviceOffer.startLocation.location.geolocation.longitude.value',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.stringValue',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.characteristicReference',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.numericalValue',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.numericalValue.unit',
  'quotation.serviceOffer.startLocation.location.specialCharacteristics.numericalValue.value',
  'quotation.serviceOffer.startLocation.location.specialInstructions',
  'quotation.serviceOffer.startLocation.location.specialInstructions.description',
  'quotation.serviceOffer.startLocation.location.specialInstructions.instructionCode',
  'quotation.serviceOffer.startLocation.appointmentTimeRange',
  'quotation.serviceOffer.startLocation.appointmentTimeRange.earliestDateTime',
  'quotation.serviceOffer.startLocation.appointmentTimeRange.latestDateTime',
  'quotation.serviceOffer.startLocation.requestedStartTimeRange',
  'quotation.serviceOffer.startLocation.requestedStartTimeRange.earliestDateTime',
  'quotation.serviceOffer.startLocation.requestedStartTimeRange.latestDateTime',
  'quotation.serviceOffer.startLocation.requestedEndTimeRange',
  'quotation.serviceOffer.startLocation.requestedEndTimeRange.earliestDateTime',
  'quotation.serviceOffer.startLocation.requestedEndTimeRange.latestDateTime',
  'quotation.serviceOffer.startLocation.plannedStartTimeRange',
  'quotation.serviceOffer.startLocation.plannedStartTimeRange.earliestDateTime',
  'quotation.serviceOffer.startLocation.plannedStartTimeRange.latestDateTime',
  'quotation.serviceOffer.startLocation.plannedEndTimeRange',
  'quotation.serviceOffer.startLocation.plannedEndTimeRange.earliestDateTime',
  'quotation.serviceOffer.startLocation.plannedEndTimeRange.latestDateTime',
  'quotation.serviceOffer.endLocation',
  'quotation.serviceOffer.endLocation.isAppointmentRequested',
  'quotation.serviceOffer.endLocation.actions',
  'quotation.serviceOffer.endLocation.actions.actionDateTime',
  'quotation.serviceOffer.endLocation.actions.actionName',
  'quotation.serviceOffer.endLocation.actions.sequenceNumber',
  'quotation.serviceOffer.endLocation.actions.actionState',
  'quotation.serviceOffer.endLocation.actions.actionType',
  'quotation.serviceOffer.endLocation.actions.actionSubtype',
  'quotation.serviceOffer.endLocation.actions.compositionMovements',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.containedObjects',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.container',
  'quotation.serviceOffer.endLocation.actions.compositionMovements.container.uri',
  'quotation.serviceOffer.endLocation.actions.sealNumber',
  'quotation.serviceOffer.endLocation.actions.sealedMaterialMean',
  'quotation.serviceOffer.endLocation.actions.sealedMaterialMean.uri',
  'quotation.serviceOffer.endLocation.actions.labelAssociations',
  'quotation.serviceOffer.endLocation.actions.labelAssociations.labelId',
  'quotation.serviceOffer.endLocation.actions.labelAssociations.labeledObject',
  'quotation.serviceOffer.endLocation.location',
  'quotation.serviceOffer.endLocation.location.locationName',
  'quotation.serviceOffer.endLocation.location.locationType',
  'quotation.serviceOffer.endLocation.location.code',
  'quotation.serviceOffer.endLocation.location.address',
  'quotation.serviceOffer.endLocation.location.address.addressLocality',
  'quotation.serviceOffer.endLocation.location.address.addressRegion',
  'quotation.serviceOffer.endLocation.location.address.postOfficeBoxNumber',
  'quotation.serviceOffer.endLocation.location.address.postalCode',
  'quotation.serviceOffer.endLocation.location.address.addressLines',
  'quotation.serviceOffer.endLocation.location.address.addressCountry',
  'quotation.serviceOffer.endLocation.location.address.addressCountry.countryCode',
  'quotation.serviceOffer.endLocation.location.address.addressCountry.countryName',
  'quotation.serviceOffer.endLocation.location.contacts',
  'quotation.serviceOffer.endLocation.location.contacts.email',
  'quotation.serviceOffer.endLocation.location.contacts.telephone',
  'quotation.serviceOffer.endLocation.location.contacts.persons',
  'quotation.serviceOffer.endLocation.location.contacts.persons.additionalName',
  'quotation.serviceOffer.endLocation.location.contacts.persons.email',
  'quotation.serviceOffer.endLocation.location.contacts.persons.familyName',
  'quotation.serviceOffer.endLocation.location.contacts.persons.faxNumber',
  'quotation.serviceOffer.endLocation.location.contacts.persons.givenName',
  'quotation.serviceOffer.endLocation.location.contacts.persons.idCardNumber',
  'quotation.serviceOffer.endLocation.location.contacts.persons.telephone',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.commercialName',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.legalEntityName',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.addressLocality',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.addressRegion',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.postalCode',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.addressLines',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.address.addressCountry',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.serviceOffer.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.serviceOffer.endLocation.location.contacts.role',
  'quotation.serviceOffer.endLocation.location.documents',
  'quotation.serviceOffer.endLocation.location.documents.cmsUri',
  'quotation.serviceOffer.endLocation.location.documents.documentName',
  'quotation.serviceOffer.endLocation.location.documents.format',
  'quotation.serviceOffer.endLocation.location.documents.isRequired',
  'quotation.serviceOffer.endLocation.location.documents.suppliedWithGoods',
  'quotation.serviceOffer.endLocation.location.documents.documentType',
  'quotation.serviceOffer.endLocation.location.documents.documentSubtype',
  'quotation.serviceOffer.endLocation.location.externalReferences',
  'quotation.serviceOffer.endLocation.location.externalReferences.description',
  'quotation.serviceOffer.endLocation.location.externalReferences.externalReferenceType',
  'quotation.serviceOffer.endLocation.location.externalReferences.reference',
  'quotation.serviceOffer.endLocation.location.geolocation',
  'quotation.serviceOffer.endLocation.location.geolocation.geolocationUnit',
  'quotation.serviceOffer.endLocation.location.geolocation.elevation',
  'quotation.serviceOffer.endLocation.location.geolocation.elevation.unit',
  'quotation.serviceOffer.endLocation.location.geolocation.elevation.value',
  'quotation.serviceOffer.endLocation.location.geolocation.latitude',
  'quotation.serviceOffer.endLocation.location.geolocation.latitude.unit',
  'quotation.serviceOffer.endLocation.location.geolocation.latitude.value',
  'quotation.serviceOffer.endLocation.location.geolocation.longitude',
  'quotation.serviceOffer.endLocation.location.geolocation.longitude.unit',
  'quotation.serviceOffer.endLocation.location.geolocation.longitude.value',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.stringValue',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.characteristicReference',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.numericalValue',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.numericalValue.unit',
  'quotation.serviceOffer.endLocation.location.specialCharacteristics.numericalValue.value',
  'quotation.serviceOffer.endLocation.location.specialInstructions',
  'quotation.serviceOffer.endLocation.location.specialInstructions.description',
  'quotation.serviceOffer.endLocation.location.specialInstructions.instructionCode',
  'quotation.serviceOffer.endLocation.appointmentTimeRange',
  'quotation.serviceOffer.endLocation.appointmentTimeRange.earliestDateTime',
  'quotation.serviceOffer.endLocation.appointmentTimeRange.latestDateTime',
  'quotation.serviceOffer.endLocation.requestedStartTimeRange',
  'quotation.serviceOffer.endLocation.requestedStartTimeRange.earliestDateTime',
  'quotation.serviceOffer.endLocation.requestedStartTimeRange.latestDateTime',
  'quotation.serviceOffer.endLocation.requestedEndTimeRange',
  'quotation.serviceOffer.endLocation.requestedEndTimeRange.earliestDateTime',
  'quotation.serviceOffer.endLocation.requestedEndTimeRange.latestDateTime',
  'quotation.serviceOffer.endLocation.plannedStartTimeRange',
  'quotation.serviceOffer.endLocation.plannedStartTimeRange.earliestDateTime',
  'quotation.serviceOffer.endLocation.plannedStartTimeRange.latestDateTime',
  'quotation.serviceOffer.endLocation.plannedEndTimeRange',
  'quotation.serviceOffer.endLocation.plannedEndTimeRange.earliestDateTime',
  'quotation.serviceOffer.endLocation.plannedEndTimeRange.latestDateTime',
  'quotation.serviceOffer.incoterm',
  'quotation.serviceOffer.saleOperations',
  'quotation.serviceOffer.saleOperations.isMandatory',
  'quotation.serviceOffer.saleOperations.isProposedByDefault',
  'quotation.serviceOffer.saleOperations.isSelected',
  'quotation.serviceOffer.saleOperations.operationDescription',
  'quotation.serviceOffer.saleOperations.operationName',
  'quotation.serviceOffer.saleOperations.operationCode',
  'quotation.serviceOffer.saleOperations.operationSubtype',
  'quotation.serviceOffer.saleOperations.operationType',
  'quotation.serviceOffer.saleOperations.amountExclTaxes',
  'quotation.serviceOffer.saleOperations.amountExclTaxes.unit',
  'quotation.serviceOffer.saleOperations.amountExclTaxes.value',
  'quotation.serviceOffer.saleOperations.amountInclTaxes',
  'quotation.serviceOffer.saleOperations.amountInclTaxes.unit',
  'quotation.serviceOffer.saleOperations.amountInclTaxes.value',
  'quotation.serviceOffer.saleOperations.requestedPrepaidAmount',
  'quotation.serviceOffer.saleOperations.requestedPrepaidAmount.unit',
  'quotation.serviceOffer.saleOperations.requestedPrepaidAmount.value',
  'quotation.serviceOffer.saleOperations.actualQuantity',
  'quotation.serviceOffer.saleOperations.actualQuantity.unit',
  'quotation.serviceOffer.saleOperations.actualQuantity.value',
  'quotation.serviceOffer.saleOperations.contacts',
  'quotation.serviceOffer.saleOperations.contacts.email',
  'quotation.serviceOffer.saleOperations.contacts.telephone',
  'quotation.serviceOffer.saleOperations.contacts.persons',
  'quotation.serviceOffer.saleOperations.contacts.persons.additionalName',
  'quotation.serviceOffer.saleOperations.contacts.persons.email',
  'quotation.serviceOffer.saleOperations.contacts.persons.familyName',
  'quotation.serviceOffer.saleOperations.contacts.persons.faxNumber',
  'quotation.serviceOffer.saleOperations.contacts.persons.givenName',
  'quotation.serviceOffer.saleOperations.contacts.persons.idCardNumber',
  'quotation.serviceOffer.saleOperations.contacts.persons.telephone',
  'quotation.serviceOffer.saleOperations.contacts.persons.party',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.commercialName',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.legalEntityName',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressLocality',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressRegion',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.postalCode',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressLines',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressCountry',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.address.addressCountry.countryName',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.companyRegistrationIds',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.serviceOffer.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.serviceOffer.saleOperations.contacts.role',
  'quotation.serviceOffer.saleOperations.documents',
  'quotation.serviceOffer.saleOperations.documents.cmsUri',
  'quotation.serviceOffer.saleOperations.documents.documentName',
  'quotation.serviceOffer.saleOperations.documents.format',
  'quotation.serviceOffer.saleOperations.documents.isRequired',
  'quotation.serviceOffer.saleOperations.documents.suppliedWithGoods',
  'quotation.serviceOffer.saleOperations.documents.documentType',
  'quotation.serviceOffer.saleOperations.documents.documentSubtype',
  'quotation.serviceOffer.saleOperations.externalReferences',
  'quotation.serviceOffer.saleOperations.externalReferences.description',
  'quotation.serviceOffer.saleOperations.externalReferences.externalReferenceType',
  'quotation.serviceOffer.saleOperations.externalReferences.reference',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.invoiceLineId',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.invoice',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.invoice.uri',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.quantity',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.quantity.unit',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.quantity.value',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.totalPrice',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.totalPrice.unit',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.totalPrice.value',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.unitPrice',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.unitPrice.unit',
  'quotation.serviceOffer.saleOperations.operationInvoicingDetails.unitPrice.value',
  'quotation.serviceOffer.saleOperations.plannedQuantity',
  'quotation.serviceOffer.saleOperations.plannedQuantity.unit',
  'quotation.serviceOffer.saleOperations.plannedQuantity.value',
  'quotation.serviceOffer.saleOperations.requestedQuantity',
  'quotation.serviceOffer.saleOperations.requestedQuantity.unit',
  'quotation.serviceOffer.saleOperations.requestedQuantity.value',
  'quotation.serviceOffer.saleOperations.unitPrice',
  'quotation.serviceOffer.saleOperations.unitPrice.unit',
  'quotation.serviceOffer.saleOperations.unitPrice.value',
  'quotation.serviceOffer.saleOperations.specialCharacteristics',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.stringValue',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.characteristicReference',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.specialCharacteristicType',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.numericalValue',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.numericalValue.unit',
  'quotation.serviceOffer.saleOperations.specialCharacteristics.numericalValue.value',
  'quotation.serviceOffer.saleOperations.specialInstructions',
  'quotation.serviceOffer.saleOperations.specialInstructions.description',
  'quotation.serviceOffer.saleOperations.specialInstructions.instructionCode',
  'quotation.serviceOffer.provider',
  'quotation.serviceOffer.provider.commercialName',
  'quotation.serviceOffer.provider.legalEntityName',
  'quotation.serviceOffer.provider.address',
  'quotation.serviceOffer.provider.address.addressLocality',
  'quotation.serviceOffer.provider.address.addressRegion',
  'quotation.serviceOffer.provider.address.postOfficeBoxNumber',
  'quotation.serviceOffer.provider.address.postalCode',
  'quotation.serviceOffer.provider.address.addressLines',
  'quotation.serviceOffer.provider.address.addressCountry',
  'quotation.serviceOffer.provider.address.addressCountry.countryCode',
  'quotation.serviceOffer.provider.address.addressCountry.countryName',
  'quotation.serviceOffer.provider.companyRegistrationIds',
  'quotation.serviceOffer.provider.companyRegistrationIds.companyRegistrationIdType',
  'quotation.serviceOffer.provider.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.serviceOffer.quotationRequest',
  'quotation.serviceOffer.quotationRequest.uri',
  'quotation.serviceOffer.carbonFootprint',
  'quotation.serviceOffer.carbonFootprint.unit',
  'quotation.serviceOffer.carbonFootprint.value',
  'quotation.serviceOffer.specialInstructions',
  'quotation.serviceOffer.specialInstructions.description',
  'quotation.serviceOffer.specialInstructions.instructionCode',
  'quotation.serviceOffer.specialCharacteristics',
  'quotation.serviceOffer.specialCharacteristics.stringValue',
  'quotation.serviceOffer.specialCharacteristics.characteristicReference',
  'quotation.serviceOffer.specialCharacteristics.specialCharacteristicType',
  'quotation.serviceOffer.specialCharacteristics.numericalValue',
  'quotation.serviceOffer.specialCharacteristics.numericalValue.unit',
  'quotation.serviceOffer.specialCharacteristics.numericalValue.value',
  'quotation.serviceOffer.externalReferences',
  'quotation.serviceOffer.externalReferences.description',
  'quotation.serviceOffer.externalReferences.externalReferenceType',
  'quotation.serviceOffer.externalReferences.reference',
  'quotation.serviceOffer.documents',
  'quotation.serviceOffer.documents.cmsUri',
  'quotation.serviceOffer.documents.documentName',
  'quotation.serviceOffer.documents.format',
  'quotation.serviceOffer.documents.isRequired',
  'quotation.serviceOffer.documents.suppliedWithGoods',
  'quotation.serviceOffer.documents.documentType',
  'quotation.serviceOffer.documents.documentSubtype',
  'quotation.serviceOffer.contacts',
  'quotation.serviceOffer.contacts.email',
  'quotation.serviceOffer.contacts.telephone',
  'quotation.serviceOffer.contacts.persons',
  'quotation.serviceOffer.contacts.persons.additionalName',
  'quotation.serviceOffer.contacts.persons.email',
  'quotation.serviceOffer.contacts.persons.familyName',
  'quotation.serviceOffer.contacts.persons.faxNumber',
  'quotation.serviceOffer.contacts.persons.givenName',
  'quotation.serviceOffer.contacts.persons.idCardNumber',
  'quotation.serviceOffer.contacts.persons.telephone',
  'quotation.serviceOffer.contacts.persons.party',
  'quotation.serviceOffer.contacts.persons.party.commercialName',
  'quotation.serviceOffer.contacts.persons.party.legalEntityName',
  'quotation.serviceOffer.contacts.persons.party.address',
  'quotation.serviceOffer.contacts.persons.party.address.addressLocality',
  'quotation.serviceOffer.contacts.persons.party.address.addressRegion',
  'quotation.serviceOffer.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.serviceOffer.contacts.persons.party.address.postalCode',
  'quotation.serviceOffer.contacts.persons.party.address.addressLines',
  'quotation.serviceOffer.contacts.persons.party.address.addressCountry',
  'quotation.serviceOffer.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.serviceOffer.contacts.persons.party.address.addressCountry.countryName',
  'quotation.serviceOffer.contacts.persons.party.companyRegistrationIds',
  'quotation.serviceOffer.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.serviceOffer.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.serviceOffer.contacts.role',
  'quotation.serviceOffer.id',
  'quotation.quotationRequest',
  'quotation.quotationRequest.uri',
  'quotation.quotationProcess',
  'quotation.declaredValue',
  'quotation.declaredValue.unit',
  'quotation.declaredValue.value',
  'quotation.batchesOfGoods',
  'quotation.batchesOfGoods.codePackaging',
  'quotation.batchesOfGoods.containerSubtype',
  'quotation.batchesOfGoods.containerType',
  'quotation.batchesOfGoods.dimensions',
  'quotation.batchesOfGoods.dimensions.height',
  'quotation.batchesOfGoods.dimensions.height.unit',
  'quotation.batchesOfGoods.dimensions.height.value',
  'quotation.batchesOfGoods.dimensions.length',
  'quotation.batchesOfGoods.dimensions.length.unit',
  'quotation.batchesOfGoods.dimensions.length.value',
  'quotation.batchesOfGoods.dimensions.volume',
  'quotation.batchesOfGoods.dimensions.volume.unit',
  'quotation.batchesOfGoods.dimensions.volume.value',
  'quotation.batchesOfGoods.dimensions.width',
  'quotation.batchesOfGoods.dimensions.width.unit',
  'quotation.batchesOfGoods.dimensions.width.value',
  'quotation.batchesOfGoods.product',
  'quotation.batchesOfGoods.product.commodityName',
  'quotation.batchesOfGoods.product.hsCode',
  'quotation.batchesOfGoods.product.hsCommodityDescription',
  'quotation.batchesOfGoods.product.hsCommodityName',
  'quotation.batchesOfGoods.product.hsType',
  'quotation.batchesOfGoods.product.productDescription',
  'quotation.batchesOfGoods.product.productIdentifier',
  'quotation.batchesOfGoods.product.contacts',
  'quotation.batchesOfGoods.product.contacts.email',
  'quotation.batchesOfGoods.product.contacts.telephone',
  'quotation.batchesOfGoods.product.contacts.persons',
  'quotation.batchesOfGoods.product.contacts.persons.additionalName',
  'quotation.batchesOfGoods.product.contacts.persons.email',
  'quotation.batchesOfGoods.product.contacts.persons.familyName',
  'quotation.batchesOfGoods.product.contacts.persons.faxNumber',
  'quotation.batchesOfGoods.product.contacts.persons.givenName',
  'quotation.batchesOfGoods.product.contacts.persons.idCardNumber',
  'quotation.batchesOfGoods.product.contacts.persons.telephone',
  'quotation.batchesOfGoods.product.contacts.persons.party',
  'quotation.batchesOfGoods.product.contacts.persons.party.commercialName',
  'quotation.batchesOfGoods.product.contacts.persons.party.legalEntityName',
  'quotation.batchesOfGoods.product.contacts.persons.party.address',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressLocality',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressRegion',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.postalCode',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressLines',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressCountry',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.batchesOfGoods.product.contacts.persons.party.address.addressCountry.countryName',
  'quotation.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds',
  'quotation.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.batchesOfGoods.product.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.batchesOfGoods.product.contacts.role',
  'quotation.batchesOfGoods.product.documents',
  'quotation.batchesOfGoods.product.documents.cmsUri',
  'quotation.batchesOfGoods.product.documents.documentName',
  'quotation.batchesOfGoods.product.documents.format',
  'quotation.batchesOfGoods.product.documents.isRequired',
  'quotation.batchesOfGoods.product.documents.suppliedWithGoods',
  'quotation.batchesOfGoods.product.documents.documentType',
  'quotation.batchesOfGoods.product.documents.documentSubtype',
  'quotation.batchesOfGoods.product.externalReferences',
  'quotation.batchesOfGoods.product.externalReferences.description',
  'quotation.batchesOfGoods.product.externalReferences.externalReferenceType',
  'quotation.batchesOfGoods.product.externalReferences.reference',
  'quotation.batchesOfGoods.product.specialCharacteristics',
  'quotation.batchesOfGoods.product.specialCharacteristics.stringValue',
  'quotation.batchesOfGoods.product.specialCharacteristics.characteristicReference',
  'quotation.batchesOfGoods.product.specialCharacteristics.specialCharacteristicType',
  'quotation.batchesOfGoods.product.specialCharacteristics.numericalValue',
  'quotation.batchesOfGoods.product.specialCharacteristics.numericalValue.unit',
  'quotation.batchesOfGoods.product.specialCharacteristics.numericalValue.value',
  'quotation.batchesOfGoods.product.specialInstructions',
  'quotation.batchesOfGoods.product.specialInstructions.description',
  'quotation.batchesOfGoods.product.specialInstructions.instructionCode',
  'quotation.batchesOfGoods.specialRegulations',
  'quotation.batchesOfGoods.specialRegulations.specialRegulationType',
  'quotation.batchesOfGoods.specialRegulations.productClass',
  'quotation.batchesOfGoods.specialRegulations.productUNCode',
  'quotation.batchesOfGoods.specialRegulations.productPackingGroup',
  'quotation.batchesOfGoods.quantity',
  'quotation.batchesOfGoods.quantity.unit',
  'quotation.batchesOfGoods.quantity.value',
  'quotation.batchesOfGoods.weight',
  'quotation.batchesOfGoods.weight.unit',
  'quotation.batchesOfGoods.weight.value',
  'quotation.batchesOfGoods.declaredValue',
  'quotation.batchesOfGoods.declaredValue.unit',
  'quotation.batchesOfGoods.declaredValue.value',
  'quotation.saleOperations',
  'quotation.saleOperations.isMandatory',
  'quotation.saleOperations.isProposedByDefault',
  'quotation.saleOperations.isSelected',
  'quotation.saleOperations.operationDescription',
  'quotation.saleOperations.operationName',
  'quotation.saleOperations.operationCode',
  'quotation.saleOperations.operationSubtype',
  'quotation.saleOperations.operationType',
  'quotation.saleOperations.amountExclTaxes',
  'quotation.saleOperations.amountExclTaxes.unit',
  'quotation.saleOperations.amountExclTaxes.value',
  'quotation.saleOperations.amountInclTaxes',
  'quotation.saleOperations.amountInclTaxes.unit',
  'quotation.saleOperations.amountInclTaxes.value',
  'quotation.saleOperations.requestedPrepaidAmount',
  'quotation.saleOperations.requestedPrepaidAmount.unit',
  'quotation.saleOperations.requestedPrepaidAmount.value',
  'quotation.saleOperations.actualQuantity',
  'quotation.saleOperations.actualQuantity.unit',
  'quotation.saleOperations.actualQuantity.value',
  'quotation.saleOperations.contacts',
  'quotation.saleOperations.contacts.email',
  'quotation.saleOperations.contacts.telephone',
  'quotation.saleOperations.contacts.persons',
  'quotation.saleOperations.contacts.persons.additionalName',
  'quotation.saleOperations.contacts.persons.email',
  'quotation.saleOperations.contacts.persons.familyName',
  'quotation.saleOperations.contacts.persons.faxNumber',
  'quotation.saleOperations.contacts.persons.givenName',
  'quotation.saleOperations.contacts.persons.idCardNumber',
  'quotation.saleOperations.contacts.persons.telephone',
  'quotation.saleOperations.contacts.persons.party',
  'quotation.saleOperations.contacts.persons.party.commercialName',
  'quotation.saleOperations.contacts.persons.party.legalEntityName',
  'quotation.saleOperations.contacts.persons.party.address',
  'quotation.saleOperations.contacts.persons.party.address.addressLocality',
  'quotation.saleOperations.contacts.persons.party.address.addressRegion',
  'quotation.saleOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'quotation.saleOperations.contacts.persons.party.address.postalCode',
  'quotation.saleOperations.contacts.persons.party.address.addressLines',
  'quotation.saleOperations.contacts.persons.party.address.addressCountry',
  'quotation.saleOperations.contacts.persons.party.address.addressCountry.countryCode',
  'quotation.saleOperations.contacts.persons.party.address.addressCountry.countryName',
  'quotation.saleOperations.contacts.persons.party.companyRegistrationIds',
  'quotation.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'quotation.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.saleOperations.contacts.role',
  'quotation.saleOperations.documents',
  'quotation.saleOperations.documents.cmsUri',
  'quotation.saleOperations.documents.documentName',
  'quotation.saleOperations.documents.format',
  'quotation.saleOperations.documents.isRequired',
  'quotation.saleOperations.documents.suppliedWithGoods',
  'quotation.saleOperations.documents.documentType',
  'quotation.saleOperations.documents.documentSubtype',
  'quotation.saleOperations.externalReferences',
  'quotation.saleOperations.externalReferences.description',
  'quotation.saleOperations.externalReferences.externalReferenceType',
  'quotation.saleOperations.externalReferences.reference',
  'quotation.saleOperations.operationInvoicingDetails',
  'quotation.saleOperations.operationInvoicingDetails.invoiceLineId',
  'quotation.saleOperations.operationInvoicingDetails.invoice',
  'quotation.saleOperations.operationInvoicingDetails.invoice.uri',
  'quotation.saleOperations.operationInvoicingDetails.quantity',
  'quotation.saleOperations.operationInvoicingDetails.quantity.unit',
  'quotation.saleOperations.operationInvoicingDetails.quantity.value',
  'quotation.saleOperations.operationInvoicingDetails.totalPrice',
  'quotation.saleOperations.operationInvoicingDetails.totalPrice.unit',
  'quotation.saleOperations.operationInvoicingDetails.totalPrice.value',
  'quotation.saleOperations.operationInvoicingDetails.unitPrice',
  'quotation.saleOperations.operationInvoicingDetails.unitPrice.unit',
  'quotation.saleOperations.operationInvoicingDetails.unitPrice.value',
  'quotation.saleOperations.plannedQuantity',
  'quotation.saleOperations.plannedQuantity.unit',
  'quotation.saleOperations.plannedQuantity.value',
  'quotation.saleOperations.requestedQuantity',
  'quotation.saleOperations.requestedQuantity.unit',
  'quotation.saleOperations.requestedQuantity.value',
  'quotation.saleOperations.unitPrice',
  'quotation.saleOperations.unitPrice.unit',
  'quotation.saleOperations.unitPrice.value',
  'quotation.saleOperations.specialCharacteristics',
  'quotation.saleOperations.specialCharacteristics.stringValue',
  'quotation.saleOperations.specialCharacteristics.characteristicReference',
  'quotation.saleOperations.specialCharacteristics.specialCharacteristicType',
  'quotation.saleOperations.specialCharacteristics.numericalValue',
  'quotation.saleOperations.specialCharacteristics.numericalValue.unit',
  'quotation.saleOperations.specialCharacteristics.numericalValue.value',
  'quotation.saleOperations.specialInstructions',
  'quotation.saleOperations.specialInstructions.description',
  'quotation.saleOperations.specialInstructions.instructionCode',
  'quotation.incoterm',
  'quotation.quotationStatus',
  'quotation.requestedPrepaidAmount',
  'quotation.requestedPrepaidAmount.unit',
  'quotation.requestedPrepaidAmount.value',
  'quotation.prepaidAmount',
  'quotation.prepaidAmount.unit',
  'quotation.prepaidAmount.value',
  'quotation.specialInstructions',
  'quotation.specialInstructions.description',
  'quotation.specialInstructions.instructionCode',
  'quotation.specialCharacteristics',
  'quotation.specialCharacteristics.stringValue',
  'quotation.specialCharacteristics.characteristicReference',
  'quotation.specialCharacteristics.specialCharacteristicType',
  'quotation.specialCharacteristics.numericalValue',
  'quotation.specialCharacteristics.numericalValue.unit',
  'quotation.specialCharacteristics.numericalValue.value',
  'quotation.documents',
  'quotation.documents.cmsUri',
  'quotation.documents.documentName',
  'quotation.documents.format',
  'quotation.documents.isRequired',
  'quotation.documents.suppliedWithGoods',
  'quotation.documents.documentType',
  'quotation.documents.documentSubtype',
  'quotation.externalReferences',
  'quotation.externalReferences.description',
  'quotation.externalReferences.externalReferenceType',
  'quotation.externalReferences.reference',
  'quotation.carbonFootprint',
  'quotation.carbonFootprint.unit',
  'quotation.carbonFootprint.value',
  'quotation.issuer',
  'quotation.issuer.commercialName',
  'quotation.issuer.legalEntityName',
  'quotation.issuer.address',
  'quotation.issuer.address.addressLocality',
  'quotation.issuer.address.addressRegion',
  'quotation.issuer.address.postOfficeBoxNumber',
  'quotation.issuer.address.postalCode',
  'quotation.issuer.address.addressLines',
  'quotation.issuer.address.addressCountry',
  'quotation.issuer.address.addressCountry.countryCode',
  'quotation.issuer.address.addressCountry.countryName',
  'quotation.issuer.companyRegistrationIds',
  'quotation.issuer.companyRegistrationIds.companyRegistrationIdType',
  'quotation.issuer.companyRegistrationIds.companyRegistrationIdValue',
  'quotation.rejections',
  'quotation.rejections.code',
  'quotation.rejections.detail',
  'quotation.rejections.title',
  'quotation.totalAmountDue',
  'quotation.totalAmountDue.unit',
  'quotation.totalAmountDue.value',
  'quotation.financialSummary',
  'quotation.financialSummary.totalAmountTaxExcluded',
  'quotation.financialSummary.totalAmountTaxExcluded.unit',
  'quotation.financialSummary.totalAmountTaxExcluded.value',
  'quotation.financialSummary.totalAmountTaxIncluded',
  'quotation.financialSummary.totalAmountTaxIncluded.unit',
  'quotation.financialSummary.totalAmountTaxIncluded.value',
  'quotation.financialSummary.totalTaxAmount',
  'quotation.financialSummary.totalTaxAmount.unit',
  'quotation.financialSummary.totalTaxAmount.value',
  'quotation.financialSummary.totalAmountDue',
  'quotation.financialSummary.totalAmountDue.unit',
  'quotation.financialSummary.totalAmountDue.value',
  'quotation.paymentStatus',
  'quotation.id',
] as const;

/**
 * Field paths for ServiceRequest
 * Total: 645 paths
 */
export const SERVICE_REQUEST_FIELD_PATHS = [
  'serviceRequest.isDangerous',
  'serviceRequest.productDescription',
  'serviceRequest.requestDateTime',
  'serviceRequest.requestStatus',
  'serviceRequest.responseDateTime',
  'serviceRequest.responseStatus',
  'serviceRequest.serviceAgreementReference',
  'serviceRequest.serviceDescription',
  'serviceRequest.serviceName',
  'serviceRequest.serviceNature',
  'serviceRequest.serviceSubtype',
  'serviceRequest.serviceType',
  'serviceRequest.incoterm',
  'serviceRequest.consignments',
  'serviceRequest.consignments.uri',
  'serviceRequest.startLocation',
  'serviceRequest.startLocation.isAppointmentRequested',
  'serviceRequest.startLocation.actions',
  'serviceRequest.startLocation.actions.actionDateTime',
  'serviceRequest.startLocation.actions.actionName',
  'serviceRequest.startLocation.actions.sequenceNumber',
  'serviceRequest.startLocation.actions.actionState',
  'serviceRequest.startLocation.actions.actionType',
  'serviceRequest.startLocation.actions.actionSubtype',
  'serviceRequest.startLocation.actions.compositionMovements',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'serviceRequest.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'serviceRequest.startLocation.actions.compositionMovements.containedObjects',
  'serviceRequest.startLocation.actions.compositionMovements.container',
  'serviceRequest.startLocation.actions.compositionMovements.container.uri',
  'serviceRequest.startLocation.actions.sealNumber',
  'serviceRequest.startLocation.actions.sealedMaterialMean',
  'serviceRequest.startLocation.actions.sealedMaterialMean.uri',
  'serviceRequest.startLocation.actions.labelAssociations',
  'serviceRequest.startLocation.actions.labelAssociations.labelId',
  'serviceRequest.startLocation.actions.labelAssociations.labeledObject',
  'serviceRequest.startLocation.location',
  'serviceRequest.startLocation.location.locationName',
  'serviceRequest.startLocation.location.locationType',
  'serviceRequest.startLocation.location.code',
  'serviceRequest.startLocation.location.address',
  'serviceRequest.startLocation.location.address.addressLocality',
  'serviceRequest.startLocation.location.address.addressRegion',
  'serviceRequest.startLocation.location.address.postOfficeBoxNumber',
  'serviceRequest.startLocation.location.address.postalCode',
  'serviceRequest.startLocation.location.address.addressLines',
  'serviceRequest.startLocation.location.address.addressCountry',
  'serviceRequest.startLocation.location.address.addressCountry.countryCode',
  'serviceRequest.startLocation.location.address.addressCountry.countryName',
  'serviceRequest.startLocation.location.contacts',
  'serviceRequest.startLocation.location.contacts.email',
  'serviceRequest.startLocation.location.contacts.telephone',
  'serviceRequest.startLocation.location.contacts.persons',
  'serviceRequest.startLocation.location.contacts.persons.additionalName',
  'serviceRequest.startLocation.location.contacts.persons.email',
  'serviceRequest.startLocation.location.contacts.persons.familyName',
  'serviceRequest.startLocation.location.contacts.persons.faxNumber',
  'serviceRequest.startLocation.location.contacts.persons.givenName',
  'serviceRequest.startLocation.location.contacts.persons.idCardNumber',
  'serviceRequest.startLocation.location.contacts.persons.telephone',
  'serviceRequest.startLocation.location.contacts.persons.party',
  'serviceRequest.startLocation.location.contacts.persons.party.commercialName',
  'serviceRequest.startLocation.location.contacts.persons.party.legalEntityName',
  'serviceRequest.startLocation.location.contacts.persons.party.address',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressLocality',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressRegion',
  'serviceRequest.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.startLocation.location.contacts.persons.party.address.postalCode',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressLines',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressCountry',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.startLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.startLocation.location.contacts.role',
  'serviceRequest.startLocation.location.documents',
  'serviceRequest.startLocation.location.documents.cmsUri',
  'serviceRequest.startLocation.location.documents.documentName',
  'serviceRequest.startLocation.location.documents.format',
  'serviceRequest.startLocation.location.documents.isRequired',
  'serviceRequest.startLocation.location.documents.suppliedWithGoods',
  'serviceRequest.startLocation.location.documents.documentType',
  'serviceRequest.startLocation.location.documents.documentSubtype',
  'serviceRequest.startLocation.location.externalReferences',
  'serviceRequest.startLocation.location.externalReferences.description',
  'serviceRequest.startLocation.location.externalReferences.externalReferenceType',
  'serviceRequest.startLocation.location.externalReferences.reference',
  'serviceRequest.startLocation.location.geolocation',
  'serviceRequest.startLocation.location.geolocation.geolocationUnit',
  'serviceRequest.startLocation.location.geolocation.elevation',
  'serviceRequest.startLocation.location.geolocation.elevation.unit',
  'serviceRequest.startLocation.location.geolocation.elevation.value',
  'serviceRequest.startLocation.location.geolocation.latitude',
  'serviceRequest.startLocation.location.geolocation.latitude.unit',
  'serviceRequest.startLocation.location.geolocation.latitude.value',
  'serviceRequest.startLocation.location.geolocation.longitude',
  'serviceRequest.startLocation.location.geolocation.longitude.unit',
  'serviceRequest.startLocation.location.geolocation.longitude.value',
  'serviceRequest.startLocation.location.specialCharacteristics',
  'serviceRequest.startLocation.location.specialCharacteristics.stringValue',
  'serviceRequest.startLocation.location.specialCharacteristics.characteristicReference',
  'serviceRequest.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.startLocation.location.specialCharacteristics.numericalValue',
  'serviceRequest.startLocation.location.specialCharacteristics.numericalValue.unit',
  'serviceRequest.startLocation.location.specialCharacteristics.numericalValue.value',
  'serviceRequest.startLocation.location.specialInstructions',
  'serviceRequest.startLocation.location.specialInstructions.description',
  'serviceRequest.startLocation.location.specialInstructions.instructionCode',
  'serviceRequest.startLocation.appointmentTimeRange',
  'serviceRequest.startLocation.appointmentTimeRange.earliestDateTime',
  'serviceRequest.startLocation.appointmentTimeRange.latestDateTime',
  'serviceRequest.startLocation.actualStartDateTime',
  'serviceRequest.startLocation.actualEndDateTime',
  'serviceRequest.startLocation.requestedStartTimeRange',
  'serviceRequest.startLocation.requestedStartTimeRange.earliestDateTime',
  'serviceRequest.startLocation.requestedStartTimeRange.latestDateTime',
  'serviceRequest.startLocation.requestedEndTimeRange',
  'serviceRequest.startLocation.requestedEndTimeRange.earliestDateTime',
  'serviceRequest.startLocation.requestedEndTimeRange.latestDateTime',
  'serviceRequest.startLocation.plannedStartTimeRange',
  'serviceRequest.startLocation.plannedStartTimeRange.earliestDateTime',
  'serviceRequest.startLocation.plannedStartTimeRange.latestDateTime',
  'serviceRequest.startLocation.plannedEndTimeRange',
  'serviceRequest.startLocation.plannedEndTimeRange.earliestDateTime',
  'serviceRequest.startLocation.plannedEndTimeRange.latestDateTime',
  'serviceRequest.endLocation',
  'serviceRequest.endLocation.isAppointmentRequested',
  'serviceRequest.endLocation.actions',
  'serviceRequest.endLocation.actions.actionDateTime',
  'serviceRequest.endLocation.actions.actionName',
  'serviceRequest.endLocation.actions.sequenceNumber',
  'serviceRequest.endLocation.actions.actionState',
  'serviceRequest.endLocation.actions.actionType',
  'serviceRequest.endLocation.actions.actionSubtype',
  'serviceRequest.endLocation.actions.compositionMovements',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'serviceRequest.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'serviceRequest.endLocation.actions.compositionMovements.containedObjects',
  'serviceRequest.endLocation.actions.compositionMovements.container',
  'serviceRequest.endLocation.actions.compositionMovements.container.uri',
  'serviceRequest.endLocation.actions.sealNumber',
  'serviceRequest.endLocation.actions.sealedMaterialMean',
  'serviceRequest.endLocation.actions.sealedMaterialMean.uri',
  'serviceRequest.endLocation.actions.labelAssociations',
  'serviceRequest.endLocation.actions.labelAssociations.labelId',
  'serviceRequest.endLocation.actions.labelAssociations.labeledObject',
  'serviceRequest.endLocation.location',
  'serviceRequest.endLocation.location.locationName',
  'serviceRequest.endLocation.location.locationType',
  'serviceRequest.endLocation.location.code',
  'serviceRequest.endLocation.location.address',
  'serviceRequest.endLocation.location.address.addressLocality',
  'serviceRequest.endLocation.location.address.addressRegion',
  'serviceRequest.endLocation.location.address.postOfficeBoxNumber',
  'serviceRequest.endLocation.location.address.postalCode',
  'serviceRequest.endLocation.location.address.addressLines',
  'serviceRequest.endLocation.location.address.addressCountry',
  'serviceRequest.endLocation.location.address.addressCountry.countryCode',
  'serviceRequest.endLocation.location.address.addressCountry.countryName',
  'serviceRequest.endLocation.location.contacts',
  'serviceRequest.endLocation.location.contacts.email',
  'serviceRequest.endLocation.location.contacts.telephone',
  'serviceRequest.endLocation.location.contacts.persons',
  'serviceRequest.endLocation.location.contacts.persons.additionalName',
  'serviceRequest.endLocation.location.contacts.persons.email',
  'serviceRequest.endLocation.location.contacts.persons.familyName',
  'serviceRequest.endLocation.location.contacts.persons.faxNumber',
  'serviceRequest.endLocation.location.contacts.persons.givenName',
  'serviceRequest.endLocation.location.contacts.persons.idCardNumber',
  'serviceRequest.endLocation.location.contacts.persons.telephone',
  'serviceRequest.endLocation.location.contacts.persons.party',
  'serviceRequest.endLocation.location.contacts.persons.party.commercialName',
  'serviceRequest.endLocation.location.contacts.persons.party.legalEntityName',
  'serviceRequest.endLocation.location.contacts.persons.party.address',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressLocality',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressRegion',
  'serviceRequest.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.endLocation.location.contacts.persons.party.address.postalCode',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressLines',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressCountry',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.endLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.endLocation.location.contacts.role',
  'serviceRequest.endLocation.location.documents',
  'serviceRequest.endLocation.location.documents.cmsUri',
  'serviceRequest.endLocation.location.documents.documentName',
  'serviceRequest.endLocation.location.documents.format',
  'serviceRequest.endLocation.location.documents.isRequired',
  'serviceRequest.endLocation.location.documents.suppliedWithGoods',
  'serviceRequest.endLocation.location.documents.documentType',
  'serviceRequest.endLocation.location.documents.documentSubtype',
  'serviceRequest.endLocation.location.externalReferences',
  'serviceRequest.endLocation.location.externalReferences.description',
  'serviceRequest.endLocation.location.externalReferences.externalReferenceType',
  'serviceRequest.endLocation.location.externalReferences.reference',
  'serviceRequest.endLocation.location.geolocation',
  'serviceRequest.endLocation.location.geolocation.geolocationUnit',
  'serviceRequest.endLocation.location.geolocation.elevation',
  'serviceRequest.endLocation.location.geolocation.elevation.unit',
  'serviceRequest.endLocation.location.geolocation.elevation.value',
  'serviceRequest.endLocation.location.geolocation.latitude',
  'serviceRequest.endLocation.location.geolocation.latitude.unit',
  'serviceRequest.endLocation.location.geolocation.latitude.value',
  'serviceRequest.endLocation.location.geolocation.longitude',
  'serviceRequest.endLocation.location.geolocation.longitude.unit',
  'serviceRequest.endLocation.location.geolocation.longitude.value',
  'serviceRequest.endLocation.location.specialCharacteristics',
  'serviceRequest.endLocation.location.specialCharacteristics.stringValue',
  'serviceRequest.endLocation.location.specialCharacteristics.characteristicReference',
  'serviceRequest.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.endLocation.location.specialCharacteristics.numericalValue',
  'serviceRequest.endLocation.location.specialCharacteristics.numericalValue.unit',
  'serviceRequest.endLocation.location.specialCharacteristics.numericalValue.value',
  'serviceRequest.endLocation.location.specialInstructions',
  'serviceRequest.endLocation.location.specialInstructions.description',
  'serviceRequest.endLocation.location.specialInstructions.instructionCode',
  'serviceRequest.endLocation.appointmentTimeRange',
  'serviceRequest.endLocation.appointmentTimeRange.earliestDateTime',
  'serviceRequest.endLocation.appointmentTimeRange.latestDateTime',
  'serviceRequest.endLocation.actualStartDateTime',
  'serviceRequest.endLocation.actualEndDateTime',
  'serviceRequest.endLocation.requestedStartTimeRange',
  'serviceRequest.endLocation.requestedStartTimeRange.earliestDateTime',
  'serviceRequest.endLocation.requestedStartTimeRange.latestDateTime',
  'serviceRequest.endLocation.requestedEndTimeRange',
  'serviceRequest.endLocation.requestedEndTimeRange.earliestDateTime',
  'serviceRequest.endLocation.requestedEndTimeRange.latestDateTime',
  'serviceRequest.endLocation.plannedStartTimeRange',
  'serviceRequest.endLocation.plannedStartTimeRange.earliestDateTime',
  'serviceRequest.endLocation.plannedStartTimeRange.latestDateTime',
  'serviceRequest.endLocation.plannedEndTimeRange',
  'serviceRequest.endLocation.plannedEndTimeRange.earliestDateTime',
  'serviceRequest.endLocation.plannedEndTimeRange.latestDateTime',
  'serviceRequest.requestedActivities',
  'serviceRequest.requestedActivities.uri',
  'serviceRequest.contacts',
  'serviceRequest.contacts.email',
  'serviceRequest.contacts.telephone',
  'serviceRequest.contacts.persons',
  'serviceRequest.contacts.persons.additionalName',
  'serviceRequest.contacts.persons.email',
  'serviceRequest.contacts.persons.familyName',
  'serviceRequest.contacts.persons.faxNumber',
  'serviceRequest.contacts.persons.givenName',
  'serviceRequest.contacts.persons.idCardNumber',
  'serviceRequest.contacts.persons.telephone',
  'serviceRequest.contacts.persons.party',
  'serviceRequest.contacts.persons.party.commercialName',
  'serviceRequest.contacts.persons.party.legalEntityName',
  'serviceRequest.contacts.persons.party.address',
  'serviceRequest.contacts.persons.party.address.addressLocality',
  'serviceRequest.contacts.persons.party.address.addressRegion',
  'serviceRequest.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.contacts.persons.party.address.postalCode',
  'serviceRequest.contacts.persons.party.address.addressLines',
  'serviceRequest.contacts.persons.party.address.addressCountry',
  'serviceRequest.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.contacts.role',
  'serviceRequest.documents',
  'serviceRequest.documents.cmsUri',
  'serviceRequest.documents.documentName',
  'serviceRequest.documents.format',
  'serviceRequest.documents.isRequired',
  'serviceRequest.documents.suppliedWithGoods',
  'serviceRequest.documents.documentType',
  'serviceRequest.documents.documentSubtype',
  'serviceRequest.externalReferences',
  'serviceRequest.externalReferences.description',
  'serviceRequest.externalReferences.externalReferenceType',
  'serviceRequest.externalReferences.reference',
  'serviceRequest.finalLocation',
  'serviceRequest.finalLocation.locationName',
  'serviceRequest.finalLocation.locationType',
  'serviceRequest.finalLocation.code',
  'serviceRequest.finalLocation.address',
  'serviceRequest.finalLocation.address.addressLocality',
  'serviceRequest.finalLocation.address.addressRegion',
  'serviceRequest.finalLocation.address.postOfficeBoxNumber',
  'serviceRequest.finalLocation.address.postalCode',
  'serviceRequest.finalLocation.address.addressLines',
  'serviceRequest.finalLocation.address.addressCountry',
  'serviceRequest.finalLocation.address.addressCountry.countryCode',
  'serviceRequest.finalLocation.address.addressCountry.countryName',
  'serviceRequest.finalLocation.contacts',
  'serviceRequest.finalLocation.contacts.email',
  'serviceRequest.finalLocation.contacts.telephone',
  'serviceRequest.finalLocation.contacts.persons',
  'serviceRequest.finalLocation.contacts.persons.additionalName',
  'serviceRequest.finalLocation.contacts.persons.email',
  'serviceRequest.finalLocation.contacts.persons.familyName',
  'serviceRequest.finalLocation.contacts.persons.faxNumber',
  'serviceRequest.finalLocation.contacts.persons.givenName',
  'serviceRequest.finalLocation.contacts.persons.idCardNumber',
  'serviceRequest.finalLocation.contacts.persons.telephone',
  'serviceRequest.finalLocation.contacts.persons.party',
  'serviceRequest.finalLocation.contacts.persons.party.commercialName',
  'serviceRequest.finalLocation.contacts.persons.party.legalEntityName',
  'serviceRequest.finalLocation.contacts.persons.party.address',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressLocality',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressRegion',
  'serviceRequest.finalLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.finalLocation.contacts.persons.party.address.postalCode',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressLines',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressCountry',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.finalLocation.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.finalLocation.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.finalLocation.contacts.role',
  'serviceRequest.finalLocation.documents',
  'serviceRequest.finalLocation.documents.cmsUri',
  'serviceRequest.finalLocation.documents.documentName',
  'serviceRequest.finalLocation.documents.format',
  'serviceRequest.finalLocation.documents.isRequired',
  'serviceRequest.finalLocation.documents.suppliedWithGoods',
  'serviceRequest.finalLocation.documents.documentType',
  'serviceRequest.finalLocation.documents.documentSubtype',
  'serviceRequest.finalLocation.externalReferences',
  'serviceRequest.finalLocation.externalReferences.description',
  'serviceRequest.finalLocation.externalReferences.externalReferenceType',
  'serviceRequest.finalLocation.externalReferences.reference',
  'serviceRequest.finalLocation.geolocation',
  'serviceRequest.finalLocation.geolocation.geolocationUnit',
  'serviceRequest.finalLocation.geolocation.elevation',
  'serviceRequest.finalLocation.geolocation.elevation.unit',
  'serviceRequest.finalLocation.geolocation.elevation.value',
  'serviceRequest.finalLocation.geolocation.latitude',
  'serviceRequest.finalLocation.geolocation.latitude.unit',
  'serviceRequest.finalLocation.geolocation.latitude.value',
  'serviceRequest.finalLocation.geolocation.longitude',
  'serviceRequest.finalLocation.geolocation.longitude.unit',
  'serviceRequest.finalLocation.geolocation.longitude.value',
  'serviceRequest.finalLocation.specialCharacteristics',
  'serviceRequest.finalLocation.specialCharacteristics.stringValue',
  'serviceRequest.finalLocation.specialCharacteristics.characteristicReference',
  'serviceRequest.finalLocation.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.finalLocation.specialCharacteristics.numericalValue',
  'serviceRequest.finalLocation.specialCharacteristics.numericalValue.unit',
  'serviceRequest.finalLocation.specialCharacteristics.numericalValue.value',
  'serviceRequest.finalLocation.specialInstructions',
  'serviceRequest.finalLocation.specialInstructions.description',
  'serviceRequest.finalLocation.specialInstructions.instructionCode',
  'serviceRequest.originLocation',
  'serviceRequest.originLocation.locationName',
  'serviceRequest.originLocation.locationType',
  'serviceRequest.originLocation.code',
  'serviceRequest.originLocation.address',
  'serviceRequest.originLocation.address.addressLocality',
  'serviceRequest.originLocation.address.addressRegion',
  'serviceRequest.originLocation.address.postOfficeBoxNumber',
  'serviceRequest.originLocation.address.postalCode',
  'serviceRequest.originLocation.address.addressLines',
  'serviceRequest.originLocation.address.addressCountry',
  'serviceRequest.originLocation.address.addressCountry.countryCode',
  'serviceRequest.originLocation.address.addressCountry.countryName',
  'serviceRequest.originLocation.contacts',
  'serviceRequest.originLocation.contacts.email',
  'serviceRequest.originLocation.contacts.telephone',
  'serviceRequest.originLocation.contacts.persons',
  'serviceRequest.originLocation.contacts.persons.additionalName',
  'serviceRequest.originLocation.contacts.persons.email',
  'serviceRequest.originLocation.contacts.persons.familyName',
  'serviceRequest.originLocation.contacts.persons.faxNumber',
  'serviceRequest.originLocation.contacts.persons.givenName',
  'serviceRequest.originLocation.contacts.persons.idCardNumber',
  'serviceRequest.originLocation.contacts.persons.telephone',
  'serviceRequest.originLocation.contacts.persons.party',
  'serviceRequest.originLocation.contacts.persons.party.commercialName',
  'serviceRequest.originLocation.contacts.persons.party.legalEntityName',
  'serviceRequest.originLocation.contacts.persons.party.address',
  'serviceRequest.originLocation.contacts.persons.party.address.addressLocality',
  'serviceRequest.originLocation.contacts.persons.party.address.addressRegion',
  'serviceRequest.originLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.originLocation.contacts.persons.party.address.postalCode',
  'serviceRequest.originLocation.contacts.persons.party.address.addressLines',
  'serviceRequest.originLocation.contacts.persons.party.address.addressCountry',
  'serviceRequest.originLocation.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.originLocation.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.originLocation.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.originLocation.contacts.role',
  'serviceRequest.originLocation.documents',
  'serviceRequest.originLocation.documents.cmsUri',
  'serviceRequest.originLocation.documents.documentName',
  'serviceRequest.originLocation.documents.format',
  'serviceRequest.originLocation.documents.isRequired',
  'serviceRequest.originLocation.documents.suppliedWithGoods',
  'serviceRequest.originLocation.documents.documentType',
  'serviceRequest.originLocation.documents.documentSubtype',
  'serviceRequest.originLocation.externalReferences',
  'serviceRequest.originLocation.externalReferences.description',
  'serviceRequest.originLocation.externalReferences.externalReferenceType',
  'serviceRequest.originLocation.externalReferences.reference',
  'serviceRequest.originLocation.geolocation',
  'serviceRequest.originLocation.geolocation.geolocationUnit',
  'serviceRequest.originLocation.geolocation.elevation',
  'serviceRequest.originLocation.geolocation.elevation.unit',
  'serviceRequest.originLocation.geolocation.elevation.value',
  'serviceRequest.originLocation.geolocation.latitude',
  'serviceRequest.originLocation.geolocation.latitude.unit',
  'serviceRequest.originLocation.geolocation.latitude.value',
  'serviceRequest.originLocation.geolocation.longitude',
  'serviceRequest.originLocation.geolocation.longitude.unit',
  'serviceRequest.originLocation.geolocation.longitude.value',
  'serviceRequest.originLocation.specialCharacteristics',
  'serviceRequest.originLocation.specialCharacteristics.stringValue',
  'serviceRequest.originLocation.specialCharacteristics.characteristicReference',
  'serviceRequest.originLocation.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.originLocation.specialCharacteristics.numericalValue',
  'serviceRequest.originLocation.specialCharacteristics.numericalValue.unit',
  'serviceRequest.originLocation.specialCharacteristics.numericalValue.value',
  'serviceRequest.originLocation.specialInstructions',
  'serviceRequest.originLocation.specialInstructions.description',
  'serviceRequest.originLocation.specialInstructions.instructionCode',
  'serviceRequest.parentActivities',
  'serviceRequest.parentActivities.uri',
  'serviceRequest.provider',
  'serviceRequest.provider.commercialName',
  'serviceRequest.provider.legalEntityName',
  'serviceRequest.provider.address',
  'serviceRequest.provider.address.addressLocality',
  'serviceRequest.provider.address.addressRegion',
  'serviceRequest.provider.address.postOfficeBoxNumber',
  'serviceRequest.provider.address.postalCode',
  'serviceRequest.provider.address.addressLines',
  'serviceRequest.provider.address.addressCountry',
  'serviceRequest.provider.address.addressCountry.countryCode',
  'serviceRequest.provider.address.addressCountry.countryName',
  'serviceRequest.provider.companyRegistrationIds',
  'serviceRequest.provider.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.provider.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.requestor',
  'serviceRequest.requestor.commercialName',
  'serviceRequest.requestor.legalEntityName',
  'serviceRequest.requestor.address',
  'serviceRequest.requestor.address.addressLocality',
  'serviceRequest.requestor.address.addressRegion',
  'serviceRequest.requestor.address.postOfficeBoxNumber',
  'serviceRequest.requestor.address.postalCode',
  'serviceRequest.requestor.address.addressLines',
  'serviceRequest.requestor.address.addressCountry',
  'serviceRequest.requestor.address.addressCountry.countryCode',
  'serviceRequest.requestor.address.addressCountry.countryName',
  'serviceRequest.requestor.companyRegistrationIds',
  'serviceRequest.requestor.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.requestor.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.saleOperations',
  'serviceRequest.saleOperations.isMandatory',
  'serviceRequest.saleOperations.isProposedByDefault',
  'serviceRequest.saleOperations.isSelected',
  'serviceRequest.saleOperations.operationDescription',
  'serviceRequest.saleOperations.operationName',
  'serviceRequest.saleOperations.operationCode',
  'serviceRequest.saleOperations.operationSubtype',
  'serviceRequest.saleOperations.operationType',
  'serviceRequest.saleOperations.amountExclTaxes',
  'serviceRequest.saleOperations.amountExclTaxes.unit',
  'serviceRequest.saleOperations.amountExclTaxes.value',
  'serviceRequest.saleOperations.amountInclTaxes',
  'serviceRequest.saleOperations.amountInclTaxes.unit',
  'serviceRequest.saleOperations.amountInclTaxes.value',
  'serviceRequest.saleOperations.requestedPrepaidAmount',
  'serviceRequest.saleOperations.requestedPrepaidAmount.unit',
  'serviceRequest.saleOperations.requestedPrepaidAmount.value',
  'serviceRequest.saleOperations.actualQuantity',
  'serviceRequest.saleOperations.actualQuantity.unit',
  'serviceRequest.saleOperations.actualQuantity.value',
  'serviceRequest.saleOperations.contacts',
  'serviceRequest.saleOperations.contacts.email',
  'serviceRequest.saleOperations.contacts.telephone',
  'serviceRequest.saleOperations.contacts.persons',
  'serviceRequest.saleOperations.contacts.persons.additionalName',
  'serviceRequest.saleOperations.contacts.persons.email',
  'serviceRequest.saleOperations.contacts.persons.familyName',
  'serviceRequest.saleOperations.contacts.persons.faxNumber',
  'serviceRequest.saleOperations.contacts.persons.givenName',
  'serviceRequest.saleOperations.contacts.persons.idCardNumber',
  'serviceRequest.saleOperations.contacts.persons.telephone',
  'serviceRequest.saleOperations.contacts.persons.party',
  'serviceRequest.saleOperations.contacts.persons.party.commercialName',
  'serviceRequest.saleOperations.contacts.persons.party.legalEntityName',
  'serviceRequest.saleOperations.contacts.persons.party.address',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressLocality',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressRegion',
  'serviceRequest.saleOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'serviceRequest.saleOperations.contacts.persons.party.address.postalCode',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressLines',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressCountry',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressCountry.countryCode',
  'serviceRequest.saleOperations.contacts.persons.party.address.addressCountry.countryName',
  'serviceRequest.saleOperations.contacts.persons.party.companyRegistrationIds',
  'serviceRequest.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.saleOperations.contacts.role',
  'serviceRequest.saleOperations.documents',
  'serviceRequest.saleOperations.documents.cmsUri',
  'serviceRequest.saleOperations.documents.documentName',
  'serviceRequest.saleOperations.documents.format',
  'serviceRequest.saleOperations.documents.isRequired',
  'serviceRequest.saleOperations.documents.suppliedWithGoods',
  'serviceRequest.saleOperations.documents.documentType',
  'serviceRequest.saleOperations.documents.documentSubtype',
  'serviceRequest.saleOperations.externalReferences',
  'serviceRequest.saleOperations.externalReferences.description',
  'serviceRequest.saleOperations.externalReferences.externalReferenceType',
  'serviceRequest.saleOperations.externalReferences.reference',
  'serviceRequest.saleOperations.operationInvoicingDetails',
  'serviceRequest.saleOperations.operationInvoicingDetails.invoiceLineId',
  'serviceRequest.saleOperations.operationInvoicingDetails.invoice',
  'serviceRequest.saleOperations.operationInvoicingDetails.invoice.uri',
  'serviceRequest.saleOperations.operationInvoicingDetails.quantity',
  'serviceRequest.saleOperations.operationInvoicingDetails.quantity.unit',
  'serviceRequest.saleOperations.operationInvoicingDetails.quantity.value',
  'serviceRequest.saleOperations.operationInvoicingDetails.totalPrice',
  'serviceRequest.saleOperations.operationInvoicingDetails.totalPrice.unit',
  'serviceRequest.saleOperations.operationInvoicingDetails.totalPrice.value',
  'serviceRequest.saleOperations.operationInvoicingDetails.unitPrice',
  'serviceRequest.saleOperations.operationInvoicingDetails.unitPrice.unit',
  'serviceRequest.saleOperations.operationInvoicingDetails.unitPrice.value',
  'serviceRequest.saleOperations.plannedQuantity',
  'serviceRequest.saleOperations.plannedQuantity.unit',
  'serviceRequest.saleOperations.plannedQuantity.value',
  'serviceRequest.saleOperations.requestedQuantity',
  'serviceRequest.saleOperations.requestedQuantity.unit',
  'serviceRequest.saleOperations.requestedQuantity.value',
  'serviceRequest.saleOperations.unitPrice',
  'serviceRequest.saleOperations.unitPrice.unit',
  'serviceRequest.saleOperations.unitPrice.value',
  'serviceRequest.saleOperations.specialCharacteristics',
  'serviceRequest.saleOperations.specialCharacteristics.stringValue',
  'serviceRequest.saleOperations.specialCharacteristics.characteristicReference',
  'serviceRequest.saleOperations.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.saleOperations.specialCharacteristics.numericalValue',
  'serviceRequest.saleOperations.specialCharacteristics.numericalValue.unit',
  'serviceRequest.saleOperations.specialCharacteristics.numericalValue.value',
  'serviceRequest.saleOperations.specialInstructions',
  'serviceRequest.saleOperations.specialInstructions.description',
  'serviceRequest.saleOperations.specialInstructions.instructionCode',
  'serviceRequest.service',
  'serviceRequest.service.uri',
  'serviceRequest.sla',
  'serviceRequest.sla.actualSLA',
  'serviceRequest.sla.plannedSLA',
  'serviceRequest.sla.requestedSLA',
  'serviceRequest.declaredValue',
  'serviceRequest.declaredValue.unit',
  'serviceRequest.declaredValue.value',
  'serviceRequest.specialCharacteristics',
  'serviceRequest.specialCharacteristics.stringValue',
  'serviceRequest.specialCharacteristics.characteristicReference',
  'serviceRequest.specialCharacteristics.specialCharacteristicType',
  'serviceRequest.specialCharacteristics.numericalValue',
  'serviceRequest.specialCharacteristics.numericalValue.unit',
  'serviceRequest.specialCharacteristics.numericalValue.value',
  'serviceRequest.specialInstructions',
  'serviceRequest.specialInstructions.description',
  'serviceRequest.specialInstructions.instructionCode',
  'serviceRequest.invoicedParty',
  'serviceRequest.invoicedParty.commercialName',
  'serviceRequest.invoicedParty.legalEntityName',
  'serviceRequest.invoicedParty.address',
  'serviceRequest.invoicedParty.address.addressLocality',
  'serviceRequest.invoicedParty.address.addressRegion',
  'serviceRequest.invoicedParty.address.postOfficeBoxNumber',
  'serviceRequest.invoicedParty.address.postalCode',
  'serviceRequest.invoicedParty.address.addressLines',
  'serviceRequest.invoicedParty.address.addressCountry',
  'serviceRequest.invoicedParty.address.addressCountry.countryCode',
  'serviceRequest.invoicedParty.address.addressCountry.countryName',
  'serviceRequest.invoicedParty.companyRegistrationIds',
  'serviceRequest.invoicedParty.companyRegistrationIds.companyRegistrationIdType',
  'serviceRequest.invoicedParty.companyRegistrationIds.companyRegistrationIdValue',
  'serviceRequest.id',
] as const;

/**
 * Field paths for Service
 * Total: 645 paths
 */
export const SERVICE_FIELD_PATHS = [
  'service.executionStatus',
  'service.invoiceStatus',
  'service.isDangerous',
  'service.productDescription',
  'service.serviceAgreementReference',
  'service.serviceDescription',
  'service.serviceName',
  'service.serviceNature',
  'service.serviceStatus',
  'service.serviceSubtype',
  'service.serviceType',
  'service.startLocation',
  'service.startLocation.isAppointmentRequested',
  'service.startLocation.actions',
  'service.startLocation.actions.actionDateTime',
  'service.startLocation.actions.actionName',
  'service.startLocation.actions.sequenceNumber',
  'service.startLocation.actions.actionState',
  'service.startLocation.actions.actionType',
  'service.startLocation.actions.actionSubtype',
  'service.startLocation.actions.compositionMovements',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'service.startLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'service.startLocation.actions.compositionMovements.containedObjects',
  'service.startLocation.actions.compositionMovements.container',
  'service.startLocation.actions.compositionMovements.container.uri',
  'service.startLocation.actions.sealNumber',
  'service.startLocation.actions.sealedMaterialMean',
  'service.startLocation.actions.sealedMaterialMean.uri',
  'service.startLocation.actions.labelAssociations',
  'service.startLocation.actions.labelAssociations.labelId',
  'service.startLocation.actions.labelAssociations.labeledObject',
  'service.startLocation.location',
  'service.startLocation.location.locationName',
  'service.startLocation.location.locationType',
  'service.startLocation.location.code',
  'service.startLocation.location.address',
  'service.startLocation.location.address.addressLocality',
  'service.startLocation.location.address.addressRegion',
  'service.startLocation.location.address.postOfficeBoxNumber',
  'service.startLocation.location.address.postalCode',
  'service.startLocation.location.address.addressLines',
  'service.startLocation.location.address.addressCountry',
  'service.startLocation.location.address.addressCountry.countryCode',
  'service.startLocation.location.address.addressCountry.countryName',
  'service.startLocation.location.contacts',
  'service.startLocation.location.contacts.email',
  'service.startLocation.location.contacts.telephone',
  'service.startLocation.location.contacts.persons',
  'service.startLocation.location.contacts.persons.additionalName',
  'service.startLocation.location.contacts.persons.email',
  'service.startLocation.location.contacts.persons.familyName',
  'service.startLocation.location.contacts.persons.faxNumber',
  'service.startLocation.location.contacts.persons.givenName',
  'service.startLocation.location.contacts.persons.idCardNumber',
  'service.startLocation.location.contacts.persons.telephone',
  'service.startLocation.location.contacts.persons.party',
  'service.startLocation.location.contacts.persons.party.commercialName',
  'service.startLocation.location.contacts.persons.party.legalEntityName',
  'service.startLocation.location.contacts.persons.party.address',
  'service.startLocation.location.contacts.persons.party.address.addressLocality',
  'service.startLocation.location.contacts.persons.party.address.addressRegion',
  'service.startLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'service.startLocation.location.contacts.persons.party.address.postalCode',
  'service.startLocation.location.contacts.persons.party.address.addressLines',
  'service.startLocation.location.contacts.persons.party.address.addressCountry',
  'service.startLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'service.startLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'service.startLocation.location.contacts.persons.party.companyRegistrationIds',
  'service.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.startLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.startLocation.location.contacts.role',
  'service.startLocation.location.documents',
  'service.startLocation.location.documents.cmsUri',
  'service.startLocation.location.documents.documentName',
  'service.startLocation.location.documents.format',
  'service.startLocation.location.documents.isRequired',
  'service.startLocation.location.documents.suppliedWithGoods',
  'service.startLocation.location.documents.documentType',
  'service.startLocation.location.documents.documentSubtype',
  'service.startLocation.location.externalReferences',
  'service.startLocation.location.externalReferences.description',
  'service.startLocation.location.externalReferences.externalReferenceType',
  'service.startLocation.location.externalReferences.reference',
  'service.startLocation.location.geolocation',
  'service.startLocation.location.geolocation.geolocationUnit',
  'service.startLocation.location.geolocation.elevation',
  'service.startLocation.location.geolocation.elevation.unit',
  'service.startLocation.location.geolocation.elevation.value',
  'service.startLocation.location.geolocation.latitude',
  'service.startLocation.location.geolocation.latitude.unit',
  'service.startLocation.location.geolocation.latitude.value',
  'service.startLocation.location.geolocation.longitude',
  'service.startLocation.location.geolocation.longitude.unit',
  'service.startLocation.location.geolocation.longitude.value',
  'service.startLocation.location.specialCharacteristics',
  'service.startLocation.location.specialCharacteristics.stringValue',
  'service.startLocation.location.specialCharacteristics.characteristicReference',
  'service.startLocation.location.specialCharacteristics.specialCharacteristicType',
  'service.startLocation.location.specialCharacteristics.numericalValue',
  'service.startLocation.location.specialCharacteristics.numericalValue.unit',
  'service.startLocation.location.specialCharacteristics.numericalValue.value',
  'service.startLocation.location.specialInstructions',
  'service.startLocation.location.specialInstructions.description',
  'service.startLocation.location.specialInstructions.instructionCode',
  'service.startLocation.appointmentTimeRange',
  'service.startLocation.appointmentTimeRange.earliestDateTime',
  'service.startLocation.appointmentTimeRange.latestDateTime',
  'service.startLocation.actualStartDateTime',
  'service.startLocation.actualEndDateTime',
  'service.startLocation.requestedStartTimeRange',
  'service.startLocation.requestedStartTimeRange.earliestDateTime',
  'service.startLocation.requestedStartTimeRange.latestDateTime',
  'service.startLocation.requestedEndTimeRange',
  'service.startLocation.requestedEndTimeRange.earliestDateTime',
  'service.startLocation.requestedEndTimeRange.latestDateTime',
  'service.startLocation.plannedStartTimeRange',
  'service.startLocation.plannedStartTimeRange.earliestDateTime',
  'service.startLocation.plannedStartTimeRange.latestDateTime',
  'service.startLocation.plannedEndTimeRange',
  'service.startLocation.plannedEndTimeRange.earliestDateTime',
  'service.startLocation.plannedEndTimeRange.latestDateTime',
  'service.endLocation',
  'service.endLocation.isAppointmentRequested',
  'service.endLocation.actions',
  'service.endLocation.actions.actionDateTime',
  'service.endLocation.actions.actionName',
  'service.endLocation.actions.sequenceNumber',
  'service.endLocation.actions.actionState',
  'service.endLocation.actions.actionType',
  'service.endLocation.actions.actionSubtype',
  'service.endLocation.actions.compositionMovements',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.codePackaging',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerSubtype',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.containerType',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.height.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.length.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.volume.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.dimensions.width.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.product',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.product.uri',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.specialRegulationType',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productClass',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productUNCode',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.specialRegulations.productPackingGroup',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.quantity.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.weight.value',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.unit',
  'service.endLocation.actions.compositionMovements.containedBatchesOfGoods.declaredValue.value',
  'service.endLocation.actions.compositionMovements.containedObjects',
  'service.endLocation.actions.compositionMovements.container',
  'service.endLocation.actions.compositionMovements.container.uri',
  'service.endLocation.actions.sealNumber',
  'service.endLocation.actions.sealedMaterialMean',
  'service.endLocation.actions.sealedMaterialMean.uri',
  'service.endLocation.actions.labelAssociations',
  'service.endLocation.actions.labelAssociations.labelId',
  'service.endLocation.actions.labelAssociations.labeledObject',
  'service.endLocation.location',
  'service.endLocation.location.locationName',
  'service.endLocation.location.locationType',
  'service.endLocation.location.code',
  'service.endLocation.location.address',
  'service.endLocation.location.address.addressLocality',
  'service.endLocation.location.address.addressRegion',
  'service.endLocation.location.address.postOfficeBoxNumber',
  'service.endLocation.location.address.postalCode',
  'service.endLocation.location.address.addressLines',
  'service.endLocation.location.address.addressCountry',
  'service.endLocation.location.address.addressCountry.countryCode',
  'service.endLocation.location.address.addressCountry.countryName',
  'service.endLocation.location.contacts',
  'service.endLocation.location.contacts.email',
  'service.endLocation.location.contacts.telephone',
  'service.endLocation.location.contacts.persons',
  'service.endLocation.location.contacts.persons.additionalName',
  'service.endLocation.location.contacts.persons.email',
  'service.endLocation.location.contacts.persons.familyName',
  'service.endLocation.location.contacts.persons.faxNumber',
  'service.endLocation.location.contacts.persons.givenName',
  'service.endLocation.location.contacts.persons.idCardNumber',
  'service.endLocation.location.contacts.persons.telephone',
  'service.endLocation.location.contacts.persons.party',
  'service.endLocation.location.contacts.persons.party.commercialName',
  'service.endLocation.location.contacts.persons.party.legalEntityName',
  'service.endLocation.location.contacts.persons.party.address',
  'service.endLocation.location.contacts.persons.party.address.addressLocality',
  'service.endLocation.location.contacts.persons.party.address.addressRegion',
  'service.endLocation.location.contacts.persons.party.address.postOfficeBoxNumber',
  'service.endLocation.location.contacts.persons.party.address.postalCode',
  'service.endLocation.location.contacts.persons.party.address.addressLines',
  'service.endLocation.location.contacts.persons.party.address.addressCountry',
  'service.endLocation.location.contacts.persons.party.address.addressCountry.countryCode',
  'service.endLocation.location.contacts.persons.party.address.addressCountry.countryName',
  'service.endLocation.location.contacts.persons.party.companyRegistrationIds',
  'service.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.endLocation.location.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.endLocation.location.contacts.role',
  'service.endLocation.location.documents',
  'service.endLocation.location.documents.cmsUri',
  'service.endLocation.location.documents.documentName',
  'service.endLocation.location.documents.format',
  'service.endLocation.location.documents.isRequired',
  'service.endLocation.location.documents.suppliedWithGoods',
  'service.endLocation.location.documents.documentType',
  'service.endLocation.location.documents.documentSubtype',
  'service.endLocation.location.externalReferences',
  'service.endLocation.location.externalReferences.description',
  'service.endLocation.location.externalReferences.externalReferenceType',
  'service.endLocation.location.externalReferences.reference',
  'service.endLocation.location.geolocation',
  'service.endLocation.location.geolocation.geolocationUnit',
  'service.endLocation.location.geolocation.elevation',
  'service.endLocation.location.geolocation.elevation.unit',
  'service.endLocation.location.geolocation.elevation.value',
  'service.endLocation.location.geolocation.latitude',
  'service.endLocation.location.geolocation.latitude.unit',
  'service.endLocation.location.geolocation.latitude.value',
  'service.endLocation.location.geolocation.longitude',
  'service.endLocation.location.geolocation.longitude.unit',
  'service.endLocation.location.geolocation.longitude.value',
  'service.endLocation.location.specialCharacteristics',
  'service.endLocation.location.specialCharacteristics.stringValue',
  'service.endLocation.location.specialCharacteristics.characteristicReference',
  'service.endLocation.location.specialCharacteristics.specialCharacteristicType',
  'service.endLocation.location.specialCharacteristics.numericalValue',
  'service.endLocation.location.specialCharacteristics.numericalValue.unit',
  'service.endLocation.location.specialCharacteristics.numericalValue.value',
  'service.endLocation.location.specialInstructions',
  'service.endLocation.location.specialInstructions.description',
  'service.endLocation.location.specialInstructions.instructionCode',
  'service.endLocation.appointmentTimeRange',
  'service.endLocation.appointmentTimeRange.earliestDateTime',
  'service.endLocation.appointmentTimeRange.latestDateTime',
  'service.endLocation.actualStartDateTime',
  'service.endLocation.actualEndDateTime',
  'service.endLocation.requestedStartTimeRange',
  'service.endLocation.requestedStartTimeRange.earliestDateTime',
  'service.endLocation.requestedStartTimeRange.latestDateTime',
  'service.endLocation.requestedEndTimeRange',
  'service.endLocation.requestedEndTimeRange.earliestDateTime',
  'service.endLocation.requestedEndTimeRange.latestDateTime',
  'service.endLocation.plannedStartTimeRange',
  'service.endLocation.plannedStartTimeRange.earliestDateTime',
  'service.endLocation.plannedStartTimeRange.latestDateTime',
  'service.endLocation.plannedEndTimeRange',
  'service.endLocation.plannedEndTimeRange.earliestDateTime',
  'service.endLocation.plannedEndTimeRange.latestDateTime',
  'service.scheduledActivities',
  'service.scheduledActivities.uri',
  'service.consignments',
  'service.consignments.uri',
  'service.contacts',
  'service.contacts.email',
  'service.contacts.telephone',
  'service.contacts.persons',
  'service.contacts.persons.additionalName',
  'service.contacts.persons.email',
  'service.contacts.persons.familyName',
  'service.contacts.persons.faxNumber',
  'service.contacts.persons.givenName',
  'service.contacts.persons.idCardNumber',
  'service.contacts.persons.telephone',
  'service.contacts.persons.party',
  'service.contacts.persons.party.commercialName',
  'service.contacts.persons.party.legalEntityName',
  'service.contacts.persons.party.address',
  'service.contacts.persons.party.address.addressLocality',
  'service.contacts.persons.party.address.addressRegion',
  'service.contacts.persons.party.address.postOfficeBoxNumber',
  'service.contacts.persons.party.address.postalCode',
  'service.contacts.persons.party.address.addressLines',
  'service.contacts.persons.party.address.addressCountry',
  'service.contacts.persons.party.address.addressCountry.countryCode',
  'service.contacts.persons.party.address.addressCountry.countryName',
  'service.contacts.persons.party.companyRegistrationIds',
  'service.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.contacts.role',
  'service.documents',
  'service.documents.cmsUri',
  'service.documents.documentName',
  'service.documents.format',
  'service.documents.isRequired',
  'service.documents.suppliedWithGoods',
  'service.documents.documentType',
  'service.documents.documentSubtype',
  'service.externalReferences',
  'service.externalReferences.description',
  'service.externalReferences.externalReferenceType',
  'service.externalReferences.reference',
  'service.finalLocation',
  'service.finalLocation.locationName',
  'service.finalLocation.locationType',
  'service.finalLocation.code',
  'service.finalLocation.address',
  'service.finalLocation.address.addressLocality',
  'service.finalLocation.address.addressRegion',
  'service.finalLocation.address.postOfficeBoxNumber',
  'service.finalLocation.address.postalCode',
  'service.finalLocation.address.addressLines',
  'service.finalLocation.address.addressCountry',
  'service.finalLocation.address.addressCountry.countryCode',
  'service.finalLocation.address.addressCountry.countryName',
  'service.finalLocation.contacts',
  'service.finalLocation.contacts.email',
  'service.finalLocation.contacts.telephone',
  'service.finalLocation.contacts.persons',
  'service.finalLocation.contacts.persons.additionalName',
  'service.finalLocation.contacts.persons.email',
  'service.finalLocation.contacts.persons.familyName',
  'service.finalLocation.contacts.persons.faxNumber',
  'service.finalLocation.contacts.persons.givenName',
  'service.finalLocation.contacts.persons.idCardNumber',
  'service.finalLocation.contacts.persons.telephone',
  'service.finalLocation.contacts.persons.party',
  'service.finalLocation.contacts.persons.party.commercialName',
  'service.finalLocation.contacts.persons.party.legalEntityName',
  'service.finalLocation.contacts.persons.party.address',
  'service.finalLocation.contacts.persons.party.address.addressLocality',
  'service.finalLocation.contacts.persons.party.address.addressRegion',
  'service.finalLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'service.finalLocation.contacts.persons.party.address.postalCode',
  'service.finalLocation.contacts.persons.party.address.addressLines',
  'service.finalLocation.contacts.persons.party.address.addressCountry',
  'service.finalLocation.contacts.persons.party.address.addressCountry.countryCode',
  'service.finalLocation.contacts.persons.party.address.addressCountry.countryName',
  'service.finalLocation.contacts.persons.party.companyRegistrationIds',
  'service.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.finalLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.finalLocation.contacts.role',
  'service.finalLocation.documents',
  'service.finalLocation.documents.cmsUri',
  'service.finalLocation.documents.documentName',
  'service.finalLocation.documents.format',
  'service.finalLocation.documents.isRequired',
  'service.finalLocation.documents.suppliedWithGoods',
  'service.finalLocation.documents.documentType',
  'service.finalLocation.documents.documentSubtype',
  'service.finalLocation.externalReferences',
  'service.finalLocation.externalReferences.description',
  'service.finalLocation.externalReferences.externalReferenceType',
  'service.finalLocation.externalReferences.reference',
  'service.finalLocation.geolocation',
  'service.finalLocation.geolocation.geolocationUnit',
  'service.finalLocation.geolocation.elevation',
  'service.finalLocation.geolocation.elevation.unit',
  'service.finalLocation.geolocation.elevation.value',
  'service.finalLocation.geolocation.latitude',
  'service.finalLocation.geolocation.latitude.unit',
  'service.finalLocation.geolocation.latitude.value',
  'service.finalLocation.geolocation.longitude',
  'service.finalLocation.geolocation.longitude.unit',
  'service.finalLocation.geolocation.longitude.value',
  'service.finalLocation.specialCharacteristics',
  'service.finalLocation.specialCharacteristics.stringValue',
  'service.finalLocation.specialCharacteristics.characteristicReference',
  'service.finalLocation.specialCharacteristics.specialCharacteristicType',
  'service.finalLocation.specialCharacteristics.numericalValue',
  'service.finalLocation.specialCharacteristics.numericalValue.unit',
  'service.finalLocation.specialCharacteristics.numericalValue.value',
  'service.finalLocation.specialInstructions',
  'service.finalLocation.specialInstructions.description',
  'service.finalLocation.specialInstructions.instructionCode',
  'service.originLocation',
  'service.originLocation.locationName',
  'service.originLocation.locationType',
  'service.originLocation.code',
  'service.originLocation.address',
  'service.originLocation.address.addressLocality',
  'service.originLocation.address.addressRegion',
  'service.originLocation.address.postOfficeBoxNumber',
  'service.originLocation.address.postalCode',
  'service.originLocation.address.addressLines',
  'service.originLocation.address.addressCountry',
  'service.originLocation.address.addressCountry.countryCode',
  'service.originLocation.address.addressCountry.countryName',
  'service.originLocation.contacts',
  'service.originLocation.contacts.email',
  'service.originLocation.contacts.telephone',
  'service.originLocation.contacts.persons',
  'service.originLocation.contacts.persons.additionalName',
  'service.originLocation.contacts.persons.email',
  'service.originLocation.contacts.persons.familyName',
  'service.originLocation.contacts.persons.faxNumber',
  'service.originLocation.contacts.persons.givenName',
  'service.originLocation.contacts.persons.idCardNumber',
  'service.originLocation.contacts.persons.telephone',
  'service.originLocation.contacts.persons.party',
  'service.originLocation.contacts.persons.party.commercialName',
  'service.originLocation.contacts.persons.party.legalEntityName',
  'service.originLocation.contacts.persons.party.address',
  'service.originLocation.contacts.persons.party.address.addressLocality',
  'service.originLocation.contacts.persons.party.address.addressRegion',
  'service.originLocation.contacts.persons.party.address.postOfficeBoxNumber',
  'service.originLocation.contacts.persons.party.address.postalCode',
  'service.originLocation.contacts.persons.party.address.addressLines',
  'service.originLocation.contacts.persons.party.address.addressCountry',
  'service.originLocation.contacts.persons.party.address.addressCountry.countryCode',
  'service.originLocation.contacts.persons.party.address.addressCountry.countryName',
  'service.originLocation.contacts.persons.party.companyRegistrationIds',
  'service.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.originLocation.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.originLocation.contacts.role',
  'service.originLocation.documents',
  'service.originLocation.documents.cmsUri',
  'service.originLocation.documents.documentName',
  'service.originLocation.documents.format',
  'service.originLocation.documents.isRequired',
  'service.originLocation.documents.suppliedWithGoods',
  'service.originLocation.documents.documentType',
  'service.originLocation.documents.documentSubtype',
  'service.originLocation.externalReferences',
  'service.originLocation.externalReferences.description',
  'service.originLocation.externalReferences.externalReferenceType',
  'service.originLocation.externalReferences.reference',
  'service.originLocation.geolocation',
  'service.originLocation.geolocation.geolocationUnit',
  'service.originLocation.geolocation.elevation',
  'service.originLocation.geolocation.elevation.unit',
  'service.originLocation.geolocation.elevation.value',
  'service.originLocation.geolocation.latitude',
  'service.originLocation.geolocation.latitude.unit',
  'service.originLocation.geolocation.latitude.value',
  'service.originLocation.geolocation.longitude',
  'service.originLocation.geolocation.longitude.unit',
  'service.originLocation.geolocation.longitude.value',
  'service.originLocation.specialCharacteristics',
  'service.originLocation.specialCharacteristics.stringValue',
  'service.originLocation.specialCharacteristics.characteristicReference',
  'service.originLocation.specialCharacteristics.specialCharacteristicType',
  'service.originLocation.specialCharacteristics.numericalValue',
  'service.originLocation.specialCharacteristics.numericalValue.unit',
  'service.originLocation.specialCharacteristics.numericalValue.value',
  'service.originLocation.specialInstructions',
  'service.originLocation.specialInstructions.description',
  'service.originLocation.specialInstructions.instructionCode',
  'service.serviceRequests',
  'service.serviceRequests.uri',
  'service.provider',
  'service.provider.commercialName',
  'service.provider.legalEntityName',
  'service.provider.address',
  'service.provider.address.addressLocality',
  'service.provider.address.addressRegion',
  'service.provider.address.postOfficeBoxNumber',
  'service.provider.address.postalCode',
  'service.provider.address.addressLines',
  'service.provider.address.addressCountry',
  'service.provider.address.addressCountry.countryCode',
  'service.provider.address.addressCountry.countryName',
  'service.provider.companyRegistrationIds',
  'service.provider.companyRegistrationIds.companyRegistrationIdType',
  'service.provider.companyRegistrationIds.companyRegistrationIdValue',
  'service.requestor',
  'service.requestor.commercialName',
  'service.requestor.legalEntityName',
  'service.requestor.address',
  'service.requestor.address.addressLocality',
  'service.requestor.address.addressRegion',
  'service.requestor.address.postOfficeBoxNumber',
  'service.requestor.address.postalCode',
  'service.requestor.address.addressLines',
  'service.requestor.address.addressCountry',
  'service.requestor.address.addressCountry.countryCode',
  'service.requestor.address.addressCountry.countryName',
  'service.requestor.companyRegistrationIds',
  'service.requestor.companyRegistrationIds.companyRegistrationIdType',
  'service.requestor.companyRegistrationIds.companyRegistrationIdValue',
  'service.saleOperations',
  'service.saleOperations.isMandatory',
  'service.saleOperations.isProposedByDefault',
  'service.saleOperations.isSelected',
  'service.saleOperations.operationDescription',
  'service.saleOperations.operationName',
  'service.saleOperations.operationCode',
  'service.saleOperations.operationSubtype',
  'service.saleOperations.operationType',
  'service.saleOperations.amountExclTaxes',
  'service.saleOperations.amountExclTaxes.unit',
  'service.saleOperations.amountExclTaxes.value',
  'service.saleOperations.amountInclTaxes',
  'service.saleOperations.amountInclTaxes.unit',
  'service.saleOperations.amountInclTaxes.value',
  'service.saleOperations.requestedPrepaidAmount',
  'service.saleOperations.requestedPrepaidAmount.unit',
  'service.saleOperations.requestedPrepaidAmount.value',
  'service.saleOperations.actualQuantity',
  'service.saleOperations.actualQuantity.unit',
  'service.saleOperations.actualQuantity.value',
  'service.saleOperations.contacts',
  'service.saleOperations.contacts.email',
  'service.saleOperations.contacts.telephone',
  'service.saleOperations.contacts.persons',
  'service.saleOperations.contacts.persons.additionalName',
  'service.saleOperations.contacts.persons.email',
  'service.saleOperations.contacts.persons.familyName',
  'service.saleOperations.contacts.persons.faxNumber',
  'service.saleOperations.contacts.persons.givenName',
  'service.saleOperations.contacts.persons.idCardNumber',
  'service.saleOperations.contacts.persons.telephone',
  'service.saleOperations.contacts.persons.party',
  'service.saleOperations.contacts.persons.party.commercialName',
  'service.saleOperations.contacts.persons.party.legalEntityName',
  'service.saleOperations.contacts.persons.party.address',
  'service.saleOperations.contacts.persons.party.address.addressLocality',
  'service.saleOperations.contacts.persons.party.address.addressRegion',
  'service.saleOperations.contacts.persons.party.address.postOfficeBoxNumber',
  'service.saleOperations.contacts.persons.party.address.postalCode',
  'service.saleOperations.contacts.persons.party.address.addressLines',
  'service.saleOperations.contacts.persons.party.address.addressCountry',
  'service.saleOperations.contacts.persons.party.address.addressCountry.countryCode',
  'service.saleOperations.contacts.persons.party.address.addressCountry.countryName',
  'service.saleOperations.contacts.persons.party.companyRegistrationIds',
  'service.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdType',
  'service.saleOperations.contacts.persons.party.companyRegistrationIds.companyRegistrationIdValue',
  'service.saleOperations.contacts.role',
  'service.saleOperations.documents',
  'service.saleOperations.documents.cmsUri',
  'service.saleOperations.documents.documentName',
  'service.saleOperations.documents.format',
  'service.saleOperations.documents.isRequired',
  'service.saleOperations.documents.suppliedWithGoods',
  'service.saleOperations.documents.documentType',
  'service.saleOperations.documents.documentSubtype',
  'service.saleOperations.externalReferences',
  'service.saleOperations.externalReferences.description',
  'service.saleOperations.externalReferences.externalReferenceType',
  'service.saleOperations.externalReferences.reference',
  'service.saleOperations.operationInvoicingDetails',
  'service.saleOperations.operationInvoicingDetails.invoiceLineId',
  'service.saleOperations.operationInvoicingDetails.invoice',
  'service.saleOperations.operationInvoicingDetails.invoice.uri',
  'service.saleOperations.operationInvoicingDetails.quantity',
  'service.saleOperations.operationInvoicingDetails.quantity.unit',
  'service.saleOperations.operationInvoicingDetails.quantity.value',
  'service.saleOperations.operationInvoicingDetails.totalPrice',
  'service.saleOperations.operationInvoicingDetails.totalPrice.unit',
  'service.saleOperations.operationInvoicingDetails.totalPrice.value',
  'service.saleOperations.operationInvoicingDetails.unitPrice',
  'service.saleOperations.operationInvoicingDetails.unitPrice.unit',
  'service.saleOperations.operationInvoicingDetails.unitPrice.value',
  'service.saleOperations.plannedQuantity',
  'service.saleOperations.plannedQuantity.unit',
  'service.saleOperations.plannedQuantity.value',
  'service.saleOperations.requestedQuantity',
  'service.saleOperations.requestedQuantity.unit',
  'service.saleOperations.requestedQuantity.value',
  'service.saleOperations.unitPrice',
  'service.saleOperations.unitPrice.unit',
  'service.saleOperations.unitPrice.value',
  'service.saleOperations.specialCharacteristics',
  'service.saleOperations.specialCharacteristics.stringValue',
  'service.saleOperations.specialCharacteristics.characteristicReference',
  'service.saleOperations.specialCharacteristics.specialCharacteristicType',
  'service.saleOperations.specialCharacteristics.numericalValue',
  'service.saleOperations.specialCharacteristics.numericalValue.unit',
  'service.saleOperations.specialCharacteristics.numericalValue.value',
  'service.saleOperations.specialInstructions',
  'service.saleOperations.specialInstructions.description',
  'service.saleOperations.specialInstructions.instructionCode',
  'service.sla',
  'service.sla.actualSLA',
  'service.sla.plannedSLA',
  'service.sla.requestedSLA',
  'service.specialCharacteristics',
  'service.specialCharacteristics.stringValue',
  'service.specialCharacteristics.characteristicReference',
  'service.specialCharacteristics.specialCharacteristicType',
  'service.specialCharacteristics.numericalValue',
  'service.specialCharacteristics.numericalValue.unit',
  'service.specialCharacteristics.numericalValue.value',
  'service.specialInstructions',
  'service.specialInstructions.description',
  'service.specialInstructions.instructionCode',
  'service.totalOperationAmount',
  'service.totalOperationAmount.unit',
  'service.totalOperationAmount.value',
  'service.declaredValue',
  'service.declaredValue.unit',
  'service.declaredValue.value',
  'service.invoicedParty',
  'service.invoicedParty.commercialName',
  'service.invoicedParty.legalEntityName',
  'service.invoicedParty.address',
  'service.invoicedParty.address.addressLocality',
  'service.invoicedParty.address.addressRegion',
  'service.invoicedParty.address.postOfficeBoxNumber',
  'service.invoicedParty.address.postalCode',
  'service.invoicedParty.address.addressLines',
  'service.invoicedParty.address.addressCountry',
  'service.invoicedParty.address.addressCountry.countryCode',
  'service.invoicedParty.address.addressCountry.countryName',
  'service.invoicedParty.companyRegistrationIds',
  'service.invoicedParty.companyRegistrationIds.companyRegistrationIdType',
  'service.invoicedParty.companyRegistrationIds.companyRegistrationIdValue',
  'service.incoterm',
  'service.id',
] as const;

/**
 * Common metadata fields (available on all logistics objects)
 */
export const METADATA_FIELD_PATHS = [
  'lo.createdAt',
  'lo.updatedAt',
  'lo.createdBy',
  'lo.updatedBy',
] as const;

/**
 * All field paths combined
 */
export const ALL_FIELD_PATHS = [
  ...ACTIVITY_FIELD_PATHS,
  ...CONSIGNMENT_FIELD_PATHS,
  ...CUSTOMER_ORDER_FIELD_PATHS,
  ...HUMAN_MEAN_FIELD_PATHS,
  ...INVOICING_DOCUMENT_FIELD_PATHS,
  ...ITEM_FIELD_PATHS,
  ...MATERIAL_MEAN_FIELD_PATHS,
  ...PIECE_FIELD_PATHS,
  ...PRODUCT_FIELD_PATHS,
  ...QUOTATION_REQUEST_FIELD_PATHS,
  ...QUOTATION_FIELD_PATHS,
  ...SERVICE_REQUEST_FIELD_PATHS,
  ...SERVICE_FIELD_PATHS,
  ...METADATA_FIELD_PATHS,
] as const;

/**
 * Get field paths for a specific logistics object type
 */
export function getFieldPathsForType(
  type: 'activity' | 'consignment' | 'customer-order' | 'human-mean' | 'invoicing-document' | 'item' | 'material-mean' | 'piece' | 'product' | 'quotation-request' | 'quotation' | 'service-request' | 'service' | 'all'
): readonly string[] {
  switch (type) {
    case 'activity':
      return [...ACTIVITY_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'consignment':
      return [...CONSIGNMENT_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'customer-order':
      return [...CUSTOMER_ORDER_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'human-mean':
      return [...HUMAN_MEAN_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'invoicing-document':
      return [...INVOICING_DOCUMENT_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'item':
      return [...ITEM_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'material-mean':
      return [...MATERIAL_MEAN_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'piece':
      return [...PIECE_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'product':
      return [...PRODUCT_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'quotation-request':
      return [...QUOTATION_REQUEST_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'quotation':
      return [...QUOTATION_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'service-request':
      return [...SERVICE_REQUEST_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'service':
      return [...SERVICE_FIELD_PATHS, ...METADATA_FIELD_PATHS];
    case 'all':
    default:
      return ALL_FIELD_PATHS;
  }
}

export type FieldPathString = typeof ALL_FIELD_PATHS[number];
